import { paymentGateWayService } from 'src/app/services/payment/paymentGateway.service';
import { Component, OnInit, OnDestroy, Input, TemplateRef, ViewChild, Output, EventEmitter, ElementRef, SimpleChanges, Renderer2, HostListener } from '@angular/core';
import { IFacilityCreditCard, IFacilityInfoACH, IGetPermissionMandatoryField, IPaymentMode, IRCMStatus, ITwoDigitDecimalInput } from '../interface';
import { PaymentService } from 'src/app/services/payment.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { EPaymentOrigin, EApprovalsDMRM, ELOV_TransactionTypes, EOpenEdgeSessionStates, ECreditCards, EPaymentGateway, EPaymentModes, EPaymentTransactionType, EEdgeExpressResultCode, EACHCheckResultCode, EOpenEdgeResponseCode, EEdgeExpressECIType, EACHAccountType, EUserFunctions, ECountries } from '../enum';
import { AbstractControl, FormControl, NgForm, Validators } from '@angular/forms';
import { FacilityService } from 'src/app/services/facility.service';
import { GeneralService } from 'src/app/services/general.service';
import { IDeviceSetting, IPaymentGatewayModel } from '../interface2';
import { environment } from 'src/environments/environment';
import { Observable, interval } from 'rxjs';
import { ProspectService } from 'src/app/services/operations/prospects.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CommonMethodService } from '../common-method.service';
import { PayFieldsSdkLoaderService } from '../payfields-sdk-loader.service';
import { FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';

declare var Stripe: any;
declare var GlobalPayments: any;

@Component({
    selector: 'app-refund',
    templateUrl: './refund.component.html',
    styleUrls: ['./refund.component.scss'],
    standalone: false
})
export class RefundComponent implements OnInit, OnDestroy {
  stripe: any;
  cardElement: any;
  element: any;
  addressElement : any;
  @Output() merchReturnSendApproval: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('RefundLimitModal', { static: true }) public RefundLimitModal: TemplateRef<any>;
  @Input() merchandiseSaleId = 0;
  @Input() Restrictiononcheckpayment: boolean = false;
  @Input() autoPayInfo;
  @Input() processRefund: any;
  @Input() refundId: number;
  @Input() isDebitCard: boolean = false;
  @Input() ccTransDate: any;
  @Input() apiResponse: any;
  @ViewChild('paymentSuccess', { static: true }) aftePay: TemplateRef<any>;
  @ViewChild('skipRefund', { static: true }) skipRefundPopUp: TemplateRef<any>;
  @ViewChild('manualAuthorization', { static: true }) offlinePay: TemplateRef<any>;
  @ViewChild('selectDevicePopup', { static: true }) public selectDevicePopup: TemplateRef<any>;
  @ViewChild('StripeRefund', { static: false }) StripeRefund: TemplateRef<any>;
  @ViewChild('CNPIFrame', { static: false }) iframe: ElementRef;
  @ViewChild('manualAuthForm', { static: true }) manualAuthForm: NgForm;
  @ViewChild('ACHIFrame', { static: false }) iframeAch: ElementRef;
  @Output() refundData: EventEmitter<any> = new EventEmitter<any>();
  @Output() isCancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() afterRefund: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitLoop: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('achManualAuthorization', { static: true }) achOfflinePay: TemplateRef<any>;
  @ViewChild('achManualAuthForm', { static: true }) achManualAuthForm: NgForm;
  private paymentGetCCTStatusInterval = environment.paymentGetCCTStatusInterval;
  private paymentMaxWaitTime = environment.paymentMaxWaitTime;
  private defaultCountryId = environment.defaultCountryId;
  private tdLocalHostArchitectureFacilities = environment.tdLocalHostArchitectureFacilities;
  private enableNewPaymentArchitecture = environment.enableNewPaymentArchitecture;
  EApprovalsDMRM = EApprovalsDMRM;
  ValidManualCardMonth = false;
  stripePublishableKey = '';
  StripeUnifiedAccountId = '';
  manualAuthAmountPaid = 0;
  refundTable = [];
  refundCount = 0;
  totalAmount;
  remainingAmount;
  currentPayModeId = 0;
  modalRefStripeRefund: BsModalRef;
  payModes: IPaymentMode[];
  defaultmode: number;
  payModalRef: BsModalRef;
  modalRefSelectDevice: BsModalRef;
  skipModalRef: BsModalRef;
  payStatus: string;
  currentPayId: any;
  paymentSuccessFul: boolean;
  finalPayModel: any;
  tillNowPaid = 0;
  showPrintEmailRcpt: boolean;
  loaderIcon: Promise<boolean>;
  paymentFailReason: any;
  urlSafe: SafeResourceUrl;
  achUrlSafe: SafeResourceUrl;
  showIFrame = false;
  showAchIFrame = false;
  showPage = true;
  hstPayBtnMsg: string;
  sessionId: any;
  prePayStatus: string;
  isResponse: boolean = false;
  credentials: any;
  checkModalRef: BsModalRef;
  ReffernceNumber: string;
  CreditCardNumber: string;
  InvoiceNumber: string;
  refundLimitref: BsModalRef;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  checkNo: number;
  checkDate: Date = new Date();
  today = new Date();
  checkBank: string = '';
  amountToPay: number;
  paymentGateway: number;
  isVoidCalled: boolean = false;
  manualModalRef: BsModalRef;
  selectedDeviceId = 0;
  ManualCardExpIsDirty: boolean = false;
  ValidManualCardExp: boolean = false;
  ManualCardNumber = '';
  ManualCardExp = null;
  ManualCardName = '';
  ManualCardAuthorization = '';
  ManualCardType = '';
  ManualSelectCard;
  isManualSelectCard: boolean = false;
  public ExpNumberMask: String = '00/0000';
  creditCardList;
  componentName: string = 'refund.component.html';
  terminalDevicesList: IDeviceSetting[];
  noRefundPermission = false;
  refundCashPermissions;
  refundCheckPermissions;
  refundCCPermissions;
  paymentModeName;
  UniqueKey: string;
  Isopen: boolean = true;
  subTD: any;
  editRightOfflinePayment = false;
  viewRightOfflinePayment = false;
  transactionInitiated = false;
  refundInProgress = false;
  initiatedVoidCC = false;
  cctStatusOrderId = 0;
  achPaymentGateway: any;
  achOrderNumber: any;
  isAutoPopulateBillingInfo = false;
  /** True when the facility is configured for PayFields (not legacy XWEB) — set in getCredentials(). */
  isPayFieldsRefundEligible = false;

  // PayFields unlinked-credit refund (card-entry) state. Refund is always independent of the
  // original sale — only voidPayFieldsRefund's rollback references a transaction id.
  showPayFieldsCreditForm = false;
  payFieldsStateRequired = false;
  payFieldsMandatoryFieldsLoaded = false;
  isPayFieldsCreditFormReady = false;
  private payFieldsCreditCardValidity = { number: false, expiration: false, cvv: false };
  payFieldsCreditPendingAmount = 0;
  payFieldsCreditPayId: number = null;
  countryList: any[] = [];
  stateList: any[] = [];
  emptyStateList = false;
  payFieldsCreditBillingDetails = {
    firstName: '',
    middleName: '',
    lastName: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    countryId: environment.defaultCountryId,
    stateId: 0,
    postalCode: ''
  };
  private payFieldsCreditSecureForm: any = null;
  private payFieldsCreditFormListeners: { form: any; tokenSuccess: any; tokenError: any; error: any } | null = null;
  private payFieldsCreditRequestId: string | null = null;
  private isPayFieldsCreditTokenPending = false;
  // True from tokenization success until CallPayFieldCredit resolves - keeps Submit disabled during that gap.
  private isPayFieldsCreditSubmitPending = false;
  private payFieldsCreditWatchdogTimer: any = null;
  private payFieldsCreditIframeObserver: MutationObserver | null = null;
  private payFieldsCreditFocusTrap: FocusTrap | null = null;
  private payFieldsCreditFocusOrigin: HTMLElement | null = null;
  private payFieldsCreditFocusTrapRetryTimer: any = null;
  @ViewChild('payFieldsCreditDialog', { static: false, read: ElementRef }) payFieldsCreditDialog: ElementRef<HTMLElement>;
  private readonly PAYFIELDS_CREDIT_TOKEN_TIMEOUT_MS = 30000;
  tempCNPPayId = null;
  tempCNPAmount = null;
  mandatoryFieldsList = [];
  customerInfo = {
    FirstName: '',
    MiddleName: '',
    LastName: '',
    CompanyName: '',
    AddressOne: '',
    City: '',
    CountryCode: '',
    StateCode: '',
    StateId: 0,
    PostalCode: '',
    CountryId: 0,
    CellPhoneNumber: '',
    Email: ''
  }
  requestParam: String;
  customerInfoPresent = false;
  openEdgeSub: any;
  subOpenEdgeEMV: any;
  retryTransactionStatusLoader = false;
  facilityCreditCards: string = '';
  tempRcmRes = {
    rcmSessionId: '',
    rcmResponse: ''
  }
  tempCnpRes: any;
  achManualModalRef: BsModalRef;
  achManualCardAuthorization = '';
  nameonAccount = '';
  accountType = 279;
  checkNumber = '';
  accountNumber = '';
  routingNumber = '';
  costValueDirectiveSetting: ITwoDigitDecimalInput = {
    Length: 5,
    IsCurrency: true,
    DefaultMinimum: false,
    MinimumValue: '0.00',
    MaximumValue: '99999.99',
    WholeValue: false,
  };
  isTDEmv = {
    isTransactionWaitTime: false,
    isPortClosingWaitTime: false
  }
  RCMStatusResponse: IRCMStatus = {
    SessionId: '',
    SessionState: 0
  };
  isOpenEdgeEMVCompleted = false;
  enableAddressAutofill: any;
  requestGatewayDetails: any;
  mandateFieldsforCheckpayment: IGetPermissionMandatoryField;
  amountFieldforcheck: boolean;
  checknumberField: boolean;
  checkdatefield: boolean;
  checkbankname: boolean;
  Tenantinfo: any;

  constructor(private paymentService: PaymentService,
    private modalService: BsModalService,
    public sanitizer: DomSanitizer,
    private toastr: ToastrService,
    public facilityservice: FacilityService,
    private generalService: GeneralService,
    private gatewayService: paymentGateWayService,
    private prospectSerice: ProspectService,
    private userSessionService: UserSessionService,
    private renderer: Renderer2,
    private commonMethod: CommonMethodService,
    private payFieldsSdkLoader: PayFieldsSdkLoaderService,
    private focusTrapFactory: FocusTrapFactory,
  ) { }

  ngOnInit() {
    if (this.processRefund.TenantId) {
      this.getTenantDetailsById(this.processRefund.TenantId);
    }
    this.setUserPermissions();
    this.manualAuthForm.form.addControl('mManualCardNumber', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardExp', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardName', new FormControl());
    this.manualAuthForm.form.addControl('mCardType', new FormControl());
    this.manualAuthForm.form.addControl('mManualCardAuthorization', new FormControl());
    this.totalAmount = this.processRefund.AmountTobeRefund;
    this.getCredentials();
    this.getCreditCard();
    this.getFacilityInfoACH();
    this.refundTable = [];
    this.refundCount = 0;
    this.tillNowPaid = 0;
    this.isResponse = false;
    this.finalPayModel = {};
    this.remainingAmount = 0;
    this.refundCashPermissions = this.generalService.getUserPermissionsForModule(EUserFunctions['Rentals : Refund By Cash']);
    this.refundCheckPermissions = this.generalService.getUserPermissionsForModule(EUserFunctions['Rentals : Refund By Check']);
    this.refundCCPermissions = this.generalService.getUserPermissionsForModule(EUserFunctions['Rentals : Refund By Credit Card']);
    this.achManualAuthForm.form.addControl("achRoutingNumber", new FormControl());
    this.achManualAuthForm.form.addControl("achAccountNumber", new FormControl());
    this.achManualAuthForm.form.addControl("achCheckNumber", new FormControl());
    this.achManualAuthForm.form.addControl("achNameOnAccount", new FormControl());
    this.achManualAuthForm.form.addControl("achAuthorization", new FormControl());
    this.achManualAuthForm.form.addControl("achAccountType", new FormControl());
    this.achManualAuthForm.form.get("achRoutingNumber").setValidators([Validators.required]);
    this.achManualAuthForm.form.get("achAccountNumber").setValidators([Validators.required]);
    this.achManualAuthForm.form.get("achCheckNumber").setValidators([Validators.required]);
    this.achManualAuthForm.form.get("achAuthorization").setValidators([Validators.required]);
    this.setMandatoryFieldforCheckpayment(173);
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.

    if (changes['refundId']) {
      let payProcess = changes['refundId'].currentValue;
      if (payProcess) {
        if (this.processRefund.Type === 9) {
          this.refundTable = [];
          this.refundCount = 0;
          this.tillNowPaid = 0;
          this.isResponse = false;
          this.finalPayModel = {};
          this.loadRefundpage();
          this.totalAmount = this.processRefund.AmountTobeRefund.toFixed(2);
          this.remainingAmount = 0;
        }
      }
    }

    if (changes['apiResponse']) {
      if (this.apiResponse.ReceiptId !== undefined) {
        if (this.apiResponse.Success) {
          this.isResponse = true;
          this.apiResponse['date'] = new Date();
          this.payStatus = 'Success';
          if (this.transactionInitiated) {
            this.loaderIcon = Promise.resolve(false);
            this.transactionInitiated = false;
          }
          this.prePayStatus = 'Transaction';
          this.payModalRef?.hide();
          this.payModalRef = this.modalService.show(this.aftePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
        } else {
          this.isResponse = false;
          this.payStatus = 'Failed';
          this.paymentSuccessFul = false;
          this.showPrintEmailRcpt = false;
          if (this.transactionInitiated) {
            this.loaderIcon = Promise.resolve(false);
            this.transactionInitiated = false;
          }
          this.prePayStatus = 'Transaction';
          this.payModalRef?.hide();
          this.payModalRef = this.modalService.show(this.aftePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
        }
      }
    }
  }

  loadRefundpage() {
    if (this.processRefund.Type === 4) {
      this.processRefund.TransactionList.map(ele => {
        this.refundCount++;
        const obj = {
          payId: this.refundCount,
          payName: 'Refund ' + this.refundCount,
          payAmount: parseFloat((ele.RefundAmount).toFixed(2)),
          payComplete: false,
          payNowDisable: this.processRefund.Type == 9 || this.processRefund.Type == 4 ? false : true,
          payModeId: (this.paymentGateway && this.paymentGateway == EPaymentGateway.TdBank && (ele.PaymentModeId == EPaymentModes.HostedPage || ele.PaymentModeId == EPaymentModes.CardOnfile))
            || (!this.autoPayInfo && (ele.PaymentModeId == EPaymentModes.CardOnfile || ele.PaymentModeId == EPaymentModes.ACHOnFile))
            || (this.paymentGateway == EPaymentGateway.Stripe &&
              [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
              EPaymentModes.RemotePay].includes(ele.PaymentModeId) || (ele.PaymentModeId == EPaymentModes.CardOnfile && !this.autoPayInfo.paymentAccountId )) ? 0 : ele.PaymentModeId,
          transactionId: ele.AuthorizationCode,
          paidAmount: parseFloat((ele.RefundAmount).toFixed(2)),
          orderId: null,
          checkNum: 0,
          checkDate: '',
          bankName: '',
          CCNumber: ele.CCNumber,
          CcType: ele.CcType,
          Nameoncard: ele.Nameoncard,
          ExpiryMonth: ele.ExpiryMonth,
          Expiryyear: ele.Expiryyear,
          isOpenEdgePaymentCompleted: false,
          UniqueTransId: ele.UniqueTransId
        };
        this.refundTable.push(obj);
      });
    } else if (this.processRefund.Type === EPaymentOrigin.Merchandise) {
      this.processRefund.TransactionList.map(ele => {
        if (this.processRefund.partialRefund) {
          if (ele.RefundAmount >= this.totalAmount && this.refundCount == 0) {
            this.refundCount++;
            const obj = {
              payId: this.refundCount,
              payName: 'Refund ' + this.refundCount,
              payAmount: parseFloat((this.totalAmount).toFixed(2)),
              payComplete: false,
              payNowDisable: false,
              payModeId: (this.paymentGateway && this.paymentGateway == EPaymentGateway.TdBank && (ele.PaymentModeId == EPaymentModes.HostedPage || ele.PaymentModeId == EPaymentModes.CardOnfile))
                || (!this.autoPayInfo && (ele.PaymentModeId == EPaymentModes.CardOnfile || ele.PaymentModeId == EPaymentModes.ACHOnFile))
                || (this.paymentGateway == EPaymentGateway.Stripe &&
                  [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
                  EPaymentModes.RemotePay].includes(ele.PaymentModeId)) ? 0 : ele.PaymentModeId,
              transactionId: ele.AuthorizationCode,
              paidAmount: parseFloat((this.totalAmount).toFixed(2)),
              orderId: null,
              checkNum: 0,
              checkDate: '',
              bankName: '',
              CardNumber: ele.CardNumber,
              ReffNumber: ele.PaymentAccountId,
              Invoice: ele.Invoice,
              isOpenEdgePaymentCompleted: false
            };
            this.refundTable.push(obj);
          }
        } else {
          let refundAmount = parseFloat((ele.RefundAmount).toFixed(2)) > parseFloat((this.totalAmount).toFixed(2)) ? parseFloat((this.totalAmount).toFixed(2)) :
            parseFloat((ele.RefundAmount).toFixed(2))
          this.refundCount++;
          const obj = {
            payId: this.refundCount,
            payName: 'Refund ' + this.refundCount,
            payAmount: refundAmount,
            payComplete: false,
            payNowDisable: false,
            payModeId: (this.paymentGateway && this.paymentGateway == EPaymentGateway.TdBank && (ele.PaymentModeId == EPaymentModes.HostedPage || ele.PaymentModeId == EPaymentModes.CardOnfile))
              || (!this.autoPayInfo && (ele.PaymentModeId == EPaymentModes.CardOnfile || ele.PaymentModeId == EPaymentModes.ACHOnFile))
              || (this.paymentGateway == EPaymentGateway.Stripe &&
                [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
                EPaymentModes.RemotePay].includes(ele.PaymentModeId)) ? 0 : ele.PaymentModeId,
            transactionId: ele.AuthorizationCode,
            paidAmount: refundAmount,
            orderId: null,
            checkNum: 0,
            checkDate: '',
            bankName: '',
            CardNumber: ele.CardNumber,
            ReffNumber: ele.PaymentAccountId,
            Invoice: ele.Invoice,
            isOpenEdgePaymentCompleted: false
          };
          this.refundTable.push(obj);
        }
      });
    } else if (this.notCreditCardPayment(this.processRefund.TransactionList)) {
      this.processRefund.TransactionList.map(ele => {
        this.refundCount++;
        const obj = {
          payId: this.refundCount,
          payName: 'Refund ' + this.refundCount,
          payAmount: parseFloat((this.processRefund.AmountTobeRefund).toFixed(2)),
          payComplete: false,
          payNowDisable: false,
          payModeId: (this.paymentGateway && this.paymentGateway == EPaymentGateway.TdBank && (ele.PaymentModeId == EPaymentModes.HostedPage || ele.PaymentModeId == EPaymentModes.CardOnfile))
            || (!this.autoPayInfo && (ele.PaymentModeId == EPaymentModes.CardOnfile || ele.PaymentModeId == EPaymentModes.ACHOnFile))
            || (this.paymentGateway == EPaymentGateway.Stripe &&
              [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
              EPaymentModes.RemotePay].includes(ele.PaymentModeId)) ? 0 : ele.PaymentModeId,
          transactionId: ele.AuthorizationCode,
          paidAmount: parseFloat((this.processRefund.AmountTobeRefund).toFixed(2)),
          orderId: null,
          checkNum: 0,
          checkDate: '',
          bankName: '',
          CardNumber: ele.CardNumber,
          ReffNumber: ele.PaymentAccountId,
          Invoice: ele.Invoice,
          isOpenEdgePaymentCompleted: false
        };
        this.refundTable.push(obj);
      });
    } else {
      this.processRefund.TransactionList.map(ele => {
        this.refundCount++;
        const obj = {
          payId: this.refundCount,
          payName: 'Refund ' + this.refundCount,
          payAmount: parseFloat((this.processRefund.AmountTobeRefund).toFixed(2)),
          payComplete: false,
          payNowDisable: this.processRefund.Type == 9 || this.processRefund.Type == 4 || this.processRefund.Type == 10 ? false : true,
          payModeId: (this.paymentGateway && this.paymentGateway == EPaymentGateway.TdBank && (ele.PaymentModeId == EPaymentModes.HostedPage || ele.PaymentModeId == EPaymentModes.CardOnfile))
            || (!this.autoPayInfo && (ele.PaymentModeId == EPaymentModes.CardOnfile || ele.PaymentModeId == EPaymentModes.ACHOnFile))
            || (this.paymentGateway == EPaymentGateway.Stripe &&
              [EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
              EPaymentModes.RemotePay].includes(ele.PaymentModeId)) ? 0 : ele.PaymentModeId,
          transactionId: ele.AuthorizationCode,
          paidAmount: parseFloat((this.processRefund.AmountTobeRefund).toFixed(2)),
          orderId: null,
          checkNum: 0,
          checkDate: '',
          bankName: '',
          CardNumber: ele.CardNumber,
          ReffNumber: ele.PaymentAccountId,
          Invoice: ele.Invoice,
          isOpenEdgePaymentCompleted: false
        };
        this.refundTable.push(obj);
      });
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode == 47)) {
      return false;
    }
    return true;
  }

  OnmanualCancel() {
    this.ManualCardExpIsDirty = false;
    this.ManualCardNumber = '';
    this.ManualCardExp = '';
    this.ManualCardName = '';
    this.ManualCardAuthorization = '';
    this.manualModalRef.hide()
  }

  IsAlphaNumeric(e) {
    var specialKeys = new Array();
    specialKeys.push(8);  //Backspace
    specialKeys.push(9);  //Tab
    specialKeys.push(46); //Delete
    specialKeys.push(36); //Home
    specialKeys.push(35); //End
    specialKeys.push(37); //Left
    specialKeys.push(39); //Right
    var keyCode = e.keyCode == 0 ? e.charCode : e.keyCode;
    var ret = ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90) || keyCode == 32 || (keyCode >= 97 && keyCode <= 122) || (specialKeys.indexOf(e.keyCode) != -1 && e.charCode != e.keyCode));
    return ret;
  }

  setMandatoryFieldsManualAuthForm() {
    this.loaderIcon = Promise.resolve(true);
    this.generalService.GetMandatoryFieldsById(this.processRefund.facId, 174)
      .subscribe((response: IGetPermissionMandatoryField) => {
        var data = response;
        if (data.Form.ListOfProperties.length != 0) {
          data.Form.ListOfProperties.forEach(field => {
            let name = `m${field.Name}`;
            if (this.manualAuthForm.form.get(name) != null) {
              if (field.Required) {
                this.manualAuthForm.form.get(name).setValidators([Validators.required]);
              } else {
                this.manualAuthForm.form.get(name).setValidators(null);
              }
              this.manualAuthForm.form.updateValueAndValidity();
              this.manualAuthForm.reset();
              this.isManualSelectCard = false;
              this.manualAuthForm.form.patchValue({
                mCardType: 0
              })
            }
          });
        }
        this.getCreditCard();
        this.loaderIcon = Promise.resolve(false);
      });
  }

  isRequired(control) {
    if (control != null) {
      if (this.manualAuthForm.form.get(control) != null) {
        if (this.manualAuthForm.form.get(control).validator !== null) {
          const validator = this.manualAuthForm.form.get(control).validator({} as AbstractControl);
          return validator && validator.required ? true : false;
        } else {
          return false
        }
      }
    }
  }

  OnChangeManualCardExp(event) {
    this.ManualCardExpIsDirty = true;
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth() + 1;
    let expMonth = this.ManualCardExp.substring(0, 2)
    let expYear = this.ManualCardExp.substring(2)
    if (event.target.value) {
      if (this.ManualCardExp.length !== 6) {
        this.ValidManualCardExp = false;
      } else if (parseInt(expMonth) == 0 || parseInt(expMonth) > 12) {
        this.ValidManualCardExp = false;
      } else if ((parseInt(expYear) < currentYear) || (parseInt(expMonth) < currentMonth && parseInt(expYear) == currentYear)) {
        this.ValidManualCardExp = false;
      } else {
        this.ValidManualCardExp = true;
      }
    }
  }

  getCreditCard() {
    this.facilityservice.getCreditCardsForOp(this.processRefund.facId)
      .subscribe((response: IFacilityCreditCard) => {
        this.creditCardList = response.CreditCards;
        this.creditCardList.map(ele => {
          if (ele.Name == "American Express" && ele.Id == 1) {
            this.facilityCreditCards = this.facilityCreditCards.concat('AMEX,');
          } else if (ele.Name == "Visa" && ele.Id == 2) {
            this.facilityCreditCards = this.facilityCreditCards.concat('VISA,');
          } else if (ele.Name == "Master Card" && ele.Id == 3) {
            this.facilityCreditCards = this.facilityCreditCards.concat('MC,');
          } else if (ele.Name == "Discover" && ele.Id == 4) {
            this.facilityCreditCards = this.facilityCreditCards.concat('DISCOVER,');
          } else if (ele.Name == "Diners" && ele.Id == 5) {
            this.facilityCreditCards = this.facilityCreditCards.concat('DINERS,');
          } else if (ele.Name == "JCB" && ele.Id == 6) {
            this.facilityCreditCards = this.facilityCreditCards.concat('JCB,');
          }
        })
        this.facilityCreditCards = this.facilityCreditCards ? this.facilityCreditCards.substring(0, this.facilityCreditCards.length - 1) : null;
      })
  }

  onChangeManualCard(evt) {
    this.ManualSelectCard = evt.target.value;
    this.isManualSelectCard = this.ManualSelectCard == '0' ? true : false;
    this.manualAuthForm.form.patchValue({
      mCardType: this.ManualSelectCard == '0' ? 0 : this.ManualSelectCard
    })
  }

  disableAmount(Id) {
    if (this.processRefund.Type == 9) {
      this.refundTable.map(item => {
        if (Id == item.payId) {
          item.payNowDisable = false;
        }
      });
      return true;
    } else {
      return false;
    }
  }

  isPaymentModesDisabled(paymentModeId, drow) {
    if ((this.userSessionService.isCallcenterAgent && !(paymentModeId == EPaymentModes.HostedPage || paymentModeId == EPaymentModes.ACH || paymentModeId == EPaymentModes.CardOnfile || paymentModeId == EPaymentModes.ACHOnFile))
      || ((!this.userSessionService.isCallcenterAgent && (this.userSessionService.userSessionData.LastAccessedStoreId != this.processRefund.facId))
        && !(paymentModeId == EPaymentModes.CreditCard || paymentModeId == EPaymentModes.HostedPage || paymentModeId == EPaymentModes.ACH || paymentModeId == EPaymentModes.CardOnfile || paymentModeId == EPaymentModes.ACHOnFile))) {
      return true
    }
    if (paymentModeId == EPaymentModes.ManualAuthorization && !this.editRightOfflinePayment) {
      return true;
    }
    if (this.paymentGateway == EPaymentGateway.TdBank) {
      if ([EPaymentModes.CardOnfile, EPaymentModes.HostedPage, EPaymentModes.DirectDebitEFTOnFile].includes(paymentModeId)) {
        return true;
      }
    }
    if (this.paymentGateway == EPaymentGateway.Stripe) {
      if ([EPaymentModes.CreditCard, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.ACH, EPaymentModes.DirectDebitEFT, EPaymentModes.ACHOnFile, EPaymentModes.ApplePay, EPaymentModes.GooglePay, EPaymentModes.CashApp,
      EPaymentModes.RemotePay].includes(paymentModeId)) {
        return true;
      } else if (paymentModeId == EPaymentModes.CardOnfile && !this.autoPayInfo?.PaymentAccountId) {
        return true;
      } else {
        return false; //Hosted page
      }
    }

    if (paymentModeId == EPaymentModes.DirectDebitEFT || (paymentModeId == EPaymentModes.CardOnfile &&
      (!this.autoPayInfo?.PaymentAccountId))) {
      return true;
    }
    if (paymentModeId == EPaymentModes.ACHOnFile && (!this.autoPayInfo?.ACHPaymentAccountId || !drow.transactionId)) {
      return true;
    }
    return false;
  }

  addRow() {
    if (this.notCreditCardPayment(this.processRefund.TransactionList)) {
      this.refundCount++;
      const obj = {
        payId: this.refundCount,
        payName: 'Refund ' + this.refundCount,
        payAmount: this.remainingAmount,
        payComplete: false,
        payNowDisable: false,
        payModeId: 0,
        transactionId: 0,
        paidAmount: this.remainingAmount,
        orderId: null,
        checkNum: 0,
        checkDate: '',
        bankName: '',
        ManualCardNumber: '',
        ManualCardExp: '',
        ManualCardName: '',
        CreditCardType: 0,
        ManualCardAuthorization: '',
        achRoutingNo: 0,
        achAccountNumber: 0,
        achAuthorization: '',
        achAccountType: 279,
        nameonAccount: '',
        isOpenEdgePaymentCompleted: false
      };
      this.refundTable.push(obj);
    }
    this.getRemainingAmount();
    this.getAmountToPay();
  }

  removeRow() {
    if (this.refundCount != 1 && (!this.refundTable[this.refundTable.length - 1].payComplete)) {
      this.refundCount--;
      this.refundTable.splice(this.refundTable.length - 1, 1);
      if (this.refundTable.length == 0) {
        this.remainingAmount = parseFloat(this.totalAmount);
      } else {
        this.getRemainingAmount();
      }
    }
    this.getAmountToPay();
  }

  disableRefund(PaymentModeId) {
    if (this.payModes && this.payModes.length) {
      this.paymentModeName = this.payModes.find((item) => item.PaymentModeId == PaymentModeId).PaymentModeName;
    }
    if (PaymentModeId == 1 && !this.refundCashPermissions.EditRight) {
      return true;
    } else if (PaymentModeId == 2 && !this.refundCheckPermissions.EditRight) {
      return true;
    } else if ((PaymentModeId == 3 || PaymentModeId == 5 || PaymentModeId == 8 || PaymentModeId == 9)
      && !this.refundCCPermissions.EditRight) {
      return true;
    } else {
      return false;
    }
  }

  onChangePayMode(modeId, Id) {
    modeId = parseInt(modeId);
    if (modeId == EPaymentModes.CreditCard && this.credentials) {
      if (this.defaultCountryId == 2 && this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
        this.getTerminalDevices();
      } else {
        this.getTerminalDevices();
      }
    }
    this.currentPayModeId = modeId;
    this.refundTable.find(o => o.payId === Id).payModeId = modeId;
    if (this.currentPayModeId == 0 || (this.refundTable.find(o => o.payId === Id).payAmount == 0)) {
      this.refundTable.find(o => o.payId === Id).payNowDisable = true;
    } else if (this.processRefund.Type === EPaymentOrigin.Merchandise && this.processRefund.partialRefund) {
      if (this.processRefund.TransactionList.find(o => o.PaymentModeId == modeId).RefundAmount > this.totalAmount) {
        this.refundTable.find(o => o.payId === Id).payAmount = this.totalAmount;
        this.refundTable.find(o => o.payId === Id).paidAmount = this.totalAmount;
      } else {
        this.refundTable.find(o => o.payId === Id).payAmount = this.processRefund.TransactionList.find(o => o.PaymentModeId == modeId).RefundAmount;
        this.refundTable.find(o => o.payId === Id).paidAmount = this.processRefund.TransactionList.find(o => o.PaymentModeId == modeId).RefundAmount;
      }
    }
    else {
      this.refundTable.find(o => o.payId === Id).payNowDisable = false;
    }
    this.getRemainingAmount();
  }

  onChangepayAmount(event, Id) {
    let val = event.target.value.replace(/[$,]/g, '') ? event.target.value.replace(/[$,]/g, '') : event.target.value;;
    val = typeof val == 'string' ? parseFloat(val) : val;
    if (this.remainingAmount >= 0) { // to calculate remaing amount from multiple modes of payments
      let tempRemaing = 0;
      this.refundTable.map(item => {
        if (Id == item.payId) {
          tempRemaing += val;
        } else {
          tempRemaing += item.payAmount;
        }
      });
      this.remainingAmount = (this.totalAmount - tempRemaing) >= 0 ? (this.totalAmount - tempRemaing) : 0;
    }

    let sumPayAmountExcludeVal = 0;
    let remainingToPay = 0;
    this.refundTable.map(item => {
      if (Id !== item.payId) {
        sumPayAmountExcludeVal += item.payAmount;
      }
    });
    remainingToPay = this.totalAmount - sumPayAmountExcludeVal;
    if (remainingToPay > 0) {
      let remainMinusVal = remainingToPay - val;
      if (remainMinusVal >= 0) {  // if updated value is less than or equal to remaining amount
        this.refundTable.find(o => o.payId == Id).payAmount = val;
        this.refundTable.find(o => o.payId == Id).paidAmount = val;
      } else {  // if updated value is greater than remaining amount
        this.refundTable.find(o => o.payId == Id).payAmount = remainingToPay;
        this.refundTable.find(o => o.payId == Id).paidAmount = remainingToPay;
      }
    } else {
      val = 0;
      this.refundTable.find(o => o.payId == Id).payAmount = val;
      this.refundTable.find(o => o.payId == Id).paidAmount = val;
    }
    this.getAmountToPay();
  }

  ValidateBeforeonPayClick(RefundLimitModal: TemplateRef<any>, amount, payId, payModeId, template: TemplateRef<any>, item,
    templateCheck: TemplateRef<any>) {
    if (this.processRefund.IsRM) { // no Approval process for Walkin Merchandise return
      this.onPayClick(amount, payId, template, item, templateCheck);
    } else
      if (this.checkRefundLimit(amount, payModeId) == true) {
        if (this.processRefund.Type == EPaymentOrigin.Merchandise) {
          this.merchReturnSendApproval.emit(amount);
        } else {
          this.loaderIcon = Promise.resolve(true);
          const refundApprovalModel = {
            Id: this.processRefund.ApprovalId != null && this.processRefund.ApprovalId != undefined ? this.processRefund.ApprovalId : 0,
            LeaseNo: this.processRefund.LeaseNo,
            FacilityId: this.processRefund.facId,
            Type: this.EApprovalsDMRM.Refund,
            PaymentModeDetailsId: null,
            Amount: amount,
            DMApprovalStatus: this.processRefund.IsDM ? this.EApprovalsDMRM.SentforApproval : null,
            DMUserId: null,
            RMApprovalStatus: this.processRefund.IsRM ? this.EApprovalsDMRM.SentforApproval : null,
            RMUserId: null,
            MerchandiseSaleId: this.merchandiseSaleId
          };
          this.paymentService.SaveApprovalForRefundReversal(refundApprovalModel).subscribe((res: any) => {
            this.loaderIcon = Promise.resolve(false);
            if (res.Success) {
              this.refundLimitref = this.modalService.show(RefundLimitModal,
                { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
            } else if (!res.Success && res.Message == 'Unit is already Sent for Approval') {
              if (this.merchandiseSaleId) {
                this.toastr.warning('Merchandise Refund is already Sent for Approval!', 'Approval Request exists', this.toasterConfig);
              } else {
                this.toastr.warning('Unit is already Sent for Approval!', 'Approval Request exists', this.toasterConfig);
              }
            } else {
              this.toastr.error('Failed to initiate Refund Request!', 'Failure', this.toasterConfig);
            }
          }, err => {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.error('Failed to initiate Refund Request!', 'Failure', this.toasterConfig);
          });
        }
      } else {
        this.onPayClick(amount, payId, template, item, templateCheck);
      }
  }

  checkRefundLimit(payAmount, payModeId) {
    let userGroupRefundLimits = [];
    if (this.generalService.UserPermissions.UserGroupRefundReversalLimits.length > 0) {
      userGroupRefundLimits = this.generalService.UserPermissions.UserGroupRefundReversalLimits.filter(ele => (ele.Refund));
    }
    if (userGroupRefundLimits.length > 0) {
      const data = userGroupRefundLimits.find(limit => (limit.PaymentModeId == payModeId && limit.DeleteFlg == false));
      if (data) {
        if (payAmount > data.Amount) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  closeRefundLimitModal() {
    this.refundLimitref.hide();
    if (this.processRefund.Type == 4) {
      this.refundData.emit('NoRefundProcessMoveOut');
    } else if (this.processRefund.Type == EPaymentOrigin.Merchandise) {
      this.refundData.emit('approvalSentMerchReturn');
    }
  }

  onPayClick(amount, payId, template: TemplateRef<any>, item, templateCheck: TemplateRef<any>) {
    this.currentPayId = payId;
    this.prePayStatus = 'Refund';
    this.amountToPay = amount;
    if (this.refundTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.Cash) {
      this.payStatus = 'Success';
      this.paymentSuccessFul = true;
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = true;
      this.gotoPaymentSuccess(template, amount);
      this.refundInProgress = true;
    } else if (this.refundTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.Check) {
      this.payStatus = 'Success';
      this.prePayStatus = 'Refund';
      this.paymentSuccessFul = true;
      if (this.showPrintEmailRcpt) {
        this.checkModalRef = this.modalService.show(templateCheck, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      } else {
        this.checkModalRef = this.modalService.show(templateCheck, { class: 'modal-dialog-centered modal-md', backdrop: 'static', keyboard: false });
      }
    } else if ([EPaymentModes.CreditCard, EPaymentModes.HostedPage, EPaymentModes.CardOnfile].includes(this.refundTable.find(o => o.payId === this.currentPayId).payModeId)) {
      this.loaderIcon = Promise.resolve(true);
      this.saveInCCT(amount, payId, template, EPaymentTransactionType.Reversal_Refund, EPaymentModes.CreditCard);
    } else if ([EPaymentModes.ACHOnFile, EPaymentModes.ACH].includes(this.refundTable.find(o => o.payId === this.currentPayId).payModeId)) {
      this.loaderIcon = Promise.resolve(true);
      this.saveInACH(amount, payId, EPaymentTransactionType.Reversal_Refund);
    } else if (this.refundTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.ManualAuthorization) {
      this.payStatus = 'Success';
      this.paymentSuccessFul = true;
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = false;
      this.setMandatoryFieldsManualAuthForm();
      this.manualModalRef = this.modalService.show(this.offlinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      this.manualAuthAmountPaid = amount;
    } else if (this.refundTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.ACHManualAuthorization) {
      this.manualAuthAmountPaid = amount;
      this.payStatus = 'Success';
      this.prePayStatus = 'Refund';
      this.paymentSuccessFul = true;
      this.achManualModalRef = this.modalService.show(this.achOfflinePay, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
    }
  }

  isString(val: any): boolean {
    return (val && (typeof val === 'string' || val instanceof String));
  }

  gotoPaymentSuccess(template: TemplateRef<any>, amount: any) {
    this.tillNowPaid += this.isString(amount) ? parseFloat(amount) : amount;
    if (this.paymentSuccessFul) {
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = true;
    }
    if (this.refundTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.Check) {
      this.checkModalRef.hide();
      this.refundTable.find(o => o.payId == this.currentPayId).payComplete = true;
      this.refundTable.find(o => o.payId == this.currentPayId).checkNum = this.checkNo;
      this.refundTable.find(o => o.payId == this.currentPayId).checkDate = this.checkDate;
      this.refundTable.find(o => o.payId == this.currentPayId).bankName = this.checkBank;
      this.refundInProgress = true;
    } else if (this.refundTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.ManualAuthorization) {
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = true;
      this.manualModalRef.hide();
      this.refundTable.find(o => o.payId == this.currentPayId).ManualCardNumber = this.ManualCardNumber;
      this.refundTable.find(o => o.payId == this.currentPayId).ManualCardExp = this.ManualCardExp;
      this.refundTable.find(o => o.payId == this.currentPayId).ManualCardName = this.ManualCardName;
      if (this.ManualSelectCard) {
        this.refundTable.find(o => o.payId == this.currentPayId).CreditCardType = this.creditCardList.find(o => o.Id == parseInt(this.ManualSelectCard)).Id;
      } else {
        this.refundTable.find(o => o.payId == this.currentPayId).CreditCardType = null
      }
      this.refundTable.find(o => o.payId == this.currentPayId).ManualCardAuthorization = this.ManualCardAuthorization;
      this.ManualCardNumber = '';
      this.ManualCardExp = '';
      this.ManualCardName = '';
      this.ManualCardAuthorization = '';
      this.showPrintEmailRcpt = true;
      this.refundInProgress = true;
    } else if (this.refundTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.ACHManualAuthorization) {
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = true;
      this.achManualModalRef.hide();
      this.showPrintEmailRcpt = true;
      this.refundInProgress = true;
      const obj = {
        APPROVEDAMOUNT: amount,
        CHECKNUMBER: this.checkNumber,
        TRANSACTIONID: this.achManualCardAuthorization,
        RESPONSECODE: '000',
        RESPONSEDESCRIPTION: 'Approved',
        ORDERID: null,
        ACCOUNT: this.accountNumber,
        ROUTINGNUMBER: this.routingNumber,
        RECEIPTTEXT: null,
        ACCOUNTYPE: this.accountType
      };
      this.refundTable.find(o => o.payId == this.currentPayId)['processedACH'] = obj;
      this.achManualCardAuthorization = '';
      this.accountNumber = '';
      this.accountType = 279;
      this.achManualCardAuthorization = '';
      this.nameonAccount = '';
    }
    let status = this.refundTable.some(function (ele) { return ele.payComplete == false; });
    if (status) {
      this.showPrintEmailRcpt = false;
    } else {
      this.showPrintEmailRcpt = true;
    }

    if (this.showPrintEmailRcpt || !this.paymentSuccessFul) {
      if (!this.paymentSuccessFul) {
        // Hide any already-open failure modal first — otherwise each retry stacks another
        // modal/backdrop instance and only the newest is ever tracked by payModalRef.
        this.payModalRef?.hide();
        this.payModalRef = this.modalService.show(template, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
      }
      if (this.showPrintEmailRcpt) {
        this.callTransactionComplete();
      }
    }
  }

  callTransactionComplete() {
    this.loaderIcon = Promise.resolve(true);
    this.transactionInitiated = true;
    this.onSuccesRefund();
  }

  getpaymentmodes(facilityId, transactionType) {
    this.paymentService.GetFacilityPaymentModes(facilityId, transactionType).subscribe((res: IPaymentMode[]) => {
      if (!this.viewRightOfflinePayment) {
        let index = res.findIndex(ele => ele.PaymentModeId == 8);
        res.splice(index, 1);
      }
      this.payModes = res;
      this.payModes = this.payModes.filter((ele) => ![EPaymentModes.CashApp, EPaymentModes.ApplePay, EPaymentModes.GooglePay].includes(ele.PaymentModeId))
      if (this.paymentGateway == EPaymentGateway.Stripe) {
        if (this.defaultCountryId == ECountries.UnitedStatesOfAmerica) {
          this.payModes = this.payModes.filter((ele) => ![EPaymentModes.DirectDebitEFT, EPaymentModes.DirectDebitEFTOnFile, EPaymentModes.EFTManualAuthorization].includes(ele.PaymentModeId))
        } else if (this.defaultCountryId == ECountries.Canada) {
          this.payModes = this.payModes.filter((ele) => ![EPaymentModes.ACH, EPaymentModes.ACHOnFile, EPaymentModes.ACHManualAuthorization].includes(ele.PaymentModeId))
        }
      }
      const obj = {
        PaymentModeId: 0,
        PaymentModeName: 'Select',
        DeleteFlag: false
      };

      this.payModes.unshift(obj);
      let payModeIdIndex = this.refundTable.length ? this.refundTable.findIndex((ele) => ele.payModeId == 3) : -1
      if (this.processRefund.Type == EPaymentOrigin.Merchandise) {
        if (this.processRefund.AmountTobeRefund > this.processRefund.MiscSetting.Amount && this.processRefund.MiscSetting.DoNotRefundMerchandiseReturnamountexceeds) {
          this.refundTable.map(ele => {
            ele.payNowDisable = true;
          });
          this.showPrintEmailRcpt = true;
          this.paymentSuccessFul = true;
          this.skipModalRef = this.modalService.show(this.skipRefundPopUp, { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
        } else {
          if (payModeIdIndex !== -1) {
            if (this.paymentGateway == EPaymentGateway.TdBank) {
              this.getTerminalDevices();
            } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.defaultCountryId == 2) {
              this.getTerminalDevices();
            }
          }
        }
      } else {
        if (payModeIdIndex !== -1) {
          if (this.paymentGateway == EPaymentGateway.TdBank) {
            this.getTerminalDevices();
          } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.defaultCountryId == 2) {
            this.getTerminalDevices();
          }
        }
      }
    });
  }

  onSuccesRefund() {
    if (!this.transactionInitiated && this.payModalRef) {
      this.payModalRef.hide();
    }
    if (this.showPrintEmailRcpt && this.paymentSuccessFul) {
      if (this.apiResponse.ReceiptId === undefined) {
        this.afterRefundSuccess();
      } else if (this.apiResponse.Success) {
        this.apiResponse = {};
        this.afterRefund.emit(true);
        this.emitLoop.emit(this.processRefund.TransactionId);
      }
    }

    if (this.apiResponse.ReceiptId != undefined && !this.apiResponse.Success) {
      this.loaderIcon = Promise.resolve(true);
      let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);

      this.refundTable.forEach(item => {
        if (item.payModeId == EPaymentModes.HostedPage) {
          if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            let CCTModel = this.generateIntialCCT(paymentTrnsId, item);
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              this.voidCCCNP(res.Id, paymentTrnsId, item);
            });
          } else {
            this.toastr.warning('Please Contact Administrator', 'Alert', this.toasterConfig);
            this.isCancel.emit(true);
            this.loaderIcon = Promise.resolve(false);
          }
        } else if (item.payModeId == EPaymentModes.CreditCard) {
          if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            let CCTModel = this.generateIntialCCT(paymentTrnsId, item);
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              if (item['processedCC'].CARDTYPE != 'Credit') {
                this.callRCMRefund(res.Id, paymentTrnsId, item['processedCC']);
              } else {
                this.voidCCCNP(res.Id, paymentTrnsId, item);
              }
            });
          } else if (this.paymentGateway == EPaymentGateway.TdBank) {
            let cardNumber = this.refundTable.find(o => o.payId == item.payId)['processedCC'].CreditCardNumber;
            cardNumber = cardNumber.substr(cardNumber.length - 4);
            let CCTModel = this.generateIntialCCT(paymentTrnsId, item);
            CCTModel['InvoiceNumberForTDVoid'] = item.orderId;
            CCTModel.AuthorizationCode = this.refundTable.find(o => o.payId == item.payId)['processedCC'].AuthorizationCode;
            let isNewTdArchiFac = this.paymentGateway == EPaymentGateway.TdBank && (this.tdLocalHostArchitectureFacilities.find(fac => fac == CCTModel.FacilityId) || this.enableNewPaymentArchitecture) ? true : false;
            CCTModel.CreditCardNumber = cardNumber;
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              let cctOrderId = res.Id;
              if (isNewTdArchiFac) {
                const obj = {
                  OrderId: res.Id,
                  Amount: CCTModel.Amount,
                  AuthorizationCode: CCTModel.AuthorizationCode,
                  CreditCardNumber: CCTModel.CreditCardNumber,
                  TransactionType: "VOID",
                  InvoiceNumberForTDVoid: item.orderId,
                  UserId: this.userSessionService.userSessionData.UserId
                }
                let isTdRefundVoidTransactionCompleted = false;
                this.isTDEmv.isTransactionWaitTime = true;
                let tdRefundVoid = this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((res) => {
                  if (res) {
                    this.isTDEmv.isTransactionWaitTime = false;
                    isTdRefundVoidTransactionCompleted = true;
                    this.initiatedVoidCC = true;
                    if (res.ResponseCode == '000') {
                      const CCModel = {
                        Amount: res.Amount ? parseFloat(res.Amount) : 0,
                        Autopay: false,
                        paymentModeId: EPaymentModes.CreditCard,
                        AutoCcProcessingDay: 0,
                        CreditCardNumber: res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
                        CreditCardType: res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
                        NameonCard: res.NameonCard ? res.NameonCard : " ",
                        CreditCardExpiryMonth: res.CreditCardExpiryMonth != 0 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
                        CreditCardExpiryYear: !parseInt(res.CreditCardExpiryYear, 10) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
                        CreditCardBillingAddress: '',
                        CreditCardBillingZip: '',
                        SwipeTransaction: false,
                        SecurityCodeSent: false,
                        AuthorizationCode: res.AuthorizationCode ? res.AuthorizationCode : " ",
                        ResponseCode: res.ResponseCode ? res.ResponseCode : '',
                        Reason: res.Reason ? res.Reason : '',
                        PaymentAccountid: '',
                        CcInfoPurged: false,
                        DebitCardPayment: res.DebitCardPayment ? true : false,
                        OfflinePayment: 0,
                        UniqueTransId: 0,
                        PaymentTransactionTypeId: paymentTrnsId,
                        OrderId: cctOrderId,
                        FacilityId: this.processRefund.facId,
                        TransactionDateTime: new Date(),
                        TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                        EmvReceiptText: res.EmvReceiptText ? res.EmvReceiptText : null,
                        TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                        TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                        LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
                      };
                      this.initiatedVoidCC = false;
                      this.isCancel.emit(true);
                      this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
                      this.toastr.success('Reversal of Refund Successful!', 'Success', this.toasterConfig);
                    } else {
                      this.initiatedVoidCC = false;
                      this.tdEmvFailedResponse(CCTModel.Amount, res, item.payId, res.Id, paymentTrnsId, 'VOID');
                      this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
                    }
                  } else {
                    this.isTDEmv.isTransactionWaitTime = false;
                    const exceptionMessage = {
                      Reason: 'No Response',
                      ResponseCode: 50
                    }
                    this.tdEmvFailedResponse(CCTModel.Amount, exceptionMessage, item.payId, res.Id, paymentTrnsId, 'VOID');
                    isTdRefundVoidTransactionCompleted = true;
                    this.loaderIcon = Promise.resolve(false);
                  }
                }, err => {
                  this.isTDEmv.isTransactionWaitTime = false;
                  this.loaderIcon = Promise.resolve(false);
                  isTdRefundVoidTransactionCompleted = true;
                  if (err.error && err.error.text && (err.error.text.includes('Could not find file') || err.error.text.includes('does not exist'))) { //COM port doesn't exist
                    this.toastr.warning(`${err.error.text}`, 'Alert', this.toasterConfig);
                  } else if (!err.error.text) {
                    this.toastr.warning('Please ask Administrator to configure TD Service', 'Alert', this.toasterConfig);
                  }
                  const exceptionMessage = {
                    Reason: 'Declined!',
                    ResponseCode: 50
                  }
                  if (err.error && err.error.text == 'Another Payment is in progress.') {
                    this.toastr.warning('Another Payment is in progress, Please try after sometime.', 'Alert', this.toasterConfig);
                    this.isTDEmv.isPortClosingWaitTime = true;
                    this.loaderIcon = Promise.resolve(true);
                    setTimeout(() => {
                      const obj = {
                        OrderId: cctOrderId,
                        Amount: CCTModel.Amount,
                        AuthorizationCode: "0",
                        CreditCardNumber: "0",
                        TransactionType: "RCLT",
                        UserId: this.userSessionService.userSessionData.UserId
                      }
                      this.tdEmvFailedResponse(CCTModel.Amount, exceptionMessage, item.payId, res.Id, paymentTrnsId, 'VOID');
                      this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((recallRes) => { });
                      this.isTDEmv.isPortClosingWaitTime = false;
                      this.loaderIcon = Promise.resolve(false);
                    }, 10000 * 6 * this.paymentMaxWaitTime);
                  } else {
                    this.tdEmvFailedResponse(CCTModel.Amount, exceptionMessage, item.payId, res.Id, paymentTrnsId, 'VOID');
                    this.loaderIcon = Promise.resolve(false);
                  }
                });

                setTimeout(() => {
                  if (!isTdRefundVoidTransactionCompleted) {
                    tdRefundVoid.unsubscribe();
                    this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
                    this.toastr.warning('Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization', 'Alert', this.toasterConfig);
                    const exceptionMessage = {
                      Reason: 'No Response',
                      ResponseCode: 50
                    }
                    this.isTDEmv.isTransactionWaitTime = false;
                    this.tdEmvFailedResponse(CCTModel.Amount, exceptionMessage, item.payId, res.Id, paymentTrnsId, 'VOID');
                    this.loaderIcon = Promise.resolve(false);
                  }
                }, 10000 * 6 * this.paymentMaxWaitTime);
              } else {
                if (!this.subTD) {
                  this.initiatedVoidCC = true;
                  let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                  const source = interval(intervalTime);
                  this.subTD = source.subscribe(val => this.getCCTStatus(res.Id, 0, val, paymentTrnsId, 'REFUNDVOID'));
                }
              }
            });
          } else {
            this.toastr.warning('Please Contact Administrator', 'Alert', this.toasterConfig);
            this.isCancel.emit(true);
            this.loaderIcon = Promise.resolve(false);
          }
        } else if (item.payModeId == EPaymentModes.ManualAuthorization) {
          this.isCancel.emit(true);
          let CCTModel = this.generateIntialCCT(paymentTrnsId, item);
          this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
            this.loaderIcon = Promise.resolve(false);
          });
        } else if (item.payModeId == EPaymentModes.CardOnfile) {
          if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
            let CCTModel = this.generateIntialCCT(paymentTrnsId, item);
            this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              this.voidCCCNP(res.Id, paymentTrnsId, item);
            });
          }
        } else {
          this.isCancel.emit(true); // For other payment modes(Cash)
          this.loaderIcon = Promise.resolve(false);
        }
      });
      this.toastr.success('Refund is Initiated', 'Success', this.toasterConfig);
    }
  }

  afterRefundSuccess() {
    let isCash = false;
    let isCC = false;
    let isCheck = false;
    var tempCashObj;
    var tempCCObj;
    var tempMultipleCC;
    var tempCheckObj;
    var tempMultipleCheck;
    var tempACHObj;
    var tempMultipleACH;
    let isAch = false;
    let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);

    this.refundTable.forEach(item => {
      if (item.payModeId == 1) {
        if (this.finalPayModel == undefined || this.finalPayModel.CashTransaction == undefined) {
          isCash = true;
          tempCashObj = {
            CashTransaction: {
              Amount: (item.payAmount * -1),
              paymentModeId: item.payModeId
            }
          };
        } else {
          this.finalPayModel.CashTransaction.Amount += item.payAmount
        }
      } else if (item.payModeId == EPaymentModes.Check) {
        if (tempCheckObj == undefined || tempCheckObj.CheckTransaction == undefined) {
          isCheck = true;
          tempCheckObj = {
            CheckTransaction: [
              {
                Amount: parseFloat(Number(item.payAmount * -1).toFixed(2)),
                PaymentModeId: 2,
                CheckNumber: item.checkNum,
                CheckDate: item.checkDate,
                BankName: item.bankName,
                AccountHolder: '',
                BankAccountNumber: '',
                BankCode: '',
                DonotAcceptChecks: true
              }
            ]
          };
        } else {
          tempMultipleCheck = {
            Amount: parseFloat(Number(item.payAmount * -1).toFixed(2)),
            PaymentModeId: 2,
            CheckNumber: item.checkNum,
            CheckDate: item.checkDate,
            BankName: item.bankName,
            AccountHolder: '',
            BankAccountNumber: '',
            BankCode: '',
            DonotAcceptChecks: true
          };
          tempCheckObj.CheckTransaction.push(tempMultipleCheck);
          tempMultipleCheck = {};
        }
      } else if (item.payModeId == EPaymentModes.ManualAuthorization) {
        if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
          isCC = true;
          tempCCObj = {
            CCTransaction: [{
              Amount: (item.payAmount * -1),
              Autopay: false,
              PaymentModeId: parseInt(item.payModeId, 10),
              AutoCcProcessingDay: 0,
              CreditCardNumber: item.ManualCardNumber,
              CreditCardType: item.CreditCardType,
              NameonCard: item.ManualCardName,
              CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item.ManualCardExp.slice(0, 2))),
              CreditCardExpiryYear: parseInt(item.ManualCardExp.slice(item.ManualCardExp.length - 2)),
              CreditCardBillingAddress: "",
              CreditCardBillingZip: "",
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: item.ManualCardAuthorization,
              ResponseCode: '',
              Reason: "",
              Key: "",
              PaymentAccountid: "",
              CcInfoPurged: false,
              DebitCardPayment: false,
              OfflinePayment: true,
              PaymentTransactionTypeId: paymentTrnsId,
              //TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              OrderId: null,
              CCBatchNumber: ''
            }]
          }
        }
      } else if (item.payModeId == EPaymentModes.CreditCard) { // RCM CC
        if (this.paymentGateway == EPaymentGateway.TdBank) {
          let cTypeId = item['processedCC'].CreditCardType;
          if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
            isCC = true;
            tempCCObj = {
              CCTransaction: [{
                Amount: (item['processedCC'].Amount * (-1)),
                Autopay: false,
                PaymentModeId: item['processedCC'].PaymentModeId,
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCC'].CreditCardNumber,
                CreditCardType: cTypeId == "00" ? 2 : cTypeId,
                NameonCard: item['processedCC'].NameonCard ? item['processedCC'].NameonCard : null,
                CreditCardExpiryMonth: item['processedCC'].CreditCardExpiryMonth && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryMonth : 275,
                CreditCardExpiryYear: item['processedCC'].CreditCardExpiryYear && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryYear : 2099,
                CreditCardBillingAddress: item['processedCC'].CreditCardBillingAddress ? item['processedCC'].CreditCardBillingAddress : null,
                CreditCardBillingZip: item['processedCC'].CreditCardBillingZip ? item['processedCC'].CreditCardBillingZip : null,
                SwipeTransaction: item['processedCC'].SwipeTransaction,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCC'].AuthorizationCode,
                ResponseCode: item['processedCC'].ResponseCode,
                Reason: item['processedCC'].Reason,
                FacilityId: this.processRefund.facId,
                Key: item['processedCC'].Key,
                PaymentAccountid: item['processedCC'].PaymentAccountId ? item['processedCC'].PaymentAccountId : null,
                CcInfoPurged: false,
                DebitCardPayment: item['processedCC'].DebitCardPayment,
                OfflinePayment: false,
                UniqueTransId: item['processedCC'].UniqueTransId ? item['processedCC'].UniqueTransId : null,
                PaymentTransactionTypeId: item['processedCC'].PaymentTransactionTypeId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: item['processedCC'].TransactionTypeId,
                OrderId: item['processedCC'].OrderId,
                CCBatchNumber: item['processedCC'].CCBatchNumber ? item['processedCC'].CCBatchNumber : null,
                TerminalDeviceId: item['processedCC'].TerminalDeviceId ? item['processedCC'].TerminalDeviceId : null,
                EmvReceiptText: item['processedCC'].EmvReceiptText,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
                GatewayDetails: this.requestGatewayDetails
              }]
            };
          } else {
            tempMultipleCC = {
              Amount: (item['processedCC'].Amount * (-1)),
              Autopay: false,
              PaymentModeId: item['processedCC'].PaymentModeId,
              AutoCcProcessingDay: 0,
              CreditCardNumber: item['processedCC'].CreditCardNumber,
              CreditCardType: item['processedCC'].CreditCardType,
              NameonCard: item['processedCC'].NameonCard ? item['processedCC'].NameonCard : null,
              CreditCardExpiryMonth: item['processedCC'].CreditCardExpiryMonth && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryMonth : 275,
              CreditCardExpiryYear: item['processedCC'].CreditCardExpiryYear && item['processedCC'].CreditCardExpiryYear != '0' ? item['processedCC'].CreditCardExpiryYear : 2099,
              CreditCardBillingAddress: item['processedCC'].CreditCardBillingAddress ? item['processedCC'].CreditCardBillingAddress : null,
              CreditCardBillingZip: item['processedCC'].CreditCardBillingZip ? item['processedCC'].CreditCardBillingZip : null,
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: item['processedCC'].AuthorizationCode,
              ResponseCode: item['processedCC'].ResponseCode,
              Reason: item['processedCC'].Reason,
              FacilityId: this.processRefund.facId,
              Key: item['processedCC'].Key,
              PaymentAccountid: item['processedCC'].PaymentAccountId,
              CcInfoPurged: false,
              DebitCardPayment: item['processedCC'].DebitCardPayment,
              OfflinePayment: false,
              UniqueTransId: item['processedCC'].UniqueTransId ? item['processedCC'].UniqueTransId : null,
              PaymentTransactionTypeId: item['processedCC'].PaymentTransactionTypeId,
              //TransactionDateTime: new Date(),
              TransactionTypeId: item['processedCC'].TransactionTypeId,
              OrderId: item['processedCC'].OrderId,
              CCBatchNumber: '',
              TerminalDeviceId: item['processedCC'].TerminalDeviceId ? item['processedCC'].TerminalDeviceId : null,
              EmvReceiptText: item['processedCC'].EmvReceiptText,
              LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
              TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
              GatewayDetails: this.requestGatewayDetails
            };
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        } else {
          if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
            isCC = true;
            tempCCObj = {
              CCTransaction: [{
                Amount: (item['processedCC'].APPROVEDAMOUNT * -1),
                Autopay: false,
                paymentModeId: item.payModeId,
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCC'].ACCOUNT,
                CreditCardType: item['processedCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCC'].CARDBRAND) : ECreditCards.Visa,
                NameonCard: item['processedCC'].CARDHOLDERNAME,
                CreditCardExpiryMonth: this.isString(item['processedCC'].EXPMONTH) ? this.getExpiryMonthValue(parseInt(item['processedCC'].EXPMONTH)) :
                  this.getExpiryMonthValue(item['processedCC'].EXPMONTH),
                CreditCardExpiryYear: item['processedCC'].EXPYEAR,
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCC'].TRANSACTIONID,
                ResponseCode: item['processedCC'].HOSTRESPONSECODE,
                Reason: item['processedCC'].HOSTRESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: item['processedCC'].CARDTYPE == 'Credit' ? false : true,
                OfflinePayment: 0,
                //TransactionDateTime: new Date(),
                PaymentTransactionTypeId: paymentTrnsId,
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                OrderId: item.orderId,
                CCBatchNumber: item['processedCC'].BATCHNO,
                EmvReceiptText: item['processedCC'].RECEIPTTEXT,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                GatewayDetails: this.requestGatewayDetails
              }]
            }
          } else {
            tempMultipleCC = {
              Amount: (item['processedCC'].APPROVEDAMOUNT * -1),
              Autopay: false,
              paymentModeId: item.payModeId,
              AutoCcProcessingDay: 0,
              CreditCardNumber: item['processedCC'].ACCOUNT,
              CreditCardType: item['processedCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCC'].CARDBRAND) : ECreditCards.Visa,
              NameonCard: item['processedCC'].CARDHOLDERNAME,
              CreditCardExpiryMonth: this.isString(item['processedCC'].EXPMONTH) ? this.getExpiryMonthValue(parseInt(item['processedCC'].EXPMONTH)) :
                this.getExpiryMonthValue(item['processedCC'].EXPMONTH),
              CreditCardExpiryYear: item['processedCC'].EXPYEAR,
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: item['processedCC'].TRANSACTIONID,
              ResponseCode: item['processedCC'].HOSTRESPONSECODE,
              Reason: item['processedCC'].HOSTRESPONSEDESCRIPTION,
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: item['processedCC'].CARDTYPE == 'Credit' ? false : true,
              OfflinePayment: 0,
              //TransactionDateTime: new Date(),
              PaymentTransactionTypeId: paymentTrnsId,
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              OrderId: item.orderId,
              CCBatchNumber: item['processedCC'].BATCHNO,
              EmvReceiptText: item['processedCC'].RECEIPTTEXT,
              TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
              GatewayDetails: this.requestGatewayDetails
            };
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        }
      } else if (item.payModeId == EPaymentModes.HostedPage) {
        if (this.paymentGateway == EPaymentGateway.TdBank) {
          let cardType = item['processedCC'].card.card_type ? this.paymentService.getTdPaymentCardType(item['processedCC'].card.card_type) : ECreditCards.Visa;
          if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
            isCC = true;
            tempCCObj = {
              CCTransaction: [{
                Amount: item['processedCC'].amount * -1,
                Autopay: false,
                PaymentModeId: parseInt(item.payModeId, 10),
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCC'].card.last_four,
                CreditCardType: cardType,
                NameonCard: '',
                CreditCardExpiryMonth: 275,
                CreditCardExpiryYear: 2099,
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCC'].id,
                ResponseCode: item['processedCC'].approved,
                Reason: item['processedCC'].message,
                FacilityId: this.processRefund.facId,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: (item['processedCC'].card.card_type == 'MD' || item['processedCC'].card.card_type == 'PV') ? true : false,
                OfflinePayment: 0,
                UniqueTransId: item['processedCC'].id,
                PaymentTransactionTypeId: paymentTrnsId,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                OrderId: item.orderId,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                GatewayDetails: this.requestGatewayDetails
              }]
            };
          } else {
            tempMultipleCC = {
              Amount: item['processedCC'].amount * -1,
              Autopay: false,
              PaymentModeId: parseInt(item.payModeId, 10),
              AutoCcProcessingDay: 0,
              CreditCardNumber: item['processedCC'].card.last_four,
              CreditCardType: cardType,
              NameonCard: '',
              CreditCardExpiryMonth: 275,
              CreditCardExpiryYear: 2099,
              CreditCardBillingAddress: '',
              CreditCardBillingZip: '',
              SwipeTransaction: false,
              SecurityCodeSent: false,
              AuthorizationCode: item['processedCC'].id,
              ResponseCode: item['processedCC'].approved,
              Reason: item['processedCC'].message,
              FacilityId: this.processRefund.facId,
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: (item['processedCC'].card.card_type == 'MD' || item['processedCC'].card.card_type == 'PV') ? true : false,
              OfflinePayment: 0,
              UniqueTransId: item['processedCC'].id,
              PaymentTransactionTypeId: paymentTrnsId,
              //TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              OrderId: item.orderId,
              LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
              TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
              GatewayDetails: this.requestGatewayDetails
            };
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
          isCC = true;
          if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
            isCC = true;
            tempCCObj = {
              CCTransaction: [{
                Amount: parseFloat(item['processedCNPCC'].APPROVEDAMOUNT) * -1,
                Autopay: false,
                paymentModeId: item.payModeId,
                AutoCcProcessingDay: 0,
                CreditCardNumber: item['processedCNPCC'].MASKEDCARDNUMBER,
                CreditCardType: item['processedCNPCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCNPCC'].CARDBRAND) : ECreditCards.Visa,
                NameonCard: item['processedCNPCC'].CUSTOMERNAME,
                CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCNPCC'].EXPMONTH, 10)),
                CreditCardExpiryYear: parseInt(item['processedCNPCC'].EXPYEAR, 10),
                CreditCardBillingAddress: item['processedCNPCC'].ADDRESS1,
                CreditCardBillingZip: item['processedCNPCC'].BILLINGPOSTALCODE,
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: item['processedCNPCC'].TRANSACTIONID,
                ResponseCode: item['processedCNPCC'].RESPONSECODE,
                Reason: item['processedCNPCC'].RESPONSEDESCRIPTION,
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: item['processedCNPCC'].CARDTYPE == 'Credit' ? false : true,
                OfflinePayment: 0,
                //TransactionDateTime: new Date(),
                PaymentTransactionTypeId: paymentTrnsId,
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                OrderId: item.orderId,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                CCBatchNumber: item['processedCNPCC'].BATCHNO,
                EmvReceiptText: item['processedCNPCC'].RECEIPTTEXT ? item['processedCNPCC'].RECEIPTTEXT : null,
                GatewayDetails: item['payFieldGatewayDetails'] || this.requestGatewayDetails
              }]
            }
          } else {
            tempMultipleCC = {
              Amount: parseFloat(item['processedCNPCC'].APPROVEDAMOUNT) * -1,
              Autopay: false,
              paymentModeId: item.payModeId,
              AutoCcProcessingDay: 0,
              CreditCardNumber: item['processedCNPCC'].MASKEDCARDNUMBER,
              CreditCardType: item['processedCNPCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCNPCC'].CARDBRAND) : ECreditCards.Visa,
              NameonCard: item['processedCNPCC'].CUSTOMERNAME,
              CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(item['processedCNPCC'].EXPMONTH, 10)),
              CreditCardExpiryYear: parseInt(item['processedCNPCC'].EXPYEAR, 10),
              CreditCardBillingAddress: item['processedCNPCC'].ADDRESS1,
              CreditCardBillingZip: item['processedCNPCC'].BILLINGPOSTALCODE,
              SwipeTransaction: false,
              SecurityCodeSent: true,
              AuthorizationCode: item['processedCNPCC'].TRANSACTIONID,
              ResponseCode: item['processedCNPCC'].RESPONSECODE,
              Reason: item['processedCNPCC'].ORIGINALRESPONSEDESCRIPTION,
              Key: '',
              PaymentAccountid: '',
              CcInfoPurged: false,
              DebitCardPayment: false,
              OfflinePayment: 0,
              PaymentTransactionTypeId: paymentTrnsId,
              //TransactionDateTime: new Date(),
              TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
              OrderId: item.orderId,
              LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
              TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
              CCBatchNumber: item['processedCNPCC'].BATCHNO,
              EmvReceiptText: item['processedCNPCC'].RECEIPTTEXT ? item['processedCNPCC'].RECEIPTTEXT : null,
              GatewayDetails: item['payFieldGatewayDetails'] || this.requestGatewayDetails
            }
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        } else {
          isCC = true;
          if (this.finalPayModel == undefined || this.finalPayModel.CCTransaction == undefined) {
            isCC = true;
            let ccobj = this.gatewayService.mapStripeProcessedCC(item['processedStripeCC']);
            ccobj.Amount = -Math.abs(ccobj.Amount);
            tempCCObj = { CCTransaction: [ccobj] };
          } else {
            tempMultipleCC = this.gatewayService.mapStripeProcessedCC(item['processedStripeCC']);
            tempMultipleCC.Amount = -Math.abs(tempMultipleCC.Amount);
            tempCCObj.CCTransaction.push(tempMultipleCC);
            tempMultipleCC = {};
          }
        }
      } else if (item.payModeId == EPaymentModes.CardOnfile) {
        isCC = true;
        let arr = [];
        let processedItem = this.paymentGateway === EPaymentGateway.Stripe ? item['processedStripeCC'] : item['processedCC'];
        processedItem.Amount = parseFloat(processedItem.Amount) * -1;
        arr.push(processedItem);

        if (!this.finalPayModel?.CCTransaction) {
          tempCCObj = {
            CCTransaction: arr
          };
        } else {
          tempCCObj.CCTransaction.push(processedItem);
        }
      } else if (item.payModeId == EPaymentModes.ACH || item.payModeId == EPaymentModes.ACHOnFile || item.payModeId == EPaymentModes.ACHManualAuthorization) {
        if (tempACHObj == undefined || tempACHObj.ACHTransaction == undefined) {
          isAch = true;
          tempACHObj = {
            ACHTransaction: [
              {
                Amount: parseFloat(Number(item['processedACH'].APPROVEDAMOUNT).toFixed(2)) * -1,
                PaymentModeId: item.payModeId,
                CheckNumber: item['processedACH'].CHECKNUMBER,
                AchAuthorizationCode: item['processedACH'].TRANSACTIONID,
                ResponseCode: item['processedACH'].RESPONSECODE,
                Reason: item['processedACH'].RESPONSEDESCRIPTION,
                Ach: true,
                OfflinePayment: false,
                AutoAchProcessingDay: 0,
                AutoAchPayment: false,
                //TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                OrderId: item.orderId,
                PaymentTransactionTypeId: paymentTrnsId,
                FacilityId: this.processRefund.facId,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                AchAccountNumber: item['processedACH'].ACCOUNT,
                AchRoutingNumber: item['processedACH'].ROUTINGNUMBER,
                UniqueTransId: null,
                ReceiptText: item['processedACH'].RECEIPTTEXT,
                PaymentAccountId: item['processedACH'].PaymentAccountId,
                AchAccountType: item['processedACH'].ACCOUNTYPE,
                GatewayDetails: this.requestGatewayDetails
              }
            ]
          };
        } else {
          tempMultipleACH = {
            Amount: parseFloat(Number(item['processedACH'].APPROVEDAMOUNT).toFixed(2)) * -1,
            PaymentModeId: item.payModeId,
            CheckNumber: item['processedACH'].CHECKNUMBER,
            AchAuthorizationCode: item['processedACH'].TRANSACTIONID,
            ResponseCode: item['processedACH'].RESPONSECODE,
            Reason: item['processedACH'].RESPONSEDESCRIPTION,
            Ach: true,
            OfflinePayment: false,
            AutoAchProcessingDay: 0,
            AutoAchPayment: false,
            //TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            OrderId: item.orderId,
            PaymentTransactionTypeId: paymentTrnsId,
            FacilityId: this.processRefund.facId,
            TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
            AchAccountNumber: item['processedACH'].ACCOUNT,
            AchRoutingNumber: item['processedACH'].ROUTINGNUMBER,
            UniqueTransId: null,
            ReceiptText: item['processedACH'].RECEIPTTEXT,
            AchAccountType: item['processedACH'].ACCOUNTYPE,
            GatewayDetails: this.requestGatewayDetails
          };
          tempACHObj.ACHTransaction.push(tempMultipleACH);
          tempMultipleACH = {};
        }
      }
      if (isCash && isCC && isCheck && isAch) {
        this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempCheckObj, tempACHObj);
      } else if (isCash && isCC && isCheck) {
        this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempCheckObj);
      } else if (isCash && isCC && isAch) {
        this.finalPayModel = Object.assign(tempCashObj, tempCCObj, tempACHObj);
      } else if (isCheck && isCC && isAch) {
        this.finalPayModel = Object.assign(tempCheckObj, tempCCObj, tempACHObj);
      } else if (isCash && isCC) {
        this.finalPayModel = Object.assign(tempCashObj, tempCCObj);
      } else if (isCash && isAch) {
        this.finalPayModel = Object.assign(tempCashObj, tempACHObj);
      } else if (isCC && isAch) {
        this.finalPayModel = Object.assign(tempCCObj, tempACHObj);
      } else if (isCheck && isAch) {
        this.finalPayModel = Object.assign(tempCheckObj, tempACHObj);
      } else if (isCash && isCheck) {
        this.finalPayModel = Object.assign(tempCashObj, tempCheckObj);
      } else if (isCC && isCheck) {
        this.finalPayModel = Object.assign(tempCCObj, tempCheckObj);
      } else if (isCash) {
        this.finalPayModel = Object.assign(tempCashObj);
      } else if (isCC) {
        this.finalPayModel = Object.assign(tempCCObj);
      } else if (isCheck) {
        this.finalPayModel = Object.assign(tempCheckObj);
      } else if (isAch) {
        this.finalPayModel = Object.assign(tempACHObj);
      }
    });
    if (this.processRefund.Type == EPaymentOrigin.Refund) {
      this.finalPayModel['Tid'] = this.processRefund.TransactionId;
    }
    this.refundData.emit(this.finalPayModel);
  }

  callRCM(amount, payId, template: TemplateRef<any>, orderId, paymentTrnsId) {
    if (!this.credentials.RCMURL) {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      let isRefundCompleted = false;
      this.initiatedVoidCC = true;
      this.refundInProgress = true;
      const requestParam = "<REQUEST>" +
        "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CREDITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + orderId + "</ORDERID><OTK>" + orderId + "</OTK><ALLOWDUPLICATES/><CLERK></CLERK> <RECEIPTCOPYLABEL>MERCHANT_COPY</RECEIPTCOPYLABEL><TITLE>SSM 6.0</TITLE><CREATEALIAS>FALSE</CREATEALIAS></REQUEST>"
      const rcmRequest = this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
        if (res) {
          isRefundCompleted = true;
          const resultFromRCM = res;
          const responseData = JSON.parse(resultFromRCM.RcmResponse);
          if (responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Success) {
            this.payStatus = 'Success';
            this.paymentSuccessFul = true;
            this.refundTable.find(o => o.payId == payId)['processedCC'] = responseData.RESPONSE;
            this.refundTable.find(o => o.payId === payId).payComplete = true;
            this.gotoPaymentSuccess(template, amount);
            this.loaderIcon = Promise.resolve(false);
            this.initiatedVoidCC = false;
          } else {
            const requestParam = "<REQUEST> " + "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
              "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
              "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
              "<TRANSACTIONTYPE>DEBITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + orderId + "</ORDERID><OTK>" + orderId + "</OTK></REQUEST>";
            this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
              const resultFromRCM = res;
              const responseData = JSON.parse(resultFromRCM.RcmResponse);
              if ((responseData && responseData.RESPONSE && responseData.RESPONSE.APPROVEDAMOUNT && responseData.RESPONSE.HOSTRESPONSECODE && responseData.RESPONSE.RESULT && responseData.RESPONSE.CARDBRAND && responseData.RESPONSE.ACCOUNT
                && responseData.RESPONSE.EXPMONTH && responseData.RESPONSE.EXPYEAR && responseData.RESPONSE.TRANSACTIONID && (responseData.RESPONSE.HOSTRESPONSEDESCRIPTION || responseData.RESPONSE.RESULTMSG)
                && responseData.RESPONSE.TRANSACTIONTYPE) || (responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Canceled || EEdgeExpressResultCode.Declined)) {

                if (responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Success) {
                  this.payStatus = 'Success';
                  this.paymentSuccessFul = true;
                  this.refundTable.find(o => o.payId == payId)['processedCC'] = responseData.RESPONSE;
                  this.refundTable.find(o => o.payId === payId).payComplete = true;
                  this.gotoPaymentSuccess(template, amount);
                  this.loaderIcon = Promise.resolve(false);
                  this.initiatedVoidCC = false;
                } else {
                  this.payStatus = 'Failed';
                  this.isAnyRefundProcessed();
                  this.paymentSuccessFul = false;
                  this.paymentFailReason = responseData.RESPONSE.RESULTMSG;
                  const tempCCModel = {
                    Amount: responseData.RESPONSE.APPROVEDAMOUNT ? responseData.RESPONSE.APPROVEDAMOUNT : amount,
                    Autopay: false,
                    paymentModeId: EPaymentModes.CreditCard,
                    AutoCcProcessingDay: 0,
                    CreditCardNumber: responseData.RESPONSE.ACCOUNT ? responseData.RESPONSE.ACCOUNT : 0,
                    CreditCardType: ECreditCards.Visa,
                    NameonCard: '',
                    CreditCardExpiryMonth: responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
                    CreditCardExpiryYear: responseData.RESPONSE.EXPYEAR ? parseInt(responseData.RESPONSE.EXPYEAR, 10) : 2099,
                    CreditCardBillingAddress: '',
                    CreditCardBillingZip: '',
                    SwipeTransaction: false,
                    SecurityCodeSent: false,
                    AuthorizationCode: responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : '0',
                    ResponseCode: responseData.RESPONSE.RESULT ? responseData.RESPONSE.RESULT : '',
                    Reason: responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : '',
                    Key: '',
                    PaymentAccountid: '',
                    CcInfoPurged: false,
                    DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
                    OfflinePayment: 0,
                    UniqueTransId: 0,
                    PaymentTransactionTypeId: paymentTrnsId,
                    OrderId: this.refundTable.find(o => o.payId == payId).orderId,
                    FacilityId: this.processRefund.facId,
                    TransactionDateTime: new Date(),
                    TransactionTypeId: EPaymentTransactionType.Declined,
                    EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT,
                    TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                    TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                    LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
                  };
                  let CCTModel = Object.assign(tempCCModel);
                  this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => { });
                  this.gotoPaymentSuccess(template, 0);
                  this.loaderIcon = Promise.resolve(false);
                  this.initiatedVoidCC = false;
                }
              } else {
                rcmRequest.unsubscribe();
                this.openEdgeTransactionStatus(orderId, payId, paymentTrnsId);
              }
            }, err => {
              this.initiatedVoidCC = false;
              this.loaderIcon = Promise.resolve(false);
              this.prePayStatus = 'Gateway';
              this.paymentSuccessFul = false;
              this.payStatus = 'Failed';
              this.isAnyRefundProcessed();
              this.toastr.error('Refund Failed', 'Failure');
              const CCModel = {
                Amount: amount,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: '0',
                CreditCardType: ECreditCards.Visa,
                NameonCard: '',
                CreditCardExpiryMonth: responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
                CreditCardExpiryYear: responseData.RESPONSE.EXPYEAR ? parseInt(responseData.RESPONSE.EXPYEAR, 10) : 2099,
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : '0',
                ResponseCode: responseData.RESPONSE.RESULT ? responseData.RESPONSE.RESULT : '',
                Reason: responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: false,
                OfflinePayment: 0,
                UniqueTransId: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: this.refundTable.find(o => o.payId == payId).orderId,
                FacilityId: this.processRefund.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Declined,
                EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
              };
              this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
              this.gotoPaymentSuccess(template, 0);
            });
          }
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
        this.prePayStatus = 'Gateway';
        isRefundCompleted = true;
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed';
        this.isAnyRefundProcessed();
        const CCModel = {
          Amount: amount,
          Autopay: false,
          paymentModeId: EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: '0',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '0',
          ResponseCode: '0',
          Reason: 'Device Not Connected!',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          UniqueTransId: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: this.refundTable.find(o => o.payId == payId).orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
        };
        let CCTModel = Object.assign(CCModel);
        this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => { });
        this.gotoPaymentSuccess(template, 0);
        this.toastr.error('Refund Failed', 'Failure');
      });

      setTimeout(() => {
        if (!isRefundCompleted) {
          this.cctStatusOrderId = 0;
          rcmRequest.unsubscribe();
          this.openEdgeTransactionStatus(orderId, payId, paymentTrnsId);
        }
      }, 10000 * 6 * this.paymentMaxWaitTime);
    }
  }

  callCNP(amount, payId) {
    // Refund is always independent of the original transaction (only reversal/void references one) —
    // opens the PayFields card-entry dialog instead of trying to reference the original sale.
    if (this.isPayFieldsRefundEligible) {
      this.openPayFieldsCreditForm(amount, payId);
      return;
    }
    if (!this.credentials.CardNotPresentURL) {
      this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      const tempOrderId = this.refundTable.find(o => o.payId == payId).uniqueTransId;
      if (this.isAutoPopulateBillingInfo && this.customerInfo) {
        this.setCNPCustomerInfo(amount, tempOrderId);
      } else {
        this.requestParam = "<REQUEST>" +
          "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
          "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
          "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
          "<TRANSACTIONTYPE>CREDITRETURN</TRANSACTIONTYPE>" +
          "<AMOUNT>" + amount + "</AMOUNT>" +
          "<CLERK></CLERK>" +
          "<ORDERID>" + tempOrderId + "</ORDERID>" +
          "<ECI>" + EEdgeExpressECIType.Moto + "</ECI>" +
          "<HOSTPAYSETTING>" +
          "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
          "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
          "<CUSTOMIZATION>" +
          "<PAGE> " +
          "<BILLINGFIRSTNAME>  <REQUIRED>TRUE</REQUIRED>  </BILLINGFIRSTNAME>" +
          "<BILLINGLASTNAME >  <REQUIRED>TRUE</REQUIRED>  </BILLINGLASTNAME>" +
          "<BILLINGADDRESSONE >  <REQUIRED>TRUE</REQUIRED>  </BILLINGADDRESSONE>" +
          "<BILLINGPOSTALCODE >  <REQUIRED>TRUE</REQUIRED>  </BILLINGPOSTALCODE>" +
          "</PAGE>" +
          "<BRANDING>" +
          "<BODY>" +
          "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
          "<FONT-SIZE>14px</FONT-SIZE>" +
          "</BODY>" +
          "<BTN>" +
          "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
          "<FONT-SIZE>14PX;</FONT-SIZE>" +
          "</BTN>" +
          "<SPECIALCSS>" +
          "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
          "<COLOR>#3757C5;</COLOR>" +
          "</SPECIALCSS>" +
          "</BRANDING>" +
          "</CUSTOMIZATION>" +
          "<POSDEVICE>" +
          "<TYPE>KEYED</TYPE>" +
          "</POSDEVICE>" +
          "</HOSTPAYSETTING>" +
          "</REQUEST>";
      }
      this.paymentService.getCNPService(this.credentials.CardNotPresentURL, this.requestParam).subscribe((res: any) => {
        this.loaderIcon = Promise.resolve(false);
        const resultResponse = JSON.parse(res);
        this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resultResponse.RESULT.PAYPAGEURL);
        this.showIFrame = true;
        this.showPage = !this.showIFrame;
      }, err => {
        this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
      );
    }
  }

  getHiddenInput() {
    this.hstPayBtnMsg = 'Cancel';
    let iframeSrc = this.iframe.nativeElement.src.split('/');
    let tempId = iframeSrc.pop();
    if (!this.credentials.QueryPaymentStatusURL) {
      this.toastr.warning('Please ask Administrator to configure CNP URL', 'URL required', this.toasterConfig);
    } else {
      this.refundInProgress = true;
      if (this.sessionId === tempId) {
        let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
        this.loaderIcon = Promise.resolve(true);
        this.hstPayBtnMsg = 'OK';
        this.sessionId = tempId;
        this.paymentService.getCNPResponse(this.credentials, this.refundTable.find(o => o.payId == this.currentPayId).uniqueTransId).subscribe((res: any) => {
          const jsonResp = JSON.parse(res);
          if (jsonResp) {
            this.showIFrame = false;
            this.showPage = !this.showIFrame;
            if (jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp.RESULT.STATE != 'IN_PROGRESS' && jsonResp.RESULT.RESPONSECODE != EOpenEdgeResponseCode.In_Progress) {
              this.paymentSuccessFul = true;
              this.payStatus = 'Success';
              let amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
              this.refundTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = jsonResp.RESULT;
              this.gotoPaymentSuccess(this.aftePay, amount);
            } else if (jsonResp.RESULT.STATE == 'IN_PROGRESS' || (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION == 'Invalid Reference Error: Transaction does not exist')) {
              this.HostedCNPResponse(this.refundTable.find(o => o.payId == this.currentPayId).uniqueTransId, this.currentPayId, paymentTrnsId);
              setTimeout(() => {
                if (!this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted && this.refundTable.find(o => o.payId == this.currentPayId).uniqueTransId == this.cctStatusOrderId) {
                  this.paymentService.GetCreditCardTransactionById(this.refundTable.find(o => o.payId == this.currentPayId).orderId).subscribe((cctResponse: any) => {
                    let res = JSON.parse(cctResponse);
                    if (res.Reason == "Attempting to Process") {
                      this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
                      if (jsonResp.RESULT && jsonResp.RESULT.STATE && jsonResp.RESULT.STATE != 'IN_PROGRESS' && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
                        this.showIFrame = false;
                        this.showPage = !this.showIFrame;
                        this.paymentSuccessFul = true;
                        this.payStatus = 'Success';
                        this.refundTable.find(o => o.payId == this.currentPayId).payFailed = false;
                        this.refundTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = jsonResp.RESULT;
                        this.gotoPaymentSuccess(this.aftePay, parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2));
                      } else {
                        this.paymentSuccessFul = false;
                        this.payStatus = 'Failed';
                        this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
                        jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
                        this.saveCCTransactionFailureCase(jsonResp, jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined!', paymentTrnsId);
                      }
                    } else {
                      this.loaderIcon = Promise.resolve(false);
                      this.paymentFailReason = 'Declined!';
                      this.showIFrame = false;
                      this.showPage = !this.showIFrame;
                      this.payStatus = 'Failed';
                      this.paymentSuccessFul = false;
                      jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
                      this.saveCCTransactionFailureCase(jsonResp, jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined!', paymentTrnsId);
                    }
                  });
                }
              }, 10000 * 6 * this.paymentMaxWaitTime);
            } else {
              this.loaderIcon = Promise.resolve(false);
              this.paymentFailReason = 'Declined!';
              this.showIFrame = false;
              this.showPage = !this.showIFrame;
              this.payStatus = 'Failed';
              this.paymentSuccessFul = false;
              jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
              this.saveCCTransactionFailureCase(jsonResp, jsonResp?.RESULT?.RESPONSEDESCRIPTION ?? 'Declined!', paymentTrnsId);
            }
          }
        }, err => {
          this.paymentFailReason = 'Gateway Rejected - No response received!';
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed';
          this.showIFrame = false;
          this.showPage = !this.showIFrame;
          this.loaderIcon = Promise.resolve(false);
          this.tempCnpRes = {
            PaymentModeId: EPaymentModes.HostedPage
          }
          this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
          this.toastr.warning('Something went wrong', 'Please try again!', this.toasterConfig);
          this.saveCCTransactionFailureCase(this.tempCnpRes, this.paymentFailReason, paymentTrnsId);
        });
      } else {
        this.sessionId = tempId;
      }
    }
  }

  onhstPayBtn(val) {
    if (val == 'OK') {
      this.refundTable.find(o => o.payId === this.currentPayId).payComplete = true;
    } else if (val == 'Cancel') {
      let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
      if (this.refundTable.find(o => o.payId === this.currentPayId).payModeId == EPaymentModes.HostedPage) {
        const cCModel = {
          Amount: this.refundTable.find(o => o.payId === this.currentPayId).payAmount,
          Autopay: false,
          PaymentModeId: EPaymentModes.HostedPage,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 'XXXX',
          CreditCardType: ECreditCards.Visa,
          NameonCard: " ",
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '0',
          ResponseCode: '0',
          Reason: 'Transaction Cancelled By User',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          OrderId: this.refundTable.find(o => o.payId === this.currentPayId).orderId,
          CCBatchNumber: null,
          EmvReceiptText: null,
          FacilityId: this.processRefund.facId,
          TerminalDeviceId: null,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
        };
        this.paymentService.saveCCTransaction(Object.assign(cCModel)).subscribe((res: any) => { });
        this.showIFrame = false;
        this.showPage = !this.showIFrame;
      } else {
        this.showAchIFrame = false;
        this.showPage = !this.showIFrame;
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, "Transaction Cancelled By User");
      }
    }
  }

  onRefundCancel() {
    this.isCancel.emit(true);
  }

  saveInCCT(amount, payId, template: TemplateRef<any>, transTypeId, paymentModeId) {
    // Validate amount before gateway submission (fail-fast for zero, negative, or NaN amounts —
    // NaN <= 0 is false in JS, so isNaN() must be checked explicitly or NaN sails past this guard).
    if (isNaN(amount) || amount <= 0) {
      this.toastr.error('Invalid refund amount. Please enter an amount greater than zero.', 'Validation Error', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
    let isNewPaymentArchiFac = (this.tdLocalHostArchitectureFacilities.find(fac => fac == this.processRefund.facId) || this.enableNewPaymentArchitecture) ? true : false;
    const refundRow = this.refundTable.find(row => row.payId == payId);
    const payFieldsGatewayDetails = this.paymentGateway == EPaymentGateway.OpenEdgeExpress &&
      refundRow?.payModeId == EPaymentModes.HostedPage && this.isPayFieldsRefundEligible
      ? this.buildPayFieldsRefundGatewayDetails() : undefined;
    if (refundRow) {
      refundRow['payFieldGatewayDetails'] = payFieldsGatewayDetails;
    }
    const CCModel = {
      Amount: amount,
      Autopay: false,
      paymentModeId: paymentModeId,
      AutoCcProcessingDay: 0,
      CreditCardNumber: 0,
      CreditCardType: ECreditCards.Visa,
      NameonCard: '',
      CreditCardExpiryMonth: 275,
      CreditCardExpiryYear: 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: 0,
      ResponseCode: '',
      Reason: 'Attempting to Process',
      Key: this.paymentGateway == EPaymentGateway.TdBank ? 'REFUND' : '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      UniqueTransId: paymentModeId == EPaymentModes.CardOnfile && this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.refundTable.find(o => o.payId === payId).UniqueTransId ? this.refundTable.find(o => o.payId === payId).UniqueTransId : null,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: null,
      FacilityId: this.processRefund.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transTypeId,
      TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
      TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
      LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
      NewTDArchitectureFacility: isNewPaymentArchiFac,
      GatewayDetails: payFieldsGatewayDetails
    };
    this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe(
      (cctRes: any) => {
        let cctId = cctRes.Id;
        this.refundTable.find(o => o.payId == payId).orderId = cctRes.Id;
        this.refundTable.find(o => o.payId == payId).uniqueTransId = cctRes.UniqueTransId;
      if (this.refundTable.find(o => o.payId === payId).payModeId == EPaymentModes.CreditCard) {
        if (this.paymentGateway == EPaymentGateway.TdBank) {
          if (isNewPaymentArchiFac) {
            const obj = {
              OrderId: cctId,
              userId: this.userSessionService.userSessionData.UserId,
              Amount: amount,
              AuthorizationCode: "0",
              CreditCardNumber: "0",
              TransactionType: "REFUND",
              InvoiceNumberForTDVoid: 0
            }
            this.isTDEmv.isTransactionWaitTime = true;
            this.loaderIcon = Promise.resolve(true);
            let isTdRefundTransactionCompleted = false;
            let tdRefundRequest = this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((res) => {
              if (res) {
                this.isTDEmv.isTransactionWaitTime = false;
                isTdRefundTransactionCompleted = true;
                if (res.ResponseCode == '000') {
                  this.paymentSuccessFul = true;
                  this.payStatus = 'Success';
                  res.Amount = parseFloat(res.Amount);
                  res['TransactionTypeId'] = transTypeId;
                  res['PaymentTransactionTypeId'] = paymentTrnsId;
                  this.refundTable.find(o => o.payId === payId).payComplete = true;
                  this.refundTable.find(o => o.payId == payId)['processedCC'] = res;
                  this.gotoPaymentSuccess(this.aftePay, res.Amount);
                  this.loaderIcon = Promise.resolve(false);
                } else {
                  if (res.ResponseCode == '95') { // 95 - device is in stand-alone mode  
                    this.toastr.warning('Device is not ready to Accept any Payment. Please ensure Device is Idle and ready to Accept New Payment Request.', 'Alert', this.toasterConfig);
                  } else if (res.Reason == 'Device is Busy, Please try after sometime.') { // Triggering multiple transaction          
                    this.toastr.warning('Device is not ready to Accept Payment, Please try after sometime.', 'Alert', this.toasterConfig);
                  } else if (res.Reason == "EMV Device Not Connected!") {
                    this.paymentFailReason = 'EMV Device Not Connected';
                  } else {
                    this.paymentFailReason = 'Declined!';
                    this.toastr.error('Refund Failed', 'Failure');
                  }
                  this.tdEmvFailedResponse(amount, res, payId, cctId, paymentTrnsId, "REFUND");
                }
              } else {
                this.isTDEmv.isTransactionWaitTime = false;
                isTdRefundTransactionCompleted = true;
                const exceptionMessage = {
                  Reason: 'No Response',
                  ResponseCode: 50
                }
                this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "REFUND");
              }
            }, err => {
              this.isTDEmv.isTransactionWaitTime = false;
              isTdRefundTransactionCompleted = true;
              if (err.error && err.error.text && (err.error.text.includes('Could not find file') || err.error.text.includes('does not exist'))) {
                this.paymentFailReason = 'EMV Device Not Connected!';
                this.toastr.warning(`${err.error.text}`, 'Alert', this.toasterConfig);
              } else {
                this.toastr.warning('Please ask Administrator to configure TD Service', 'Alert', this.toasterConfig);
                this.paymentFailReason = 'Declined!';
              }
              this.payStatus = 'Failed';
              this.paymentSuccessFul = false;
              this.isAnyRefundProcessed();
              this.refundTable.find(o => o.payId === payId).payComplete = false;
              const exceptionMessage = {
                Reason: 'Declined!',
                ResponseCode: 50
              }
              if (err.error && err.error.text == 'Another Payment is in progress.') {
                this.paymentFailReason = 'Declined!';
                this.toastr.warning('Another Payment is in progress, Please try after sometime.', 'Alert', this.toasterConfig);
                this.isTDEmv.isPortClosingWaitTime = true;
                this.loaderIcon = Promise.resolve(true);
                setTimeout(() => {
                  const obj = {
                    OrderId: cctId,
                    Amount: amount,
                    AuthorizationCode: "0",
                    CreditCardNumber: "0",
                    TransactionType: "RCLT",
                    UserId: this.userSessionService.userSessionData.UserId
                  }
                  this.isTDEmv.isPortClosingWaitTime = false;
                  this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "REFUND");
                  this.paymentService.InitiateTDPayment(obj, this.credentials.URLforLocalHost).subscribe((recallRes) => { });
                  this.loaderIcon = Promise.resolve(false);
                }, 10000 * 6 * this.paymentMaxWaitTime);
              } else {
                this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "REFUND");
                this.loaderIcon = Promise.resolve(false);
              }
            });
            setTimeout(() => {
              if (!isTdRefundTransactionCompleted) {
                tdRefundRequest.unsubscribe();
                this.isTDEmv.isTransactionWaitTime = false;
                this.loaderIcon = Promise.resolve(false);
                const exceptionMessage = {
                  Reason: 'Declined!',
                  ResponseCode: 50
                }
                this.tdEmvFailedResponse(amount, exceptionMessage, payId, cctId, paymentTrnsId, "REFUND");
                this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
              }
            }, 10000 * 6 * this.paymentMaxWaitTime);

          } else {
            if (!this.subTD) {
              this.initiatedVoidCC = true;
              let intervalTime = this.paymentGetCCTStatusInterval * 1000;
              const source = interval(intervalTime);
              this.subTD = source.subscribe(val => this.getCCTStatus(cctId, payId, val, paymentTrnsId, 'REFUND'));
            }
          }
        } else {
          if (isNewPaymentArchiFac) {
            this.callOpenEdgeTerminal(amount, payId, cctRes.Id, paymentTrnsId, cctRes.UniqueTransId);
          } else {
            this.callRCM(amount, payId, template, cctRes.Id, paymentTrnsId); // Transaction type(SALE) is decided by user when RCM device popsup a option to choose
          }
        }
      } else if (this.refundTable.find(o => o.payId === payId).payModeId == EPaymentModes.HostedPage) {
        if (this.paymentGateway == EPaymentGateway.TdBank) {
          this.returnTdPayment(amount, payId, paymentTrnsId);
        } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
          this.cctStatusOrderId = cctRes.Id;
          this.tempCNPAmount = amount;
          this.tempCNPPayId = payId;
          this.callCNP(amount, payId); // CNP is always CREDITSALE, Debit card is N/A
        } else { // stripe
          this.callStripeRefund(cctRes.Id, paymentTrnsId);
        }
      } else if (this.refundTable.find(o => o.payId === payId).payModeId == EPaymentModes.CardOnfile) {
        if (this.paymentGateway == EPaymentGateway.TdBank) {
          this.returnTdPayment(amount, payId, paymentTrnsId);
        } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
          this.cardOnFileEdgeReturn(amount, cctRes.Id, payId, cctRes.UniqueTransId, paymentTrnsId);
        } else {
          this.callStripeCofRefund(cctRes.Id, cctRes.UniqueTransId, paymentTrnsId, amount);
        }
      }
    },
    (error) => {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('Failed to save transaction record. Please contact administrator.', 'Error', this.toasterConfig);
      console.error('saveCCTransaction error in refund:', error);
    }
    );
  }


  getCredentials() {
    this.paymentService.getCCCredentials(this.processRefund.facId).subscribe((res) => {
      if (res !== null) {
        this.credentials = JSON.parse(res.GatewayDetails);
        this.paymentGateway = res.PaymentGateWay;
        if (this.paymentGateway == EPaymentGateway.TdBank) {          
          this.requestGatewayDetails = {
            MerchantId: this.credentials.MerchantId,
            PassCode: this.credentials.PassCode,
            URLforPaymentTD: this.credentials.URLforPaymentTD
          }
          this.refundTable.map((item) => {
            if (item.payModeId == EPaymentModes.HostedPage || item.payModeId == EPaymentModes.CardOnfile) {
              item.payModeId = 0;
              this.onChangePayMode(item.payModeId, item.payId);
            }
          })
        } else if (this.paymentGateway == EPaymentGateway.Stripe) {
          this.stripePublishableKey = this.credentials.PublishableKey;
          this.StripeUnifiedAccountId = this.credentials.AccountId;
          this.enableAddressAutofill = this.credentials.EnableAddressAutofill;
          this.requestGatewayDetails = {
            CompletePaymentDuringDayEnd: this.credentials.CompletePaymentDuringDayEnd,
            AccountId: this.credentials.AccountId,
            SecretKey: this.credentials.SecretKey
          }
          this.setMandatoryFieldHostedPage();
        }else {
          this.requestGatewayDetails = {
            XWEBID: this.credentials.XWEBID,
            XWEBTERMINALID: this.credentials.XWEBTERMINALID,
            XWEBAUTHKEY: this.credentials.XWEBAUTHKEY,
            QueryPaymentStatusURL: this.credentials.QueryPaymentStatusURL
          }
          this.isPayFieldsRefundEligible = this.canUseOpenEdgePayFieldsCreditRuntime();
          if (this.isPayFieldsRefundEligible) {
            this.setMandatoryFieldHostedPage();
          }
        }
        this.requestGatewayDetails = JSON.stringify(this.requestGatewayDetails);
      }
      if ([EPaymentOrigin.Merchandise, EPaymentOrigin.SeperateMerchRefund].includes(this.processRefund.Type)) {
        this.getpaymentmodes(this.processRefund.facId, ELOV_TransactionTypes.Merchandise);
      } else {
        this.getpaymentmodes(this.processRefund.facId, ELOV_TransactionTypes.Rental);
      }
      this.loadRefundpage();
    }, err => {
      if ([EPaymentOrigin.Merchandise, EPaymentOrigin.SeperateMerchRefund].includes(this.processRefund.Type)) {
        this.getpaymentmodes(this.processRefund.facId, ELOV_TransactionTypes.Merchandise);
      } else {
        this.getpaymentmodes(this.processRefund.facId, ELOV_TransactionTypes.Rental);
      }
      this.loadRefundpage();
    })

  }

  // ── PayFields unlinked-credit refund: credential/eligibility helpers ────────

  // Angular's Validators.required accepts a whitespace-only string; coerce non-string values safely too.
  private hasCredentialValue(value: any): boolean {
    return !!(value ?? '').toString().trim();
  }

  // Mirrors payment.component.ts's toBoolean — hasCredentialValue would treat a persisted
  // boolean/string "false" as present, so this flag needs real boolean parsing, not a presence check.
  private toBoolean(value: any): boolean {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') return value.toLowerCase() === 'true';
    return !!value;
  }

  // Mirrors ResolvePayFieldGatewayDetails's ApiKey/ApiSecret fallback chain server-side. Uses
  // hasCredentialValue per-candidate (not ||) so a whitespace-only value doesn't shadow a real fallback.
  private getPayFieldsTransactionsApiKey(): string {
    return [this.credentials?.ApiKey, this.credentials?.PayFieldApiKey, this.credentials?.PAYFIELDSTRANSACTIONSAPIKEY]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  private getPayFieldsTransactionsApiSecret(): string {
    return [this.credentials?.ApiSecret, this.credentials?.PayFieldApiSecret, this.credentials?.PAYFIELDSTRANSACTIONSAPISECRET]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  private getPayFieldsIntegrationUrl(): string {
    return [this.credentials?.PAYFIELDSAPIIntegrationURL, this.credentials?.PayFieldIntegrationURL]
      .find((v) => this.hasCredentialValue(v)) ?? '';
  }

  private getPayFieldsTokenizationApiKey(): string {
    return [this.credentials?.PayFieldsAPIKey, this.credentials?.PayFieldApiKey]
      .find((value) => this.hasCredentialValue(value)) ?? '';
  }

  private getPayFieldsEnvironment(): string {
    const raw = ([this.credentials?.PayFieldEnvironment, this.credentials?.PayFieldModeAddOn, this.credentials?.Environment]
      .find((value) => this.hasCredentialValue(value)) ?? 'test').toString().trim().toLowerCase();
    if (['local', 'dev', 'pqa', 'qa', 'test', 'prod'].includes(raw)) {
      return raw;
    }
    if (raw === 'production') { return 'prod'; }
    if (raw === 'sandbox') { return 'test'; }
    return 'test';
  }

  private buildPayFieldsRefundGatewayDetails(): string {
    return JSON.stringify({
      PayFieldReferenceVersion: 2,
      XWebId: this.credentials?.PAYFIELDSXWEBID ?? '',
      XWebTerminalId: this.credentials?.PAYFIELDSXWEBTERMINALID ?? '',
      XWebAuthKey: this.credentials?.PAYFIELDSXWEBAUTHKEY ?? '',
      PayField: true,
      Environment: this.getPayFieldsEnvironment(),
      Region: ([this.credentials?.PayFieldMerchantCountry, this.credentials?.Region, this.credentials?.PayFieldRegion]
        .find(value => this.hasCredentialValue(value)) ?? '').toString(),
      ApiSecret: this.getPayFieldsTransactionsApiSecret()
    });
  }

  // Mirrors EdgeExpressBusiness.ResolvePayFieldCurrencyCode's configured-code-then-region fallback so
  // the embedded modal shows the same currency the backend actually charges in, not a hardcoded "$".
  // Uses hasCredentialValue per-candidate (not ||) so a whitespace-only value doesn't shadow a real fallback.
  protected getPayFieldCurrencySymbol(): string {
    const configuredCurrencyCode = ([this.credentials?.PayFieldCurrencyCode, this.credentials?.CurrencyCode, this.credentials?.PayFieldCurrency, this.credentials?.Currency]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString().trim();
    if (configuredCurrencyCode === '124') {
      return 'C$';
    }
    if (configuredCurrencyCode === '840') {
      return '$';
    }

    const configuredCountryCode = ([this.credentials?.PayFieldCountryCode, this.credentials?.CountryCode, this.credentials?.PayFieldTransactionCountryCode]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString().trim().toUpperCase();
    if (configuredCountryCode === '124' || configuredCountryCode === 'CA' || configuredCountryCode === 'CAN' || configuredCountryCode === 'CANADA') {
      return 'C$';
    }
    if (configuredCountryCode === '840' || configuredCountryCode === 'US' || configuredCountryCode === 'USA' || configuredCountryCode === 'UNITED STATES') {
      return '$';
    }

    const region = ([this.credentials?.PayFieldMerchantCountry, this.credentials?.Region, this.credentials?.PayFieldRegion]
      .find((v) => this.hasCredentialValue(v)) ?? '').toString().trim().toUpperCase();
    return (region === '124' || region === 'CA' || region === 'CAN' || region === 'CANADA') ? 'C$' : '$';
  }

  // Mirrors payment.component.ts's canUseOpenEdgePayFieldsRuntime — the card-entry form tokenizes
  // client-side, so refund eligibility needs the tokenization key too, not just the Transactions API creds.
  private canUseOpenEdgePayFieldsCreditRuntime(): boolean {
    if (this.paymentGateway !== EPaymentGateway.OpenEdgeExpress || !this.credentials) {
      return false;
    }
    if (!this.toBoolean(this.credentials.EnablePayFieldPayment ?? this.credentials.EnabledPayFieldPayment)) {
      return false;
    }
    return this.hasCredentialValue(this.credentials.PAYFIELDSXWEBID)
      && this.hasCredentialValue(this.credentials.PAYFIELDSXWEBTERMINALID)
      && this.hasCredentialValue(this.credentials.PAYFIELDSXWEBAUTHKEY)
      && this.hasCredentialValue(this.getPayFieldsIntegrationUrl())
      && this.hasCredentialValue(this.getPayFieldsTransactionsApiKey())
      && this.hasCredentialValue(this.getPayFieldsTransactionsApiSecret())
      && this.hasCredentialValue(this.getPayFieldsTokenizationApiKey());
  }

  // ── PayFields unlinked-credit refund: card-entry form lifecycle ──────────────

  private openPayFieldsCreditForm(amount: any, payId: number): void {
    const activeElement = document.activeElement;
    this.payFieldsCreditFocusOrigin = activeElement instanceof HTMLElement ? activeElement : null;
    this.payFieldsCreditPendingAmount = Number(amount);
    this.payFieldsCreditPayId = payId;
    this.payFieldsCreditBillingDetails = {
      firstName: '',
      middleName: '',
      lastName: '',
      addressOne: '',
      addressTwo: '',
      city: '',
      countryId: environment.defaultCountryId,
      stateId: 0,
      postalCode: ''
    };
    this.showPayFieldsCreditForm = true;
    this.isPayFieldsCreditFormReady = false;
    this.isAutoPopulateBillingInfo = false;
    this.loaderIcon = Promise.resolve(false);
    if (this.countryList.length === 0) {
      this.generalService.getCountries().subscribe({
        next: (response: any[]) => {
          this.countryList = response;
          // Country APIs don't return an IsoCode field natively — without this, Country always fell back to 'US' below.
          this.commonMethod.mapCountryIsoCode(this.countryList);
          this.onPayFieldsCreditCountryChange(this.payFieldsCreditBillingDetails.countryId);
        },
        error: () => {
          this.toastr.error('Unable to load countries. Please retry.', 'PayFields Error', this.toasterConfig);
        }
      });
    } else {
      this.onPayFieldsCreditCountryChange(this.payFieldsCreditBillingDetails.countryId);
    }
    setTimeout(() => {
      this.initializePayFieldsCreditForm();
      this.initializePayFieldsCreditFocusTrap();
    }, 0);
  }

  private initializePayFieldsCreditFocusTrap(canRetry: boolean = true): void {
    const dialog = this.payFieldsCreditDialog?.nativeElement;
    if (!dialog) {
      if (canRetry && this.showPayFieldsCreditForm) {
        this.payFieldsCreditFocusTrapRetryTimer = setTimeout(() => this.initializePayFieldsCreditFocusTrap(false), 0);
      }
      return;
    }
    this.payFieldsCreditFocusTrap?.destroy();
    this.payFieldsCreditFocusTrap = this.focusTrapFactory.create(dialog);
    this.payFieldsCreditFocusTrap.focusInitialElementWhenReady();
  }

  // Focus trap keeps keyboard-only users inside the dialog, so Escape must be handled explicitly to let them cancel out.
  @HostListener('document:keydown.escape', ['$event'])
  onPayFieldsCreditEscapeKeydown(event: KeyboardEvent): void {
    if (!this.showPayFieldsCreditForm || this.isPayFieldsCreditTokenPending || this.isPayFieldsCreditSubmitPending) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    this.cancelPayFieldsCreditForm();
  }

  onPayFieldsCreditCountryChange(id): void {
    const previousStateId = this.payFieldsCreditBillingDetails.stateId;
    this.payFieldsCreditBillingDetails.stateId = 0;
    if (id == 1 || id == 2) {
      this.emptyStateList = false;
      this.generalService.getStates(id).subscribe({
        next: (response: any[]) => {
          // Guard against a stale response from a superseded country selection (rapid switching).
          if (this.payFieldsCreditBillingDetails.countryId !== id) {
            return;
          }
          this.stateList = response;
          const selectedStateIsValid = response?.some((state: any) => Number(state.Id) === Number(previousStateId));
          if (selectedStateIsValid) {
            this.payFieldsCreditBillingDetails.stateId = previousStateId;
          }
        },
        error: () => {
          this.toastr.error('Unable to load states/provinces. Please retry.', 'PayFields Error', this.toasterConfig);
        }
      });
    } else {
      this.emptyStateList = true;
      this.stateList = [];
    }
  }

  onPayFieldsCreditAutoPopulateChange(): void {
    if (this.isAutoPopulateBillingInfo && this.customerInfoPresent && this.customerInfo) {
      this.payFieldsCreditBillingDetails.firstName = this.customerInfo.FirstName || '';
      this.payFieldsCreditBillingDetails.middleName = this.customerInfo.MiddleName || '';
      this.payFieldsCreditBillingDetails.lastName = this.customerInfo.LastName || '';
      this.payFieldsCreditBillingDetails.addressOne = this.customerInfo.AddressOne || '';
      this.payFieldsCreditBillingDetails.addressTwo = '';
      this.payFieldsCreditBillingDetails.city = this.customerInfo.City || '';
      this.payFieldsCreditBillingDetails.postalCode = this.customerInfo.PostalCode || '';
      this.payFieldsCreditBillingDetails.countryId = this.customerInfo.CountryId || environment.defaultCountryId;
      this.payFieldsCreditBillingDetails.stateId = this.customerInfo.StateId || 0;
    } else {
      this.payFieldsCreditBillingDetails.firstName = '';
      this.payFieldsCreditBillingDetails.middleName = '';
      this.payFieldsCreditBillingDetails.lastName = '';
      this.payFieldsCreditBillingDetails.addressOne = '';
      this.payFieldsCreditBillingDetails.addressTwo = '';
      this.payFieldsCreditBillingDetails.city = '';
      this.payFieldsCreditBillingDetails.postalCode = '';
      this.payFieldsCreditBillingDetails.countryId = environment.defaultCountryId;
      this.payFieldsCreditBillingDetails.stateId = 0;
    }
    this.onPayFieldsCreditCountryChange(this.payFieldsCreditBillingDetails.countryId);
  }

  cancelPayFieldsCreditForm(): void {
    if (!this.showPayFieldsCreditForm || this.isPayFieldsCreditTokenPending || this.isPayFieldsCreditSubmitPending) {
      return;
    }
    this.failPayFieldsCreditTokenization('Transaction Cancelled By User');
  }

  closePayFieldsCreditForm(): void {
    this.showPayFieldsCreditForm = false;
    this.disposePayFieldsCreditForm();
    this.loaderIcon = Promise.resolve(false);
  }

  private initializePayFieldsCreditForm(): void {
    if (!this.showPayFieldsCreditForm || this.payFieldsCreditSecureForm) {
      return;
    }

    this.payFieldsSdkLoader.load()
      .then(() => this.buildPayFieldsCreditForm())
      .catch(() => {
        this.toastr.error('GlobalPayments SDK is not available.', 'PayFields Error', this.toasterConfig);
      });
  }

  private buildPayFieldsCreditForm(): void {
    if (!this.showPayFieldsCreditForm || this.payFieldsCreditSecureForm) {
      return;
    }

    const tokenizationApiKey = this.getPayFieldsTokenizationApiKey();
    if (!tokenizationApiKey) {
      this.toastr.error('PayFields API key is missing in gateway settings.', 'PayFields Error', this.toasterConfig);
      return;
    }

    try {
      GlobalPayments.configure({
        'X-GP-Api-Key': tokenizationApiKey,
        'X-GP-Environment': this.getPayFieldsEnvironment()
      });

      this.payFieldsCreditSecureForm = GlobalPayments.ui.form({
        fields: {
          'card-number': { target: '#refund-payfields-card-number', placeholder: 'Card Number', required: true },
          'card-expiration': { target: '#refund-payfields-card-expiration', placeholder: 'MM / YYYY', required: true },
          'card-cvv': { target: '#refund-payfields-card-cvv', placeholder: 'CVV', required: true },
          submit: { target: '#refund-payfields-submit-host', text: 'Submit' }
        },
        styles: {
          input: {
            border: '0px',
            outline: 'none',
            'box-shadow': 'none',
            background: 'transparent',
            'font-size': '14px',
            'font-family': 'Lato, sans-serif',
            color: '#2a2a2a',
            'line-height': '20px',
            'user-select': 'text'
          },
          'input:focus': {
            border: '0px',
            outline: 'none',
            'box-shadow': 'none'
          },
          '::placeholder': {
            color: '#6c757d'
          }
        }
      });

      this.payFieldsCreditCardValidity = { number: false, expiration: false, cvv: false };
      const form = this.payFieldsCreditSecureForm;
      form.frames['card-number']?.on('card-number-test', (result: any) => {
        if (this.payFieldsCreditSecureForm === form) {
          this.payFieldsCreditCardValidity.number = result?.valid === true;
        }
      });
      form.frames['card-expiration']?.on('card-expiration-test', (result: any) => {
        if (this.payFieldsCreditSecureForm === form) {
          this.payFieldsCreditCardValidity.expiration = result?.valid === true;
        }
      });
      form.frames['card-cvv']?.on('card-cvv-test', (result: any) => {
        if (this.payFieldsCreditSecureForm === form) {
          this.payFieldsCreditCardValidity.cvv = result?.valid === true;
        }
      });
      this.payFieldsCreditSecureForm.ready(() => {
        this.isPayFieldsCreditFormReady = true;
      });
      this.watchPayFieldsCreditIframes();
    } catch (error) {
      this.toastr.error('Unable to initialize PayFields form.', 'PayFields Error', this.toasterConfig);
    }
  }

  // Mirrors payment.component.ts's watchPayFieldsIframes — rewrites the SDK's root-relative
  // '/SecureSubmit.v1/...' iframe src to the PayFields CDN host, scoped to this dialog only.
  private watchPayFieldsCreditIframes(): void {
    const container = this.payFieldsCreditDialog?.nativeElement;
    if (!container) {
      return;
    }
    const fixIframeSrc = (el: HTMLIFrameElement) => {
      if (el.src && el.src.startsWith(location.origin + '/SecureSubmit.v1/')) {
        el.src = el.src.replace(location.origin, 'https://js.paygateway.com');
      }
    };
    const fixIframesInNode = (node: Node) => {
      if (node instanceof HTMLIFrameElement) {
        fixIframeSrc(node);
      }
      if (node instanceof Element) {
        node.querySelectorAll('iframe').forEach((iframe: HTMLIFrameElement) => fixIframeSrc(iframe));
      }
    };
    fixIframesInNode(container);
    this.payFieldsCreditIframeObserver?.disconnect();
    this.payFieldsCreditIframeObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          fixIframesInNode(node);
        });
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLIFrameElement) {
          fixIframeSrc(mutation.target);
        }
      }
    });
    this.payFieldsCreditIframeObserver.observe(container, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
  }

  private disposePayFieldsCreditForm(): void {
    this.payFieldsCreditIframeObserver?.disconnect();
    this.payFieldsCreditIframeObserver = null;
    this.clearPayFieldsCreditWatchdog();
    this.detachPayFieldsCreditFormListeners();
    if (this.payFieldsCreditFocusTrapRetryTimer) {
      clearTimeout(this.payFieldsCreditFocusTrapRetryTimer);
      this.payFieldsCreditFocusTrapRetryTimer = null;
    }
    this.payFieldsCreditFocusTrap?.destroy();
    this.payFieldsCreditFocusTrap = null;
    const focusOrigin = this.payFieldsCreditFocusOrigin;
    this.payFieldsCreditFocusOrigin = null;
    if (focusOrigin?.isConnected) {
      focusOrigin.focus();
    }
    if (this.payFieldsCreditSecureForm && this.payFieldsCreditSecureForm.dispose) {
      this.payFieldsCreditSecureForm.dispose();
    }
    this.payFieldsCreditSecureForm = null;
    this.isPayFieldsCreditFormReady = false;
    this.payFieldsCreditCardValidity = { number: false, expiration: false, cvv: false };
    this.isPayFieldsCreditTokenPending = false;
    this.isPayFieldsCreditSubmitPending = false;
    this.payFieldsCreditRequestId = null;
  }

  private detachPayFieldsCreditFormListeners(): void {
    const listeners = this.payFieldsCreditFormListeners;
    if (!listeners || !listeners.form?.off) {
      this.payFieldsCreditFormListeners = null;
      return;
    }
    listeners.form.off('token-success', listeners.tokenSuccess);
    listeners.form.off('token-error', listeners.tokenError);
    listeners.form.off('error', listeners.error);
    this.payFieldsCreditFormListeners = null;
  }

  private generatePayFieldsCreditRequestId(): string {
    return `pfc-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  }

  private startPayFieldsCreditWatchdog(requestId: string): void {
    this.clearPayFieldsCreditWatchdog();
    this.payFieldsCreditWatchdogTimer = setTimeout(() => {
      if (this.payFieldsCreditRequestId === requestId && this.isPayFieldsCreditTokenPending) {
        this.failPayFieldsCreditTokenization('Card tokenization timed out. Please retry.');
      }
    }, this.PAYFIELDS_CREDIT_TOKEN_TIMEOUT_MS);
  }

  private clearPayFieldsCreditWatchdog(): void {
    if (this.payFieldsCreditWatchdogTimer) {
      clearTimeout(this.payFieldsCreditWatchdogTimer);
      this.payFieldsCreditWatchdogTimer = null;
    }
  }

  private isPayFieldsCreditBillingValid(): boolean {
    return !!(
      this.payFieldsMandatoryFieldsLoaded &&
      this.payFieldsCreditBillingDetails.firstName?.trim() &&
      this.payFieldsCreditBillingDetails.lastName?.trim() &&
      this.payFieldsCreditBillingDetails.addressOne?.trim() &&
      this.payFieldsCreditBillingDetails.city?.trim() &&
      this.payFieldsCreditBillingDetails.countryId &&
      (this.emptyStateList ||
        (!this.payFieldsStateRequired && (!this.payFieldsCreditBillingDetails.stateId || this.payFieldsCreditBillingDetails.stateId == 0)) ||
        this.stateList?.some((item) => item.Id == this.payFieldsCreditBillingDetails.stateId && item.Code?.trim())) &&
      this.payFieldsCreditBillingDetails.postalCode?.trim()
    );
  }

  isPayFieldsCreditSubmitDisabled(): boolean {
    return !this.isPayFieldsCreditFormReady || this.isPayFieldsCreditTokenPending || this.isPayFieldsCreditSubmitPending || !this.isPayFieldsCreditBillingValid()
      || !this.payFieldsCreditCardValidity.number || !this.payFieldsCreditCardValidity.expiration || !this.payFieldsCreditCardValidity.cvv;
  }

  submitPayFieldsCreditForm(): void {
    if (this.isPayFieldsCreditTokenPending || this.isPayFieldsCreditSubmitPending) {
      this.toastr.warning('Tokenization is in progress. Please wait.', 'Please Wait', this.toasterConfig);
      return;
    }
    if (!this.isPayFieldsCreditBillingValid()) {
      this.toastr.warning('Please complete required customer information.', 'Validation', this.toasterConfig);
      return;
    }
    if (!this.payFieldsCreditSecureForm || !this.isPayFieldsCreditFormReady) {
      this.toastr.warning('PayFields form is still loading. Please wait and retry.', 'Please Wait', this.toasterConfig);
      return;
    }
    if (!this.payFieldsCreditCardValidity.number || !this.payFieldsCreditCardValidity.expiration || !this.payFieldsCreditCardValidity.cvv) {
      this.toastr.warning('Please complete card number, expiration and CVV.', 'Validation', this.toasterConfig);
      return;
    }

    const requestId = this.generatePayFieldsCreditRequestId();
    this.payFieldsCreditRequestId = requestId;
    this.isPayFieldsCreditTokenPending = true;
    this.loaderIcon = Promise.resolve(true);
    this.startPayFieldsCreditWatchdog(requestId);

    const submittingForm = this.payFieldsCreditSecureForm;
    this.detachPayFieldsCreditFormListeners();
    const onResult = (result: any) => this.handlePayFieldsCreditTokenResult(submittingForm, requestId, result);
    const tokenSuccessListener = (result: any) => onResult(result);
    const tokenErrorListener = (result: any) => onResult({ error: { message: result?.error?.message || 'Tokenization failed.' } });
    const errorListener = (result: any) => onResult({ error: { message: result?.reasons?.[0]?.message || 'Tokenization failed.' } });
    submittingForm.on('token-success', tokenSuccessListener);
    submittingForm.on('token-error', tokenErrorListener);
    submittingForm.on('error', errorListener);
    this.payFieldsCreditFormListeners = { form: submittingForm, tokenSuccess: tokenSuccessListener, tokenError: tokenErrorListener, error: errorListener };

    const submitFrame = (this.payFieldsCreditSecureForm as any)?.frames?.submit;
    if (submitFrame && submitFrame.emit) {
      submitFrame.emit('click');
      return;
    }
    this.failPayFieldsCreditTokenization('PayFields submit control was not initialized.');
  }

  private handlePayFieldsCreditTokenResult(submittingForm: any, requestId: string, result: any): void {
    if (!this.isPayFieldsCreditTokenPending || submittingForm !== this.payFieldsCreditSecureForm || requestId !== this.payFieldsCreditRequestId) {
      return;
    }
    this.clearPayFieldsCreditWatchdog();

    if (!result || result.error) {
      this.failPayFieldsCreditTokenization(result?.error?.message ?? 'Card tokenization failed. Please retry.');
      return;
    }

    this.isPayFieldsCreditTokenPending = false;
    const token = this.resolvePayFieldsCreditTokenValue(result);
    if (!token) {
      this.failPayFieldsCreditTokenization('Tokenization completed but temporary token is missing.');
      return;
    }
    // Keep Submit disabled until CallPayFieldCredit resolves - clearing isPayFieldsCreditTokenPending above
    // alone re-enables it while the credit request is still in flight, risking a duplicate credit.
    this.isPayFieldsCreditSubmitPending = true;
    this.completePayFieldsCreditRefund(token);
  }

  private failPayFieldsCreditTokenization(reason: string): void {
    this.closePayFieldsCreditForm();
    this.isPayFieldsCreditTokenPending = false;
    this.payFieldsCreditRequestId = null;
    this.detachPayFieldsCreditFormListeners();
    this.loaderIcon = Promise.resolve(false);
    this.toastr.warning(reason, 'PayFields Error', this.toasterConfig);

    // saveInCCT already created an "Attempting to Process" CCT row before this dialog opened —
    // record a declined failure row here too, mirroring the legacy HostedPage failure paths,
    // so a tokenization failure/timeout doesn't leave that row stuck.
    const paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
    this.currentPayId = this.payFieldsCreditPayId;
    const row = this.refundTable.find(o => o.payId == this.payFieldsCreditPayId);
    if (row) {
      row.payFailed = true;
    }
    this.saveCCTransactionFailureCase({ PaymentModeId: EPaymentModes.HostedPage, RESULT: { RESPONSEDESCRIPTION: reason } }, reason, paymentTrnsId);
  }

  private resolvePayFieldsCreditTokenValue(result: any): string | null {
    const candidates = [
      result?.temporary_token,
      result?.temporaryToken,
      result?.token,
      result?.paymentReference,
      result?.id
    ];
    for (const candidate of candidates) {
      if (typeof candidate === 'string' && candidate.trim().length > 0) {
        return candidate.trim();
      }
    }
    return null;
  }

  // Submits a freshly tokenized card as an independent return, without the original sale identifier.
  private completePayFieldsCreditRefund(temporaryToken: string): void {
    const amount = this.payFieldsCreditPendingAmount;
    const payId = this.payFieldsCreditPayId;
    const paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
    const row = this.refundTable.find(o => o.payId == payId);
    const country = this.countryList?.find((item) => item.Id == this.payFieldsCreditBillingDetails.countryId);
    const state = this.stateList?.find((item) => item.Id == this.payFieldsCreditBillingDetails.stateId);
    row['payFieldGatewayDetails'] = row['payFieldGatewayDetails'] || this.buildPayFieldsRefundGatewayDetails();

    const creditPayload = {
      FacilityId: this.processRefund.facId,
      Amount: amount,
      InvoiceNumber: row.orderId,
      OrderId: row.orderId,
      TemporaryToken: temporaryToken,
      FirstName: this.payFieldsCreditBillingDetails.firstName,
      MiddleName: this.payFieldsCreditBillingDetails.middleName,
      LastName: this.payFieldsCreditBillingDetails.lastName,
      Address1: this.payFieldsCreditBillingDetails.addressOne,
      Address2: this.payFieldsCreditBillingDetails.addressTwo,
      City: this.payFieldsCreditBillingDetails.city,
      State: state?.Code || '',
      PostalCode: this.payFieldsCreditBillingDetails.postalCode,
      Country: country?.IsoCode || 'US'
    };

    this.paymentService.CallPayFieldCredit(creditPayload).subscribe((response: any) => {
      this.loaderIcon = Promise.resolve(false);
      this.isPayFieldsCreditSubmitPending = false;
      try {
        const gatewayResponse = response?.GatewayResponse ? JSON.parse(response.GatewayResponse) : null;
        const status = String(gatewayResponse?.status ?? '').toLowerCase();
        const approvedStatuses = ['approved', 'approved - avs mismatch', 'approved - csc mismatch',
          'approved - avs & csc mismatch', 'approved - token creation failed'];
        const returnId = gatewayResponse?.return_id;
        if (typeof returnId === 'string' && returnId.trim().length > 0 && approvedStatuses.includes(status) &&
          [200, 201].includes(response?.ResponseCode) && response?.Success) {
          row['processedCNPCC'] = {
            APPROVEDAMOUNT: amount,
            MASKEDCARDNUMBER: gatewayResponse.card?.masked_card_number || gatewayResponse.card?.last_four || '',
            CARDBRAND: gatewayResponse.card?.type || '',
            CUSTOMERNAME: gatewayResponse.card?.cardholder_name || '',
            EXPMONTH: gatewayResponse.card?.expiry_month || 275,
            EXPYEAR: gatewayResponse.card?.expiry_year || 2099,
            ADDRESS1: this.payFieldsCreditBillingDetails.addressOne,
            BILLINGPOSTALCODE: this.payFieldsCreditBillingDetails.postalCode,
            // Keep the backend-normalized merchant reference separate from the gateway return identifier.
            TRANSACTIONID: response?.ReferenceId || creditPayload.OrderId || creditPayload.InvoiceNumber,
            CREDITID: returnId,
            RESPONSECODE: response?.ResponseCode || 200,
            RESPONSEDESCRIPTION: gatewayResponse.status || 'Approved',
            ORIGINALRESPONSEDESCRIPTION: gatewayResponse.status || 'Approved',
            CARDTYPE: 'Credit',
            BATCHNO: null,
            RECEIPTTEXT: gatewayResponse.receipt?.text?.merchant_receipt || null
          };
          this.paymentSuccessFul = true;
          this.payStatus = 'Success';
          this.currentPayId = payId;
          row.payFailed = false;
          this.closePayFieldsCreditForm();
          this.gotoPaymentSuccess(this.aftePay, amount);
        } else {
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed';
          this.currentPayId = payId;
          row.payFailed = true;
          const reason = gatewayResponse?.error ? `${gatewayResponse.error.message}:${gatewayResponse.error.code}` : (gatewayResponse?.status || 'Declined');
          this.closePayFieldsCreditForm();
          this.toastr.warning(`${reason} - Please submit Refund as Offline or Contact Administrator.`, 'Alert', this.toasterConfig);
          this.saveCCTransactionFailureCase({ PaymentModeId: EPaymentModes.HostedPage, RESULT: { RESPONSEDESCRIPTION: reason } }, reason, paymentTrnsId);
        }
      } catch (e) {
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed';
        this.currentPayId = payId;
        row.payFailed = true;
        this.closePayFieldsCreditForm();
        this.toastr.error('Gateway Rejected!', 'Alert', this.toasterConfig);
        this.saveCCTransactionFailureCase({ PaymentModeId: EPaymentModes.HostedPage, RESULT: { RESPONSEDESCRIPTION: 'Invalid gateway response' } }, 'Invalid gateway response', paymentTrnsId);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.isPayFieldsCreditSubmitPending = false;
      this.paymentSuccessFul = false;
      this.payStatus = 'Failed';
      this.currentPayId = payId;
      row.payFailed = true;
      this.closePayFieldsCreditForm();
      const reason = err?.error ? `${err.error.message}:${err.error.code}` : 'Decline';
      this.toastr.error('Gateway Rejected!', 'Alert', this.toasterConfig);
      this.saveCCTransactionFailureCase({ PaymentModeId: EPaymentModes.HostedPage, RESULT: { RESPONSEDESCRIPTION: reason } }, reason, paymentTrnsId);
    });
  }

  ngOnDestroy(): void {
    this.disposePayFieldsCreditForm();
  }

  setMandatoryFieldHostedPage() {
    this.payFieldsMandatoryFieldsLoaded = false;
    this.payFieldsStateRequired = false;
    this.generalService.GetMandatoryFields(this.userSessionService.userSessionData.LastAccessedStoreId, this.componentName, 'tdAutopayForm')
      .subscribe((response: IGetPermissionMandatoryField) => {
        const data = response;
        this.payFieldsMandatoryFieldsLoaded = Array.isArray(data?.Form?.ListOfProperties);
        this.payFieldsStateRequired = this.payFieldsMandatoryFieldsLoaded && data.Form.ListOfProperties.some(field => field.Name == 'tdState' && field.Required);
        if (this.payFieldsMandatoryFieldsLoaded && data.Form.ListOfProperties.length) {
          if ([EPaymentGateway.TdBank, EPaymentGateway.Stripe].includes(this.paymentGateway)) {
            this.mandatoryFieldsList = data.Form.ListOfProperties;
          }
        }
      }, () => {
        this.toastr.error('Unable to load mandatory field settings. Please refresh and try again.', 'Settings Error', this.toasterConfig);
      });
  }

  batchInquiry(batchModel) {
    this.gatewayService.batchInquiry(batchModel).subscribe((res) => {
    });
  }

  onCheckCancel() {
    this.checkNo = null;
    this.checkDate = new Date();
    this.checkBank = '';
    this.checkModalRef.hide();
  }

  onDisableCheck() {
    if (this.amountFieldforcheck && (this.amountToPay == null || this.amountToPay === 0)) {
      return true;
    }
    if (this.checknumberField && (this.checkNo == null || (this.checkNo.toString().trim() === ''))) {
      return true;
    }
    if (this.checkdatefield && (this.checkDate == null)) {
      return true;
    }
    if (this.checkbankname && (this.checkBank == null || this.checkBank.trim() === '')) {
      return true;
    }

    return false;
  }
  
  notCreditCardPayment(transList) {
    if (transList && transList.length && transList.findIndex(o => o.PaymentModeId == 3) == -1) {
      return true;
    }
    return false;
  }

  onSkipRefund() {
    this.skipModalRef.hide();
    this.refundData.emit(null);
  }

  getExpiryMonthValue(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = tempMonth + expiryMonth;
      } else if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = 264;
      }
    } else {
      expiryMonth = 264;
    }
    return expiryMonth;
  }

  getTerminalDevices() {
    this.loaderIcon = Promise.resolve(true);
    this.terminalDevicesList = [];
    this.facilityservice.getTerminalDevicesForOp(this.processRefund.facId)
      .subscribe((response: IDeviceSetting[]) => {
        if (response) {
          this.terminalDevicesList = response;
          this.loaderIcon = Promise.resolve(false);
          if (this.terminalDevicesList.length && this.terminalDevicesList.length > 1) {
            if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
              if (this.isDebitCard) {
                this.modalRefSelectDevice = this.modalService.show(this.selectDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
              } else {
                let terminalDeviceId = this.processRefund.TransactionList.map(item => { return item.TerminalDeviceId; });
                this.selectedDeviceId = terminalDeviceId[0] ? terminalDeviceId[0] : null
                this.onSelectDevice();
              }
            } else if (this.paymentGateway == EPaymentGateway.TdBank) {
              this.modalRefSelectDevice = this.modalService.show(this.selectDevicePopup, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });
            }
          } else if (this.terminalDevicesList.length && this.terminalDevicesList.length == 1) {
            let terminalDeviceId = this.processRefund.TransactionList.map(item => { return item.TerminalDeviceId; });
            this.selectedDeviceId = terminalDeviceId[0] ? terminalDeviceId[0] : null;
            if (!this.selectedDeviceId) {
              this.selectedDeviceId = this.terminalDevicesList[0].Id;
            }
          }
        } else {
          this.loaderIcon = Promise.resolve(false);
        }
      },
        () => {
          this.terminalDevicesList = [];
          this.loaderIcon = Promise.resolve(false);
        });
  }

  onSelectDevice() {
    if (this.selectedDeviceId !== null) {
      if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress) {
        let deviceObj = this.terminalDevicesList.find(o => o.Id == this.selectedDeviceId);
        this.credentials.XWEBTERMINALID = deviceObj.WebId;
        this.credentials.XWEBAUTHKEY = deviceObj.AuthKey;
      }
      if (this.modalRefSelectDevice) {
        this.modalRefSelectDevice.hide();
      }
    } else if (this.paymentGateway == EPaymentGateway.OpenEdgeExpress && this.selectedDeviceId == null && this.terminalDevicesList.length > 0) {
      this.selectedDeviceId = this.terminalDevicesList.find(o => o.AuthKey == this.credentials.XWEBAUTHKEY && o.WebId == this.credentials.XWEBTERMINALID).Id;
    }
  }

  OnCardcancel() {
    this.modalRefSelectDevice.hide();
  }

  cardOnFileEdgeReturn(amt, cctid, payId, uniqueTransId, paymentTrnsId) {
    this.refundInProgress = true;
    this.loaderIcon = Promise.resolve(true);
    const transId = this.refundTable.find(o => o.payId == payId).transactionId;
    let payModel: IPaymentGatewayModel = {
      FacilityId: this.processRefund.facId,
      OrderId: uniqueTransId, //Here order id is unique transaction id
      Alias: this.autoPayInfo.PaymentAccountId,
      CreditCardDetails: {
        CardType: 'CreditCard',
        CardNumber: this.autoPayInfo.CreditCardNumber,
        ExpiryDate: this.getOriginalExpiryMonth(this.autoPayInfo.CreditCardExpiryMonth) + "" + this.autoPayInfo.CreditCardExpiryYear,
        CardCode: this.autoPayInfo.CreditCardType,
        BillingAddress: this.autoPayInfo.CreditCardBillingAddress,
        Zip: (this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : (this.Tenantinfo.Zip ? this.Tenantinfo.Zip : (this.Tenantinfo.BusinessAccount && this.Tenantinfo.CompanyZip ? this.Tenantinfo.CompanyZip : null)))
      },
      GatewayAttributesModel: {
        CardPresent: false,
        CustomerPresent: false,
        PinCapabilities: false,
        DuplicateMode: true,
        CreateAlias: false
      },
      TransactionId: '',
      Amount: amt
    }

    this.gatewayService.paymentReversal(payModel).subscribe((response: any) => {
      if (response && response.Success) {
        this.loaderIcon = Promise.resolve(false);
        this.paymentSuccessFul = true;
        this.payStatus = 'Success';
        this.refundTable.find(o => o.payId === payId).payComplete = true;
        const responseData = JSON.parse(response.GatewayResponse);
        if (responseData) { //Success
          let expMonth = responseData.GatewayResponse.ExpDate ? responseData.GatewayResponse.ExpDate.substring(0, 2) : this.getOriginalExpiryMonth(this.autoPayInfo.CreditCardExpiryMonth);
          let expYear = responseData.GatewayResponse.ExpDate ? responseData.GatewayResponse.ExpDate.substring(2) : this.autoPayInfo.CreditCardExpiryYear;
          let cTypeId;
          var cType = responseData.GatewayResponse.CardBrandShort;
          if (cType) {
            if (cType.toLowerCase() == 'ax') {
              cTypeId = 1;
            } else if (cType.toLowerCase() == 'vi') {
              cTypeId = 2;
            } else if (cType.toLowerCase() == 'mc') {
              cTypeId = 3;
            } else if (cType.toLowerCase() == 'nn') {
              cTypeId = 4;
            } else if (cType.toLowerCase() == 'di') {
              cTypeId = 5;
            } else if (cType.toLowerCase() == 'jb') {
              cTypeId = 6;
            }
          }
          const CCTModel = {
            Amount: responseData.GatewayResponse.Amount,
            Autopay: false,
            paymentModeId: EPaymentModes.CardOnfile,
            AutoCcProcessingDay: 0,
            CreditCardNumber: responseData.GatewayResponse.MaskedAcctNum == undefined ? 0 : responseData.GatewayResponse.MaskedAcctNum,
            CreditCardType: cTypeId ? cTypeId : this.autoPayInfo.CreditCardType ? this.autoPayInfo.CreditCardType : 2, // Visa 
            NameonCard: this.autoPayInfo ? this.autoPayInfo.NameonCard : '',
            CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(expMonth, 10)),
            CreditCardExpiryYear: parseInt(expYear, 10),
            CreditCardBillingAddress: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: (this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip : (this.Tenantinfo.Zip ? this.Tenantinfo.Zip : (this.Tenantinfo.BusinessAccount && this.Tenantinfo.CompanyZip ? this.Tenantinfo.CompanyZip : ''))),
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: response.TransactionId,
            ResponseCode: responseData.GatewayResponse.ResponseCode,
            Reason: responseData.GatewayResponse.ResponseDescription,
            Key: '',
            PaymentAccountid: this.autoPayInfo.PaymentAccountId,
            CcInfoPurged: false,
            DebitCardPayment: responseData.GatewayResponse.CardType == 'Credit' ? false : true,
            OfflinePayment: 0,
            UniqueTransId: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: cctid, //For Save CCT order id is cctid
            FacilityId: this.processRefund.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            CCBatchNumber: responseData && responseData.GatewayResponse.BatchNum ? responseData.GatewayResponse.BatchNum : null,
            TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
            LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
            EmvReceiptText: responseData.GatewayResponse && responseData.GatewayResponse.Receipt ? responseData.GatewayResponse.Receipt : null,
            GatewayDetails: this.requestGatewayDetails
          };
          this.refundTable.find(o => o.payId == payId)['processedCC'] = CCTModel;
          this.gotoPaymentSuccess(this.aftePay, amt);
        }
      } else {
        this.paymentSuccessFul = false;
        this.loaderIcon = Promise.resolve(false);
        const responseData = JSON.parse(response.GatewayResponse);
        if (responseData) { //Success
          let expMonth = responseData.GatewayResponse.ExpDate ? responseData.GatewayResponse.ExpDate.substring(0, 2) : this.getOriginalExpiryMonth(this.autoPayInfo.CreditCardExpiryMonth);
          let expYear = responseData.GatewayResponse.ExpDate ? responseData.GatewayResponse.ExpDate.substring(2) : this.autoPayInfo.CreditCardExpiryYear;
          let cTypeId = ECreditCards.Visa;
          var cType = responseData.GatewayResponse.CardBrandShort;
          if (cType) {
            if (cType.toLowerCase() == 'ax') {
              cTypeId = 1;
            } else if (cType.toLowerCase() == 'vi') {
              cTypeId = 2;
            } else if (cType.toLowerCase() == 'mc') {
              cTypeId = 3;
            } else if (cType.toLowerCase() == 'nn') {
              cTypeId = 4;
            } else if (cType.toLowerCase() == 'di') {
              cTypeId = 5;
            } else if (cType.toLowerCase() == 'jb') {
              cTypeId = 6;
            }
          }
          const CCTModel = {
            Amount: amt,
            Autopay: false,
            paymentModeId: EPaymentModes.CardOnfile,
            AutoCcProcessingDay: 0,
            CreditCardNumber: responseData.GatewayResponse.MaskedAcctNum == undefined ? 0 : responseData.GatewayResponse.MaskedAcctNum,
            CreditCardType: cTypeId ? cTypeId : this.autoPayInfo.CreditCardType,
            NameonCard: this.autoPayInfo ? this.autoPayInfo.NameonCard : '',
            CreditCardExpiryMonth: this.getExpiryMonthValue(parseInt(expMonth, 10)),
            CreditCardExpiryYear: parseInt(expYear, 10),
            CreditCardBillingAddress: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingAddress : '',
            CreditCardBillingZip: this.autoPayInfo ? this.autoPayInfo.CreditCardBillingZip : '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: response && response.TransactionId ? response.TransactionId : 0,
            ResponseCode: responseData.GatewayResponse.ResponseCode,
            Reason: responseData.GatewayResponse && responseData.GatewayResponse.ResponseDescription ? responseData.GatewayResponse.ResponseDescription : 'Declined',
            Key: '',
            PaymentAccountid: this.autoPayInfo.PaymentAccountId,
            CcInfoPurged: false,
            DebitCardPayment: responseData.GatewayResponse.CardType == 'Credit' ? false : true,
            OfflinePayment: 0,
            UniqueTransId: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: cctid,
            FacilityId: this.processRefund.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Declined,
            CCBatchNumber: responseData?.GatewayResponse?.BatchNum ?? null,
            TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
            LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
            EmvReceiptText: responseData?.GatewayResponse?.Receipt ?? null,
            GatewayDetails: this.requestGatewayDetails
          };
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
          this.gotoPaymentSuccess(this.aftePay, amt);
          this.toastr.error('Refund Failed', 'Failure');
        }
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.paymentSuccessFul = false;
      this.gotoPaymentSuccess(this.aftePay, amt);
      this.toastr.error('Refund Failed', 'Failure');
    });
  }

  returnTdPayment(amount, payId, paymentTrnsId) {
    this.refundInProgress = true;
    let returnPayment = {
      amount: amount,
      TransactionId: this.refundTable.find(o => o.payId == payId).transactionId,
    }
    this.paymentService.TdBankReturnPayment(returnPayment, this.credentials).subscribe((response: any) => {
      this.loaderIcon = Promise.resolve(false);
      if (response && response.message == 'Approved') {
        this.paymentSuccessFul = true;
        this.payStatus = 'Success';
        this.refundTable.find(o => o.payId === payId).payComplete = true;
        this.refundTable.find(o => o.payId == payId)['processedCC'] = response;
      } else {
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed';
        this.isAnyRefundProcessed();
        this.paymentFailReason = response.Message;
        let CCTModel;
        const tempCCModel = {
          Amount: amount,
          Autopay: false,
          paymentModeId: this.refundTable.find(o => o.payId == payId).payModeId,
          AutoCcProcessingDay: 0,
          CreditCardNumber: 'XXXX',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: this.refundTable.find(o => o.payId == payId).transactionId,
          ResponseCode: response.code ? response.code : '',
          Reason: response.Message,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: this.refundTable.find(o => o.payId == this.currentPayId).orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
          GatewayDetails: this.requestGatewayDetails
        };

        CCTModel = Object.assign(tempCCModel);
        this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => { });
      }
      this.gotoPaymentSuccess(this.aftePay, amount);
      this.toastr.error('Refund Failed', 'Failure');
    });
  }

  getCCTStatus(cctId, payId, count, paymentTrnsId, transactionType) {
    this.refundInProgress = true;
    let amount;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    this.paymentService.getCCTStatus(cctId).subscribe((res: any) => {
      if (res) {
        res = JSON.parse(res);
        if (this.subTD) {
          this.subTD.unsubscribe();
          this.subTD = null;
        }
        const responseData = res;
        if (this.cctStatusOrderId != cctId) {
          this.cctStatusOrderId = res.OrderId;
          if (transactionType == 'REFUND') {
            if (res.ResponseCode == '000') {
              this.paymentSuccessFul = true;
              this.payStatus = 'Success';
              amount = parseFloat(responseData.Amount);
              responseData.Amount = parseFloat(responseData.Amount);
              this.refundTable.find(o => o.payId === payId).payComplete = true;
              this.refundTable.find(o => o.payId == payId)['processedCC'] = responseData;
              this.gotoPaymentSuccess(this.aftePay, amount);
              this.loaderIcon = Promise.resolve(false);
            } else {
              if (res.ResponseCode == '95') { // 95 - device is in stand-alone mode  
                this.toastr.warning('Device is not ready to Accept any Payment. Please ensure Device is Idle and ready to Accept New Payment Request.', 'Alert', this.toasterConfig);
              } else if (res.Reason == 'Device is Busy, Please try after sometime.') { // Triggering multiple transaction          
                this.toastr.warning('Device is not ready to Accept Payment, Please try after sometime.', 'Alert', this.toasterConfig);
              } else if (res.Reason == "EMV Device Not Connected!") {
                this.paymentFailReason = 'EMV Device Not Connected';
              } else {
                this.toastr.error('Refund Failed', 'Failure');
              }
              this.payStatus = 'Failed';
              this.paymentSuccessFul = false;
              this.isAnyRefundProcessed();
              amount = 0;
              this.refundTable.find(o => o.payId === payId).payComplete = false;
              this.refundTable.find(o => o.payId == payId)['processedCC'] = res;
              this.paymentFailReason = res.Reason ? res.Reason : '';
              const tempCCModel = {
                Amount: responseData.Amount ? parseFloat(responseData.Amount) : 0,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
                CreditCardType: res.CreditCardType ? res.CreditCardType : 2, //Visa
                NameonCard: res.NameonCard ? res.NameonCard : " ",
                CreditCardExpiryMonth: res.CreditCardExpiryMonth == 264 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
                CreditCardExpiryYear: !parseInt(res.CreditCardExpiryYear, 10) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: res.AuthorizationCode ? res.AuthorizationCode : " ",
                ResponseCode: res.ResponseCode ? res.ResponseCode : '',
                Reason: res.Reason ? res.Reason : '',
                Key: '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: res.DebitCardPayment ? true : false,
                OfflinePayment: 0,
                UniqueTransId: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: this.refundTable.find(o => o.payId == payId).orderId,
                FacilityId: this.processRefund.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Declined,
                EmvReceiptText: res.EmvReceiptText ? res.EmvReceiptText : null,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
              };
              let CCTModel = Object.assign(tempCCModel);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              });
              this.gotoPaymentSuccess(this.aftePay, amount);
              this.loaderIcon = Promise.resolve(false);
            }
          } else {
            this.initiatedVoidCC = true;
            if (res.ResponseCode == '000') {
              const tempCCModel = {
                Amount: responseData.Amount ? parseFloat(responseData.Amount) : 0,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
                CreditCardType: res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
                NameonCard: res.NameonCard ? res.NameonCard : " ",
                CreditCardExpiryMonth: res.CreditCardExpiryMonth != 0 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
                CreditCardExpiryYear: !parseInt(res.CreditCardExpiryYear, 10) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: res.AuthorizationCode ? res.AuthorizationCode : " ",
                ResponseCode: res.ResponseCode ? res.ResponseCode : '',
                Reason: res.Reason ? res.Reason : '',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: res.DebitCardPayment ? true : false,
                OfflinePayment: 0,
                UniqueTransId: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: cctId,
                FacilityId: this.processRefund.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
                EmvReceiptText: res.EmvReceiptText ? res.EmvReceiptText : null,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
              };
              this.initiatedVoidCC = false;
              this.isCancel.emit(true);
              let CCTModel = Object.assign(tempCCModel);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              });
              this.toastr.success('Reversal of Refund Successful!', 'Success', this.toasterConfig);
            } else {
              const tempCCModel = {
                Amount: responseData.Amount ? parseFloat(responseData.Amount) : 0,
                Autopay: false,
                paymentModeId: EPaymentModes.CreditCard,
                AutoCcProcessingDay: 0,
                CreditCardNumber: res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
                CreditCardType: res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
                NameonCard: res.NameonCard ? res.NameonCard : " ",
                CreditCardExpiryMonth: res.CreditCardExpiryMonth != 0 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
                CreditCardExpiryYear: !parseInt(res.CreditCardExpiryYear, 10) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
                CreditCardBillingAddress: '',
                CreditCardBillingZip: '',
                SwipeTransaction: false,
                SecurityCodeSent: false,
                AuthorizationCode: res.AuthorizationCode ? res.AuthorizationCode : " ",
                ResponseCode: res.ResponseCode ? res.ResponseCode : '',
                Reason: res.Reason ? res.Reason : 'Declined!',
                PaymentAccountid: '',
                CcInfoPurged: false,
                DebitCardPayment: res.DebitCardPayment ? true : false,
                OfflinePayment: 0,
                UniqueTransId: 0,
                PaymentTransactionTypeId: paymentTrnsId,
                OrderId: cctId,
                FacilityId: this.processRefund.facId,
                TransactionDateTime: new Date(),
                TransactionTypeId: EPaymentTransactionType.Declined,
                EmvReceiptText: res.EmvReceiptText ? res.EmvReceiptText : null,
                TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
                TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
                LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
              };
              this.isCancel.emit(true);
              this.initiatedVoidCC = false;
              let CCTModel = Object.assign(tempCCModel);
              this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
              });
              this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
            }
          }
        }
        this.initiatedVoidCC = false;
      } else if (res == null) {
        if (count > maxTime) {
          if (this.subTD) {
            this.subTD.unsubscribe();
            this.subTD = null;
          }
          const tempCCModel = {
            Amount: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].Amount,
            Autopay: false,
            paymentModeId: EPaymentModes.CreditCard,
            AutoCcProcessingDay: 0,
            CreditCardNumber: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardNumber ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardNumber : 0,
            CreditCardType: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardType ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardType : ECreditCards.Visa,
            NameonCard: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].NameonCard ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].NameonCard : " ",
            CreditCardExpiryMonth: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryMonth != 0 ? this.getExpiryMonthValue(parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryMonth, 10)) : 275,
            CreditCardExpiryYear: !parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryYear, 10) ? 2099 : parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryYear, 10),
            CreditCardBillingAddress: '',
            CreditCardBillingZip: '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: "0",
            ResponseCode: '0',
            Reason: 'Declined!',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].DebitCardPayment == true ? true : false,
            OfflinePayment: 0,
            UniqueTransId: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: cctId,
            FacilityId: this.processRefund.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Declined,
            EmvReceiptText: null,
            TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
            TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
            LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
          };
          let CCTModel = Object.assign(tempCCModel);
          this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
          });
          if (transactionType == 'REFUNDVOID') {
            this.isCancel.emit(true);
            this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
          } else {
            this.toastr.error('Refund Failed', 'Failure');
          }
          this.initiatedVoidCC = false;
          this.loaderIcon = Promise.resolve(false);
        }
      }
    }, err => {
      if (count > maxTime) {
        if (this.subTD) {
          this.subTD.unsubscribe();
          this.subTD = null;
        }
        const tempCCModel = {
          Amount: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].Amount,
          Autopay: false,
          paymentModeId: EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardNumber ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardNumber : 0,
          CreditCardType: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardType ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardType : ECreditCards.Visa,
          NameonCard: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].NameonCard ? this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].NameonCard : " ",
          CreditCardExpiryMonth: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryMonth != 0 ? this.getExpiryMonthValue(parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryMonth, 10)) : 275,
          CreditCardExpiryYear: !parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryYear, 10) ? 2099 : parseInt(this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].CreditCardExpiryYear, 10),
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: "0",
          ResponseCode: '0',
          Reason: 'Declined!',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: this.refundTable.find(o => o.payId == this.currentPayId)['processedCC'].DebitCardPayment == true ? true : false,
          OfflinePayment: 0,
          UniqueTransId: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: cctId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          EmvReceiptText: null,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
        };
        this.initiatedVoidCC = false;
        let CCTModel = Object.assign(tempCCModel);
        this.paymentService.saveCCTransaction(CCTModel).subscribe((res: any) => {
        });
        if (transactionType == 'REFUNDVOID') {
          this.isCancel.emit(true);
          this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
        } else {
          this.toastr.error('Refund Failed', 'Failure');
        }
        this.loaderIcon = Promise.resolve(false);
      }
    });
  }

  getOriginalExpiryMonth(expiryMonth) {
    let tempMonth = 263;
    if (expiryMonth) {
      if (expiryMonth > 263 && expiryMonth < 276) {
        expiryMonth = expiryMonth - tempMonth;
        expiryMonth = '0' + expiryMonth
      } else if (expiryMonth > 0 && expiryMonth < 13) {
        expiryMonth = expiryMonth;
      } else {
        expiryMonth = '01';
      }
    } else {
      expiryMonth = '01';
    }
    return expiryMonth;
  }

  generateIntialCCT(paymentTransactionId, item) {
    let ccExpMonth;
    let ccExpYear;
    let paidAmount = item.payAmount;
    if (item.payModeId == EPaymentModes.ManualAuthorization && item.ManualCardExp) {
      ccExpMonth = item.ManualCardExp.substr(0, 2);
      ccExpYear = item.ManualCardExp.substr(4);
    }
    const CCTModel = {
      Amount: paidAmount,
      Autopay: false,
      paymentModeId: item.payModeId ? item.payModeId : null,
      AutoCcProcessingDay: 0,
      CreditCardNumber: item.payModeId == EPaymentModes.ManualAuthorization && item.ManualCardNumber ? item.ManualCardNumber : 0,
      CreditCardType: item.payModeId == EPaymentModes.ManualAuthorization && item.CreditCardType ? item.CreditCardType : ECreditCards.Visa,
      NameonCard: item.payModeId == EPaymentModes.ManualAuthorization && item.ManualCardName ? item.ManualCardName : '',
      CreditCardExpiryMonth: item.payModeId == EPaymentModes.ManualAuthorization && ccExpMonth ? this.getExpiryMonthValue(parseInt(ccExpMonth, 10)) : 275,
      CreditCardExpiryYear: item.payModeId == EPaymentModes.ManualAuthorization && ccExpYear ? parseInt(ccExpYear, 10) : 2099,
      CreditCardBillingAddress: '',
      CreditCardBillingZip: '',
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: item.payModeId == EPaymentModes.ManualAuthorization && item.ManualCardAuthorization ? item.ManualCardAuthorization : '0',
      ResponseCode: '',
      Reason: item.payModeId == EPaymentModes.ManualAuthorization ? 'Approval' : 'Attempting to Process',
      Key: item.payModeId == EPaymentModes.CreditCard && this.paymentGateway == EPaymentGateway.TdBank ? 'VOID' : '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTransactionId,
      OrderId: null,
      FacilityId: this.processRefund.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
      TerminalDeviceId: item.payModeId == EPaymentModes.CreditCard && this.selectedDeviceId ? this.selectedDeviceId : null,
      LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
      TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null
    };
    return Object.assign(CCTModel);
  }

  /**
   * Voids an already-succeeded PayFields refund (rollback path, e.g. receipt save failed after
   * the gateway credit went through). Mirrors refundPayFieldsHostedPage but with TransactionType 'voids'.
   */
  private voidPayFieldsRefund(orderId: any, paymentTrnsId: any, item: any): void {
    const reversalPayload = {
      FacilityId: this.processRefund.facId,
      GatewayDetails: { PayFieldPayment: true },
      Amount: item['processedCNPCC'].APPROVEDAMOUNT,
      InvoiceNumber: orderId,
      TransactionId: item['processedCNPCC'].TRANSACTIONID,
      TransactionType: 'voids'
    };

    this.paymentService.CallPayFieldReversal(reversalPayload).subscribe((response: any) => {
      this.loaderIcon = Promise.resolve(false);
      try {
        const gatewayResponse = response?.GatewayResponse ? JSON.parse(response.GatewayResponse) : null;
        const reversalStatus = String(gatewayResponse?.status ?? '').trim().toLowerCase();
        if (gatewayResponse && (reversalStatus.startsWith('approved') || reversalStatus.startsWith('voided')) && [200, 201].includes(response?.ResponseCode)) {
          this.isCancel.emit(true);
          const CCTModel = {
            Amount: item['processedCNPCC'].APPROVEDAMOUNT,
            Autopay: false,
            paymentModeId: item.payModeId,
            AutoCcProcessingDay: 0,
            CreditCardNumber: item['processedCNPCC'].MASKEDCARDNUMBER || 0,
            CreditCardType: item['processedCNPCC'].CARDBRAND ? this.paymentService.openEdgeCardType(item['processedCNPCC'].CARDBRAND) : ECreditCards.Visa,
            NameonCard: item['processedCNPCC'].CUSTOMERNAME || '',
            CreditCardExpiryMonth: item['processedCNPCC'].EXPMONTH ? this.getExpiryMonthValue(parseInt(item['processedCNPCC'].EXPMONTH, 10)) : 275,
            CreditCardExpiryYear: item['processedCNPCC'].EXPYEAR ? parseInt(item['processedCNPCC'].EXPYEAR, 10) : 2099,
            CreditCardBillingAddress: '',
            CreditCardBillingZip: '',
            SwipeTransaction: false,
            SecurityCodeSent: false,
            AuthorizationCode: gatewayResponse.sale_id || item['processedCNPCC'].TRANSACTIONID,
            ResponseCode: response?.ResponseCode || 200,
            Reason: gatewayResponse.status || 'Voided',
            Key: '',
            PaymentAccountid: '',
            CcInfoPurged: false,
            DebitCardPayment: false,
            OfflinePayment: 0,
            PaymentTransactionTypeId: paymentTrnsId,
            OrderId: orderId,
            FacilityId: this.processRefund.facId,
            TransactionDateTime: new Date(),
            TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
            TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
            LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
            TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
            CCBatchNumber: null,
            EmvReceiptText: gatewayResponse.receipt?.text?.merchant_receipt || null,
            GatewayDetails: item['payFieldGatewayDetails'] || this.buildPayFieldsRefundGatewayDetails()
          };
          this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
          this.toastr.success('Reversal of Refund Successful!', 'Success', this.toasterConfig);
        } else {
          const reason = gatewayResponse?.error ? `${gatewayResponse.error.message}:${gatewayResponse.error.code}` : (gatewayResponse?.status || 'Declined');
          this.toastr.warning(`${reason} - Reversal of Refund Failed. Please Contact Administrator.`, 'Alert', this.toasterConfig);
        }
      } catch (e) {
        this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
      this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
    });
  }

  voidCCCNP(orderId, paymentTrnsId, item) {
    let payModeId = item.payModeId;
    // Rollback of an already-succeeded PayFields refund (e.g. receipt save failed afterward) must
    // void via the Transactions API too — the legacy GetCNPCreditVoid below can't reference a PayFields return_id.
    if (payModeId == EPaymentModes.HostedPage && this.isPayFieldsRefundEligible && item['processedCNPCC']?.TRANSACTIONID) {
      this.voidPayFieldsRefund(orderId, paymentTrnsId, item);
      return;
    }
    let TID = payModeId == EPaymentModes.CardOnfile ? item['processedCC'].AuthorizationCode : payModeId == EPaymentModes.CreditCard ? item['processedCC'].TRANSACTIONID : item['processedCNPCC'].TRANSACTIONID;
    let amount = payModeId == EPaymentModes.CardOnfile ? -1 * (item['processedCC'].Amount) : payModeId == EPaymentModes.CreditCard ? item['processedCC'].APPROVEDAMOUNT : item['processedCNPCC'].APPROVEDAMOUNT;
    let zipCode = payModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingZip ? this.autoPayInfo.CreditCardBillingZip :
      payModeId == EPaymentModes.HostedPage ? item['processedCNPCC'].BILLINGPOSTALCODE : " ";
    let address = payModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.CreditCardBillingAddress ? this.autoPayInfo.CreditCardBillingAddress :
      payModeId == EPaymentModes.HostedPage ? item['processedCNPCC'].ADDRESS1 : " ";
    this.paymentService.GetCNPCreditVoid(this.credentials, TID, amount).subscribe((res: any) => {
      const jsonResp = JSON.parse(res);
      this.loaderIcon = Promise.resolve(false);
      if (jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
        let nameOnCard = payModeId == EPaymentModes.CardOnfile && this.autoPayInfo && this.autoPayInfo.NameonCard ? this.autoPayInfo.NameonCard :
          payModeId == EPaymentModes.CreditCard ? jsonResp.RESULT.CARDHOLDERNAME : item['processedCNPCC'].CUSTOMERNAME;
        this.isCancel.emit(true);
        const CCTModel = {
          Amount: jsonResp.RESULT.APPROVEDAMOUNT,
          Autopay: false,
          paymentModeId: payModeId,
          AutoCcProcessingDay: 0,
          CreditCardNumber: jsonResp.RESULT.MASKEDCARDNUMBER == undefined ? 0 : jsonResp.RESULT.MASKEDCARDNUMBER,
          CreditCardType: jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa,
          NameonCard: nameOnCard ? nameOnCard : "",
          CreditCardExpiryMonth: jsonResp.RESULT.EXPMONTH ? this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)) : 275,
          CreditCardExpiryYear: jsonResp.RESULT.EXPYEAR ? parseInt(jsonResp.RESULT.EXPYEAR, 10) : 2099,
          CreditCardBillingAddress: address ? address : '',
          CreditCardBillingZip: zipCode ? zipCode : '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: jsonResp.RESULT.TRANSACTIONID,
          ResponseCode: jsonResp.RESULT.RESPONSECODE,
          Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          CCBatchNumber: jsonResp.RESULT.BATCHNO ? jsonResp.RESULT.BATCHNO : null,
          EmvReceiptText: jsonResp.RESULT && jsonResp.RESULT.RECEIPTTEXT ? jsonResp.RESULT.RECEIPTTEXT : null
        };
        this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        this.toastr.success('Reversal of Refund Successful!', 'Success', this.toasterConfig);
      } else {
        let cTypeId = ECreditCards.Visa;
        if (payModeId != EPaymentModes.CardOnfile) {
          var cType = payModeId == EPaymentModes.HostedPage ? item['processedCNPCC'].CARDBRAND : item['processedCC'].CARDBRAND;
          cTypeId = cType ? this.paymentService.openEdgeCardType(cType) : ECreditCards.Visa;
        } else {
          cTypeId = this.autoPayInfo.CreditCardType;
        }
        this.isCancel.emit(true);
        const CCTModel = {
          Amount: amount,
          Autopay: false,
          paymentModeId: payModeId,
          AutoCcProcessingDay: 0,
          CreditCardNumber: payModeId == EPaymentModes.HostedPage ? item['processedCNPCC'].MASKEDCARDNUMBER : payModeId == 3 ? item['processedCC'].MASKEDCARDNUMBER : this.autoPayInfo.NameonCard,
          CreditCardType: cTypeId,
          NameonCard: payModeId == EPaymentModes.HostedPage ? item['processedCNPCC'].CUSTOMERNAME : payModeId == 3 ? item['processedCC'].CARDHOLDERNAME : this.autoPayInfo.NameonCard,
          CreditCardExpiryMonth: jsonResp.RESULT.EXPMONTH ? this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)) : 275,
          CreditCardExpiryYear: jsonResp.RESULT.EXPYEAR ? parseInt(jsonResp.RESULT.EXPYEAR, 10) : 2099,
          CreditCardBillingAddress: address ? address : '',
          CreditCardBillingZip: zipCode ? zipCode : '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: jsonResp.RESULT.TRANSACTIONID ? jsonResp.RESULT.TRANSACTIONID : 0,
          ResponseCode: jsonResp.RESULT.RESPONSECODE,
          Reason: jsonResp.RESULT.RESPONSEDESCRIPTION,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: payModeId == EPaymentModes.HostedPage && item['processedCNPCC'].CARDTYPE == "Credit" ? true : payModeId == 3 && item['processedCC'].CARDTYPE == "Credit" ? true : false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          CCBatchNumber: jsonResp.RESULT.BATCHNO ? jsonResp.RESULT.BATCHNO : null,
          EmvReceiptText: jsonResp.RESULT && jsonResp.RESULT.RECEIPTTEXT ? jsonResp.RESULT.RECEIPTTEXT : null
        };
        this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  callRCMRefund(orderId, paymentTrnsId, ccItem) {
    this.initiatedVoidCC = true;
    let amount = ccItem.APPROVEDAMOUNT
    this.toastr.warning('Please Insert Debit Card For Reversal of Refund', 'Alert', this.toasterConfig);
    const requestParam = "<REQUEST> " + "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
      "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
      "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
      "<TRANSACTIONTYPE>DEBITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + orderId + "</ORDERID> </REQUEST>";
    this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
      const responseData = JSON.parse(res.RcmResponse);
      if (responseData.RESPONSE.RESULT == 0) {
        this.isCancel.emit(true);
        const CCTModel = {
          Amount: responseData.RESPONSE.APPROVEDAMOUNT,
          Autopay: false,
          paymentModeId: EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: responseData.RESPONSE.ACCOUNT,
          CreditCardType: responseData.RESPONSE && responseData.RESPONSE['processedCC'].CARDBRAND ? this.paymentService.openEdgeCardType(responseData.RESPONSE['processedCC'].CARDBRAND) : ECreditCards.Visa,
          NameonCard: responseData.RESPONSE.CARDHOLDERNAME,
          CreditCardExpiryMonth: responseData.RESPONSE.EXPMONTH ? this.getExpiryMonthValue(parseInt(responseData.RESPONSE.EXPMONTH, 10)) : 275,
          CreditCardExpiryYear: responseData.RESPONSE.EXPYEAR ? parseInt(responseData.RESPONSE.EXPYEAR, 10) : 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: responseData.RESPONSE.TRANSACTIONID,
          ResponseCode: responseData.RESPONSE.HOSTRESPONSECODE,
          Reason: responseData.RESPONSE.HOSTRESPONSEDESCRIPTION,
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
          OfflinePayment: 0,
          UniqueTransId: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: responseData.RESPONSE.ORDERID ? responseData.RESPONSE.ORDERID : orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Reversal_Refund,
          EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null
        };
        this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        this.toastr.success('Reversal of Refund Successful!', 'Success', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.initiatedVoidCC = false;
      } else {
        this.isCancel.emit(true);
        const CCTModel = {
          Amount: amount,
          Autopay: false,
          paymentModeId: EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: responseData.RESPONSE.ACCOUNT ? responseData.RESPONSE.ACCOUNT : 0,
          CreditCardType: ccItem.CreditCardType,
          NameonCard: responseData.RESPONSE.CARDHOLDERNAME ? responseData.RESPONSE.CARDHOLDERNAME : ccItem.NameonCard,
          CreditCardExpiryMonth: ccItem.CreditCardExpiryMonth ? ccItem.CreditCardExpiryMonth : 275,
          CreditCardExpiryYear: ccItem.CreditCardExpiryYear ? ccItem.CreditCardExpiryYear : 2099,
          CreditCardBillingAddress: '',
          CreditCardBillingZip: '',
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: responseData.RESPONSE.TRANSACTIONID ? responseData.RESPONSE.TRANSACTIONID : 0,
          ResponseCode: responseData.RESPONSE.HOSTRESPONSECODE ? responseData.RESPONSE.HOSTRESPONSECODE : '',
          Reason: responseData.RESPONSE.HOSTRESPONSEDESCRIPTION ? responseData.RESPONSE.HOSTRESPONSEDESCRIPTION : '',
          Key: '',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: responseData.RESPONSE.CARDTYPE == 'Credit' ? false : true,
          OfflinePayment: 0,
          UniqueTransId: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          EmvReceiptText: responseData.RESPONSE.RECEIPTTEXT,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null
        };
        this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
        this.loaderIcon = Promise.resolve(false);
        this.initiatedVoidCC = false;
        this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
      }
    }, err => {
      this.initiatedVoidCC = false;
      this.toastr.error('Reversal of Refund Failed!', 'Failure', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    });
  }

  setUserPermissions() {
    const userPermissionsOfflinePayment = this.generalService.getUserPermissionsForModule(EUserFunctions['Rentals : Offline CC Transactions']);
    this.editRightOfflinePayment = userPermissionsOfflinePayment.EditRight;
    this.viewRightOfflinePayment = userPermissionsOfflinePayment.ViewRight;
  }

  getRemainingAmount() {
    if (this.remainingAmount >= 0) { // to calculate remaing amount from multiple modes of payments
      let tempRemaing = 0;
      this.refundTable.map(item => {
        tempRemaing += item.payAmount;
      });
      this.remainingAmount = (this.totalAmount - tempRemaing) >= 0 ? (this.totalAmount - tempRemaing) : 0;
    }
  }

  disableRefundNowButton(drow) {
    let tempRemaing = 0;
    let listedTotalAmount = 0;

    this.refundTable.map(item => {
      tempRemaing += item.payModeId !== 0 ? item.payAmount : 0;
      listedTotalAmount += item.payModeId !== 0 && item.payAmount !== 0 ? item.payAmount : item.paidAmount;
    });

    if (tempRemaing.toFixed(2) > this.totalAmount) {// to avoid  paying more than actual refund amount
      return true;
    } else if (tempRemaing.toFixed(2) < listedTotalAmount.toFixed(2)) { // to avoid  initiating payment before updating complete amount listed
      return true;
    } else if (drow.payAmount == 0 || drow.payModeId == 0) {
      return true;
    } else if (drow.payAmount > drow.paidAmount) {
      return true;
    } else if (this.processRefund.Type == EPaymentOrigin.Merchandise) {
      if (this.processRefund.AmountTobeRefund > this.processRefund.MiscSetting.Amount && this.processRefund.MiscSetting.DoNotRefundMerchandiseReturnamountexceeds) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  getAmountToPay() {
    this.refundTable.map(item => {
      if (!item.payAmount) {
        item.paidAmount = this.remainingAmount;
        item.payAmount = 0;
      } else {
        item.paidAmount = item.payAmount;
      }
    });
  }

  showRefundProgress() {
    if (this.refundInProgress) {
      return true;
    } else {
      return false;
    }
  }

  isAnyRefundProcessed() {
    let status = this.refundTable.some(function (ele) { return ele.payComplete });
    if (!status) {
      this.refundInProgress = false;
    }
  }

  onClickAutoPopulateBillingInfo(gateway) {
    if (gateway == EPaymentGateway.OpenEdgeExpress) {
      this.callCNP(this.tempCNPAmount, this.tempCNPPayId);
    }
  }

  setCNPCustomerInfo(amount, orderId) {
    this.customerInfo.AddressOne = this.customerInfo.AddressOne && this.customerInfo.AddressOne.length > 50 ?
      this.customerInfo.AddressOne.substring(0, 50) : this.customerInfo.AddressOne;
    const customerInfo = this.paymentService.mapBillingInfo(this.customerInfo);
    this.requestParam = "<REQUEST>" +
      "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
      "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
      "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
      "<TRANSACTIONTYPE>CREDITRETURN</TRANSACTIONTYPE>" +
      "<AMOUNT>" + amount + "</AMOUNT>" +
      "<BILLINGFIRSTNAME>" + customerInfo.firstName + "</BILLINGFIRSTNAME>" +
      "<BILLINGMIDDLENAME>" + customerInfo.middleName + "</BILLINGMIDDLENAME>" +
      "<BILLINGLASTNAME>" + customerInfo.lastName + "</BILLINGLASTNAME>" +
      "<BILLINGADDRESS1>" + customerInfo.address + "</BILLINGADDRESS1>" +
      "<BILLINGCOMPANY>" + customerInfo.companyName + "</BILLINGCOMPANY>" +
      "<BILLINGCITY>" + customerInfo.city + "</BILLINGCITY>" +
      "<BILLINGCOUNTRY>" + customerInfo.countryCode + "</BILLINGCOUNTRY>" +
      "<BILLINGSTATE>" + customerInfo.stateCode + "</BILLINGSTATE>" +
      "<BILLINGPOSTALCODE>" + customerInfo.postalCode + "</BILLINGPOSTALCODE>" +
      "<CLERK></CLERK>" +
      "<ORDERID>" + orderId + "</ORDERID>" +
      "<ECI>" + EEdgeExpressECIType.Moto + "</ECI>" +
      "<HOSTPAYSETTING>" +
      "<CARDBRAND>" + this.facilityCreditCards + "</CARDBRAND>" +
      "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
      "<CUSTOMIZATION>" +
      "<PAGE> " +
      "<BILLINGFIRSTNAME>  <REQUIRED>TRUE</REQUIRED>  </BILLINGFIRSTNAME>" +
      "<BILLINGLASTNAME >  <REQUIRED>TRUE</REQUIRED>  </BILLINGLASTNAME>" +
      "<BILLINGADDRESSONE >  <REQUIRED>TRUE</REQUIRED>  </BILLINGADDRESSONE>" +
      "<BILLINGPOSTALCODE >  <REQUIRED>TRUE</REQUIRED>  </BILLINGPOSTALCODE>" +
      "</PAGE>" +
      "<BRANDING>" +
      "<BODY>" +
      "<FONT-FAMILY> LATO,SANS-SERIF;</FONT-FAMILY>" +
      "<FONT-SIZE>14px</FONT-SIZE>" +
      "</BODY>" +
      "<BTN>" +
      "<BACKGROUND-COLOR>#3757C5;</BACKGROUND-COLOR>" +
      "<FONT-SIZE>14PX;</FONT-SIZE>" +
      "</BTN>" +
      "<SPECIALCSS>" +
      "<SECTION-HEADER-FONT-SIZE>18px</SECTION-HEADER-FONT-SIZE>" +
      "<COLOR>#3757C5;</COLOR>" +
      "</SPECIALCSS>" +
      "</BRANDING>" +
      "</CUSTOMIZATION>" +
      "<POSDEVICE>" +
      "<TYPE>KEYED</TYPE>" +
      "</POSDEVICE>" +
      "</HOSTPAYSETTING>" +
      "</REQUEST>";
  }

  getTenantDetailsById(tenantId) {
    this.prospectSerice.getContactInfo(tenantId).subscribe((response: any) => {
      this.Tenantinfo=response;
      if (response) {
        this.customerInfoPresent = true;
        this.customerInfo = {
          FirstName: response.FirstName,
          MiddleName: response.MiddleName,
          LastName: response.LastName,
          CompanyName: response.BusinessAccount && response.CompanyName ? response.CompanyName : '',
          AddressOne: response.Address,
          City: response.City,
          CountryCode: response.CountryCode.substring(0, 2),
          StateCode: response.State && response.State.Code ? response.State.Code : '',
          StateId: response.State && response.State.Id ? response.State.Id : '',
          PostalCode: response.Zip,
          CountryId: response.CountryId,
          CellPhoneNumber: response.CellPhoneNumber,
          Email: response.Email
        }
      }
    })
  }

  openEdgeTransactionStatus(orderId, payId, paymentTrnsId) {
    this.paymentService.GetCreditCardTransactionById(orderId).subscribe((cctResponse: any) => {
      let res = JSON.parse(cctResponse);
      if (res.Reason == "Attempting to Process") {
        this.initiatingOpenEdgeQueryPaymentRequest(orderId, payId, paymentTrnsId, true);
      } else {
        this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
        this.saveCCTransactionFailureCase(this.tempRcmRes.rcmResponse, this.paymentFailReason, paymentTrnsId);
      }
    });
  }


  getOpenEdgeTransactionStatus(orderId, payId, count, paymentTrnsId) {
    count = count + 1;
    let maxTime = (this.paymentMaxWaitTime * 60) / this.paymentGetCCTStatusInterval;
    if (count > maxTime) {
      if (this.openEdgeSub) {
        this.openEdgeSub.unsubscribe();
        this.openEdgeSub = null;
      }
      this.cancelRcmRefundRequest(this.tempRcmRes.rcmSessionId, false);
      this.retryTransactionStatusLoader = false;
      this.paymentFailReason = "Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
      this.saveCCTransactionFailureCase(this.tempRcmRes.rcmResponse, this.paymentFailReason, paymentTrnsId);
    } else {
      this.initiatingOpenEdgeQueryPaymentRequest(orderId, payId, paymentTrnsId, false);
    }
  }

  saveCCTFailModelStripe(stripFailedResponse, processPayment) {
    const CCModel = {
      Amount: stripFailedResponse.Amount,
      Autopay: false,
      paymentModeId: EPaymentModes.HostedPage,
      AutoCcProcessingDay: 0,
      CreditCardNumber: stripFailedResponse.CreditCardNumber ? stripFailedResponse.CreditCardNumber : '0',
      CreditCardType: stripFailedResponse.CardBrand ? this.paymentService.openEdgeCardType(stripFailedResponse.CardBrand) : ECreditCards.Visa,
      NameonCard: stripFailedResponse.CreditHolderName ? stripFailedResponse.CreditHolderName : "",
      CreditCardExpiryMonth: stripFailedResponse.ExpiryMonth ? this.getExpiryMonthValue(parseInt(stripFailedResponse.ExpiryMonth, 10)) : 275,
      CreditCardExpiryYear: stripFailedResponse.ExpiryYear ? parseInt(stripFailedResponse.ExpiryYear, 10) : 2099,
      CreditCardBillingAddress: " ",
      CreditCardBillingZip: " ",
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: stripFailedResponse.chargeId ? stripFailedResponse.chargeId : " ",
      ResponseCode: stripFailedResponse.ResponseCode ? stripFailedResponse.ResponseCode : "",
      Reason: stripFailedResponse.Reason ? stripFailedResponse.Reason : "Failed",
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: false,
      OfflinePayment: 0,
      Key: stripFailedResponse.Key ? stripFailedResponse.Key : stripFailedResponse.PaymentIntentId,
      PaymentTransactionTypeId: stripFailedResponse.PaymentTrnsId,
      OrderId: stripFailedResponse.OrderId,
      FacilityId: processPayment.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Declined,
      TerminalDeviceId: null,
      TenantId: processPayment.TenantId ? processPayment.TenantId : null,
      LeaseNo: processPayment.LeaseNo ? processPayment.LeaseNo : null,
      GatewayDetails: this.requestGatewayDetails
    };
    return CCModel;
  }

  saveCCTransactionFailureCase(jsonResp, paymentFailReason, paymentTrnsId) {
    this.paymentSuccessFul = false;
    this.payStatus = 'Failed';
    this.retryTransactionStatusLoader = false;
    this.isAnyRefundProcessed();
    this.paymentFailReason = paymentFailReason ? paymentFailReason : jsonResp.RESULT.STATE;
    this.loaderIcon = Promise.resolve(false);
    const CCTModel = {
      Amount: this.amountToPay,
      Autopay: false,
      paymentModeId: jsonResp && jsonResp.PaymentModeId ? jsonResp.PaymentModeId : EPaymentModes.CreditCard,
      AutoCcProcessingDay: 0,
      CreditCardNumber: jsonResp && jsonResp.RESULT && jsonResp.RESULT.MASKEDCARDNUMBER ? jsonResp.RESULT.MASKEDCARDNUMBER : '0',
      CreditCardType: jsonResp && jsonResp.RESULT && jsonResp.RESULT.CARDBRAND ? this.paymentService.openEdgeCardType(jsonResp.RESULT.CARDBRAND) : ECreditCards.Visa, //Visa
      NameonCard: '',
      CreditCardExpiryMonth: jsonResp && jsonResp.RESULT && jsonResp.RESULT.EXPMONTH ? this.getExpiryMonthValue(parseInt(jsonResp.RESULT.EXPMONTH, 10)) : 275,
      CreditCardExpiryYear: jsonResp && jsonResp.RESULT && jsonResp.RESULT.EXPYEAR ? parseInt(jsonResp.RESULT.EXPYEAR, 10) : 2099,
      CreditCardBillingAddress: jsonResp && jsonResp.RESULT && jsonResp.RESULT.ADDRESS1 ? jsonResp.RESULT.ADDRESS1 : " ",
      CreditCardBillingZip: jsonResp && jsonResp.RESULT && jsonResp.RESULT.BILLINGPOSTALCODE ? jsonResp.RESULT.BILLINGPOSTALCODE : " ",
      SwipeTransaction: false,
      SecurityCodeSent: false,
      AuthorizationCode: jsonResp && jsonResp.RESULT && jsonResp.RESULT.TRANSACTIONID ? jsonResp.RESULT.TRANSACTIONID : '0',
      ResponseCode: jsonResp && jsonResp.RESUL && jsonResp.RESULT.RESPONSECODE ? jsonResp.RESULT.RESPONSECODE : '0',
      Reason: (jsonResp && jsonResp.RESULT && jsonResp.RESULT.STATE == 'IN_PROGRESS') ? jsonResp.RESULT.STATE : jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : this.paymentFailReason,
      Key: '',
      PaymentAccountid: '',
      CcInfoPurged: false,
      DebitCardPayment: jsonResp && jsonResp.RESULT && jsonResp.RESULT.CARDTYPE && jsonResp.RESULT.CARDTYPE == 'Credit' ? false : true,
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: this.refundTable.find(o => o.payId == this.currentPayId).orderId,
      FacilityId: this.processRefund.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: EPaymentTransactionType.Declined,
      TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
      UniqueTransId: this.refundTable.find(o => o.payId == this.currentPayId).uniqueTransId,
      TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
      LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
      EmvReceiptText:  jsonResp?.RESULT?.RECEIPTTEXT ?? null,
      GatewayDetails: this.paymentGateway == EPaymentGateway.OpenEdgeExpress && jsonResp?.PaymentModeId == EPaymentModes.HostedPage
        ? this.refundTable.find(row => row.payId == this.currentPayId)?.['payFieldGatewayDetails'] || this.requestGatewayDetails
        : this.requestGatewayDetails
    };
    this.paymentService.saveCCTransaction(Object.assign(CCTModel)).subscribe((res: any) => { });
    this.gotoPaymentSuccess(this.aftePay, 0);
    this.loaderIcon = Promise.resolve(false);
  }

  initiatingOpenEdgeQueryPaymentRequest(orderId, payId, paymentTrnsId, callRetryLogic) {
    if (this.credentials) {
      this.paymentService.getCNPResponse(this.credentials, orderId).subscribe((paymentRes: any) => {
        this.prePayStatus = 'Refund';
        const jsonResp = JSON.parse(paymentRes);
        this.tempRcmRes.rcmResponse = jsonResp;
        let amount;
        if (this.cctStatusOrderId == 0) {
          if (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp.RESULT.STATE != 'IN_PROGRESS') {
            this.cctStatusOrderId = jsonResp.RESULT.ORDERID;
            if (this.openEdgeSub) {
              this.openEdgeSub.unsubscribe();
              this.openEdgeSub = null;
            }
            this.payStatus = 'Success';
            this.paymentSuccessFul = true;
            this.retryTransactionStatusLoader = false;
            amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
            jsonResp.RESULT['OrderId'] = orderId;
            jsonResp.RESULT['CARDHOLDERNAME'] = jsonResp.RESULT.CARDBRAND;
            jsonResp.RESULT['ACCOUNT'] = jsonResp.RESULT.MASKEDCARDNUMBER;
            jsonResp.RESULT['HOSTRESPONSECODE'] = jsonResp.RESULT.RESPONSECODE;
            jsonResp.RESULT['HOSTRESPONSEDESCRIPTION'] = jsonResp.RESULT.ORIGINALRESPONSEDESCRIPTION;
            this.refundTable.find(o => o.payId == payId)['processedCC'] = jsonResp.RESULT;
            this.loaderIcon = Promise.resolve(false);
            this.gotoPaymentSuccess(this.aftePay, amount);
            this.getRCMStatus(orderId, true);
          } else if (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE != EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION != 'Invalid Reference Error: Transaction does not exist') {
            if (this.openEdgeSub) {
              this.openEdgeSub.unsubscribe();
              this.openEdgeSub = null;
            }
            this.retryTransactionStatusLoader = false;
            let reason = jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : null;
            this.saveCCTransactionFailureCase(jsonResp, reason, paymentTrnsId);
            this.getRCMStatus(orderId, false);
          } else if (callRetryLogic) {
            this.paymentService.GetCreditCardTransactionById(orderId).subscribe((cctResponse: any) => {
              let res = JSON.parse(cctResponse);
              if (this.openEdgeSub == null && res.Reason == "Attempting to Process") {
                this.cctStatusOrderId = 0;
                this.retryTransactionStatusLoader = true;
                let intervalTime = this.paymentGetCCTStatusInterval * 1000;
                const source = interval(intervalTime);
                this.openEdgeSub = source.subscribe(val => this.getOpenEdgeTransactionStatus(orderId, payId, val, paymentTrnsId));
              } else {
                this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
                this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, paymentTrnsId);
                this.cancelRcmRefundRequest(this.tempRcmRes.rcmSessionId, false);
              }
            });
          } else {
            this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
              if (sessionRes) {
                this.tempRcmRes.rcmSessionId = sessionRes.SessionId;
                if (sessionRes.SessionState == EOpenEdgeSessionStates.Completed && jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION == 'Invalid Reference Error: Transaction does not exist') {
                  this.retryTransactionStatusLoader = false;
                  if (this.openEdgeSub) {
                    this.openEdgeSub.unsubscribe();
                    this.openEdgeSub = null;
                  }
                  this.paymentFailReason = "Declined!";
                  jsonResp.RESULT.RESPONSEDESCRIPTION = jsonResp.RESULT.RESPONSEDESCRIPTION + " : RCM Session Completed!";
                  this.saveCCTransactionFailureCase(jsonResp, this.paymentFailReason, paymentTrnsId);
                }
              }
            });
          }
        }
      }, err => {
        this.payStatus = 'Failed!';
        this.paymentFailReason = "Payment Status not received. Please Contact Administrator to check in Gateway Portal if Payment is Approved. If Yes, key in the Payment as Manual Authorization";
        this.loaderIcon = Promise.resolve(false);
        if (this.openEdgeSub) {
          this.openEdgeSub.unsubscribe();
          this.openEdgeSub = null;
        }
        this.payStatus = 'Failed';
        this.retryTransactionStatusLoader = false;
        const tempCCModel = {
          Amount: this.amountToPay,
          Autopay: false,
          paymentModeId: EPaymentModes.CreditCard,
          AutoCcProcessingDay: 0,
          CreditCardNumber: '0',
          CreditCardType: ECreditCards.Visa,
          NameonCard: '',
          CreditCardExpiryMonth: 275,
          CreditCardExpiryYear: 2099,
          CreditCardBillingAddress: " ",
          CreditCardBillingZip: " ",
          SwipeTransaction: false,
          SecurityCodeSent: false,
          AuthorizationCode: '0',
          ResponseCode: '0',
          Reason: 'Declined!',
          PaymentAccountid: '',
          CcInfoPurged: false,
          DebitCardPayment: false,
          OfflinePayment: 0,
          PaymentTransactionTypeId: paymentTrnsId,
          OrderId: orderId,
          FacilityId: this.processRefund.facId,
          TransactionDateTime: new Date(),
          TransactionTypeId: EPaymentTransactionType.Declined,
          TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
          UniqueTransId: this.refundTable.find(o => o.payId == this.currentPayId).uniqueTransId,
          TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
          LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
        };
        this.paymentService.saveCCTransaction(Object.assign(tempCCModel)).subscribe((res: any) => { });
        this.gotoPaymentSuccess(this.aftePay, 0);
      });
    } else {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    }

  }
  getRCMStatus(orderId, transactinSuccess) {
    this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
      if (sessionRes) {
        if (sessionRes.SessionState == EOpenEdgeSessionStates.PromptingForCardRemoval) {
          this.toastr.warning('Please Remove Your Card From EMV Device', 'Alert', this.toasterConfig);
        }
        this.cancelRcmRefundRequest(sessionRes.SessionId, transactinSuccess);
      }
    });
  }

  cancelRcmRefundRequest(sessionId, isTransactionSuccess) {
    this.paymentService.getRCMServiceStatus(sessionId, 0, true).subscribe((respose: any) => {
      if (!respose.IsSuccessful && !isTransactionSuccess) {
        this.toastr.warning('Please click on Cancel Button in the EMV Device, if it is not in Home Screen. Ignore if already in Home Screen', 'Alert', this.toasterConfig);
      }
    });
  }

  HostedCNPResponse(orderId, payId, paymentTrnsId) {
    if (!this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted) {
      this.paymentService.getCNPResponse(this.credentials, orderId).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        this.prePayStatus = 'Refund';
        jsonResp['PaymentModeId'] = EPaymentModes.HostedPage;
        this.tempCnpRes = jsonResp;
        if (jsonResp.RESULT && jsonResp.RESULT.STATE && jsonResp.RESULT.STATE != 'IN_PROGRESS' && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.Approval) {
          this.paymentSuccessFul = true;
          this.payStatus = 'Success';
          this.refundTable.find(o => o.payId == this.currentPayId).payFailed = false;
          this.refundTable.find(o => o.payId == this.currentPayId)['processedCNPCC'] = jsonResp.RESULT;
          this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
          this.gotoPaymentSuccess(this.aftePay, parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2));
        } else if (jsonResp.RESULT.STATE == 'IN_PROGRESS' || (jsonResp.RESULT && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.TransactionDoesNotExist && jsonResp.RESULT.RESPONSEDESCRIPTION == 'Invalid Reference Error: Transaction does not exist')) {
          this.HostedCNPResponse(orderId, payId, paymentTrnsId);
        } else {
          this.isAnyRefundProcessed();
          this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed';
          this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
          this.paymentFailReason = jsonResp.RESULT.STATE;
          this.saveCCTransactionFailureCase(this.tempRcmRes.rcmResponse, jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : 'Declined!', paymentTrnsId);
          if (jsonResp.RESULT.RESPONSECODE && jsonResp.RESULT.RESPONSECODE == EOpenEdgeResponseCode.ImproperFieldData) {
            if (jsonResp.RESULT.RESPONSEDESCRIPTION) {
              jsonResp.RESULT.RESPONSEDESCRIPTION = jsonResp.RESULT.RESPONSEDESCRIPTION + '. ' + 'Customer Name should be less than 50 characters!'
              this.toastr.warning(jsonResp.RESULT.RESPONSEDESCRIPTION, 'Warning', this.toasterConfig);
            }
          }
        }
      }, err => {
        this.showIFrame = false;
        this.showPage = !this.showIFrame;
        this.refundTable.find(o => o.payId == this.currentPayId).isOpenEdgePaymentCompleted = true;
        this.loaderIcon = Promise.resolve(false);
        this.paymentFailReason = 'Declined!';
        this.toastr.error('Refund Failed', 'Failure');
        this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.tempCnpRes['PaymentModeId'] = EPaymentModes.HostedPage;
        this.saveCCTransactionFailureCase(this.tempCnpRes, this.paymentFailReason, paymentTrnsId);
      });
    }
  }

  saveInACH(amount, payId, transactionType) {
    let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
    let payModeId = this.refundTable.find(o => o.payId === payId).payModeId;
    let ACHModel = this.generateIntialACH(amount, transactionType, paymentTrnsId, payModeId);
    this.paymentService.saveACHTransaction(ACHModel).subscribe((res) => {
      if (res) {
        this.refundTable.find(o => o.payId == payId).orderId = res.Id;
        this.achOrderNumber = res.UniqueTransId;
        if (payModeId == EPaymentModes.ACH) {
          this.callRefundAchPage(amount, paymentTrnsId);
        } else if (payModeId == EPaymentModes.ACHOnFile) {
          this.callRefundAChOnFile(amount, paymentTrnsId);
        } else {
          console.log("Manual auth.....");
        }
      }
    });
  }

  generateIntialACH(amount, transactionType, paymentTrnsId, payModeId) {
    const ACHModel = {
      Amount: amount,
      Autopay: false,
      paymentModeId: payModeId,
      AutoACHProcessingDay: 0,
      AchAccountNumber: 0,
      AchRoutingNumber: 0,
      AccountClass: 277,
      AccountType: 279,
      SwipeTransaction: false,
      AuthorizationCode: 0,
      ResponseCode: '0',
      Reason: 'Attempting to Process',
      CcInfoPurged: false,
      OfflinePayment: 0,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: null,
      FacilityId: this.processRefund.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transactionType,
      LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
      TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null
    };
    return Object.assign(ACHModel);
  }

  callRefundAchPage(amount, paymentTrnsId) {
    if (this.achPaymentGateway) {
      this.requestParam =
        "<REQUEST>" +
        "<XWEBID>" + this.achPaymentGateway.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.achPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.achPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
        "<TRANSACTIONTYPE>CHECKCREDIT</TRANSACTIONTYPE>" +
        "<AMOUNT>" + amount + "</AMOUNT>" +
        "<ENTRYCLASS>PPD</ENTRYCLASS>" +
        "<ORDERID>" + this.achOrderNumber + "</ORDERID>" +
        "<HOSTPAYSETTING>" +
        "<DISABLEFRAMING>FALSE</DISABLEFRAMING>" +
        " <POSDEVICE>" +
        "<TYPE>KEYED</TYPE>" +
        "</POSDEVICE>" +
        "<CUSTOMIZATION>" +
        "<BANKACCOUNTTYPEFORMAT></BANKACCOUNTTYPEFORMAT>" +
        "<PAGE>" +
        "<BANKACCOUNTTYPE><EDIT>TRUE</EDIT><REQUIRED>TRUE</REQUIRED><VISIBLE>TRUE</VISIBLE></BANKACCOUNTTYPE>" +
        "<INVOICENUMBER><EDIT>FALSE</EDIT><REQUIRED>FALSE</REQUIRED><VISIBLE>FALSE</VISIBLE></INVOICENUMBER>" +
        "<PURCHASEORDERNUMBER><EDIT>FALSE</EDIT><REQUIRED>FALSE</REQUIRED><VISIBLE>FALSE</VISIBLE></PURCHASEORDERNUMBER>" +
        "<ORDERID><LABEL>ORDER ID</LABEL><VISIBLE>TRUE</VISIBLE></ORDERID>" +
        "<BRANDING>" +
        "<BODY>" +
        " <BACKGROUNDCOLOR>#FFFF00;</BACKGROUNDCOLOR>" +
        "<COLOR>#0F0F0F;</COLOR>" +
        "<FONTFAMILY>TIMES NEW ROMAN, HELVETICA-NEUE,HELVETICA,ARIAL,SANS-SERIF;</FONTFAMILY>" +
        "<FONTSIZE>18PX;</FONTSIZE>" +
        "<INPUTFIELDHEIGHT />" +
        "</BODY>" +
        "</BRANDING>" +
        "</PAGE>" +
        "  </CUSTOMIZATION>" +
        " </HOSTPAYSETTING>" +
        "</REQUEST>";

      this.paymentService.getCNPService(this.achPaymentGateway.CheckNotPresentURL, this.requestParam).subscribe((res: any) => {
        this.loaderIcon = Promise.resolve(false);
        const resultResponse = JSON.parse(res);
        this.achUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(resultResponse.RESULT.PAYPAGEURL);
        this.showAchIFrame = true;
        this.showPage = false;
      }, err => {
        this.toastr.warning('Please ask Administrator to configure ACH URL', 'URL required', this.toasterConfig);
        this.loaderIcon = Promise.resolve(false);
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, err.error && err.error.error ? err.error.error : null);
        this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.gotoPaymentSuccess(this.aftePay, 0);
      });
    } else {
      this.toastr.warning('Please ask Administrator to configure ACH URL', 'URL required', this.toasterConfig);
      this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, 'Declined! - Wrong ACH configuration');
      this.loaderIcon = Promise.resolve(false);
      this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.toastr.error('Refund Failed', 'Failure');
      this.gotoPaymentSuccess(this.aftePay, 0);
    }
  }

  getFacilityInfoACH() {
    this.loaderIcon = Promise.resolve(true);
    this.facilityservice.getFacilityInfoACHForOp(this.processRefund.facId).subscribe((response: IFacilityInfoACH) => {
      if (response != null && response.GatewayDetails) {
        this.achPaymentGateway = JSON.parse(response.GatewayDetails);
      }
      this.loaderIcon = Promise.resolve(false);
    });
  }

  getAchHiddenInput() {
    this.hstPayBtnMsg = 'Cancel';
    let iframeSrc = this.iframeAch.nativeElement.src.split('/');
    let tempId = iframeSrc.pop();
    let paymentTrnsId = this.paymentService.getRefundPaymentTransactionTypeId(this.processRefund.Type);
    if (this.sessionId === tempId) {
      this.refundInProgress = true;
      this.hstPayBtnMsg = 'OK';
      this.sessionId = tempId;
      let amount;
      this.paymentService.GetACHResponse(this.achOrderNumber, this.achPaymentGateway).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        if (jsonResp) {
          console.log('jsonResp', jsonResp);
          this.showAchIFrame = false;
          this.showPage = !this.showAchIFrame;
          this.prePayStatus = 'Refund';
          this.paymentSuccessFul = true;
          if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Check_Submitted && jsonResp.RESULT.RESPONSEDESCRIPTION == "Check Submitted") {
            this.refundTable.find(o => o.payId == this.currentPayId).payFailed = false;
            amount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
            this.refundTable.find(o => o.payId == this.currentPayId)['processedACH'] = jsonResp.RESULT;
          } else {
            this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
            amount = 0;
            this.toastr.error('Refund Failed', 'Failure');
            this.loaderIcon = Promise.resolve(false);
            this.saveAchTransactions(jsonResp.RESULT, paymentTrnsId, EPaymentTransactionType.Declined, null);
          }
          this.gotoPaymentSuccess(this.aftePay, amount);
        }
      }, err => {
        this.loaderIcon = Promise.resolve(false);
        this.showAchIFrame = false;
        this.showPage = !this.showAchIFrame;
        this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
        this.toastr.error('Refund Failed', 'Failure');
        this.gotoPaymentSuccess(this.aftePay, 0);
        this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, null);
      });
    } else {
      this.sessionId = tempId;
    }
  }

  callRefundAChOnFile(amount, paymentTrnsId) {
    console.log('autoPayInfo', this.autoPayInfo);
    const accounType = this.autoPayInfo.ACHAccountType == EACHAccountType.Savings ? 'SAVINGS' : 'CHECKING';
    var aliaseRequest = "<REQUEST>" +
      "<XWEBID>" + this.achPaymentGateway.XWEBID + "</XWEBID>" +
      "<XWEBTERMINALID>" + this.achPaymentGateway.XWEBTERMINALID + "</XWEBTERMINALID>" +
      "<XWEBAUTHKEY>" + this.achPaymentGateway.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
      "<TRANSACTIONTYPE>CHECKCREDIT</TRANSACTIONTYPE>" +
      "<AMOUNT>" + amount + "</AMOUNT>" +
      "<ENTRYCLASS>PPD</ENTRYCLASS>" +
      "<RECEIPTFORMAT>TEXT</RECEIPTFORMAT>" +
      "<BANKACCOUNTTYPE>" + accounType + "</BANKACCOUNTTYPE>" +
      "<ORDERID>" + this.achOrderNumber + "</ORDERID>" +
      "<ALIAS>" + this.autoPayInfo.ACHPaymentAccountId + "</ALIAS>" +
      "</REQUEST>";
    this.paymentService.getCNPService(this.achPaymentGateway.QueryPaymentStatusURL, aliaseRequest).subscribe((res: any) => {
      if (res) {
        let approvedAmount;
        const jsonResp = JSON.parse(res);
        if (jsonResp.RESULT.RESPONSECODE == EACHCheckResultCode.Check_Submitted && jsonResp.RESULT.RESPONSEDESCRIPTION == "Check Submitted") {
          this.paymentSuccessFul = true;
          this.refundTable.find(o => o.payId == this.currentPayId).payFailed = false;
          approvedAmount = parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2);
          this.refundTable.find(o => o.payId == this.currentPayId)['processedACH'] = jsonResp.RESULT;
          this.refundTable.find(o => o.payId == this.currentPayId)['processedACH'].PaymentAccountId = this.autoPayInfo.ACHPaymentAccountId;
          this.refundTable.find(o => o.payId == this.currentPayId)['processedACH'].ACCOUNTYPE = this.autoPayInfo.ACHAccountType;
        } else {
          this.paymentSuccessFul = false;
          this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
          approvedAmount = 0;
          this.toastr.error('Refund Failed', 'Failure');
          this.loaderIcon = Promise.resolve(false);
          this.saveAchTransactions(jsonResp.RESULT, paymentTrnsId, EPaymentTransactionType.Declined, null);
        }
        this.gotoPaymentSuccess(this.aftePay, approvedAmount);
      }
    }, err => {
      this.paymentSuccessFul = false;
      this.refundTable.find(o => o.payId == this.currentPayId).payFailed = true;
      this.toastr.error('Refund Failed', 'Failure');
      this.loaderIcon = Promise.resolve(false);
      this.saveAchTransactions(null, paymentTrnsId, EPaymentTransactionType.Declined, err.error && err.error.error ? err.error.error : null);
      this.gotoPaymentSuccess(this.aftePay, 0);
    });
  }

  saveAchTransactions(achResponse, paymentTrnsId, transactionType, reason) {
    this.loaderIcon = Promise.resolve(false);
    const achModel = {
      Amount: achResponse && achResponse.APPROVEDAMOUNT ? parseFloat(achResponse.APPROVEDAMOUNT).toFixed(2) : this.amountToPay,
      Autopay: false,
      paymentModeId: this.refundTable.find(o => o.payId == this.currentPayId).payModeId,
      AutoACHProcessingDay: 0,
      AchAccountNumber: achResponse && achResponse.ACCOUNT ? achResponse.ACCOUNT : "0",
      AchRoutingNumber: achResponse && achResponse.ROUTINGNUMBER ? achResponse.ROUTINGNUMBER : "0",
      AccountClass: 277,
      AchAccountType: this.refundTable.find(o => o.payId == this.currentPayId).payModeId == EPaymentModes.ACHOnFile && this.autoPayInfo && this.autoPayInfo.ACHAccountType ? this.autoPayInfo.ACHAccountType : EACHAccountType.Checking,
      SwipeTransaction: false,
      AutoAchPayment: false,
      AuthorizationCode: 0,
      ResponseCode: achResponse && achResponse.RESPONSECODE ? achResponse.RESPONSECODE : "0",
      Reason: reason ? reason : (achResponse && achResponse.RESPONSEDESCRIPTION ? achResponse.RESPONSEDESCRIPTION : "Declined!"),
      CcInfoPurged: false,
      OfflinePayment: false,
      ACHInfoPurged: false,
      PaymentTransactionTypeId: paymentTrnsId,
      OrderId: this.refundTable.find(o => o.payId == this.currentPayId).orderId,
      FacilityId: this.processRefund.facId,
      TransactionDateTime: new Date(),
      TransactionTypeId: transactionType,
      LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null,
      TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
      ReceiptText: achResponse && achResponse.RECEIPTTEXT,
      GatewayDetails: this.requestGatewayDetails
    };
    this.paymentService.saveACHTransaction(Object.assign(achModel)).subscribe((res) => { });
  }

  onACHManualCancel() {
    this.achManualCardAuthorization = '';
    this.nameonAccount = '';
    this.accountType = 279;
    this.checkNumber = '';
    this.accountNumber = '';
    this.routingNumber = '';
    this.achManualModalRef.hide();
  }

  onRefundNext(amount, payId, paymentSuccessTemplate, item, checkTemplate) {
    this.currentPayId = 1;
    this.onPayClick(amount, payId, paymentSuccessTemplate, item, checkTemplate)
  }

  tdEmvFailedResponse(amount, res, payId, cctId, paymentTrnsId, transactionType) {
    this.refundTable.find(o => o.payId == payId).payFailed = true;
    if (res.ResponseCode == '050' || res.ResponseCode == '086') {
      this.prePayStatus = '';
      this.payStatus = 'Declined!';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '107') {
      this.prePayStatus = '';
      this.payStatus = '$ LIMIT EXCEEDED';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '903') {
      this.prePayStatus = '';
      this.payStatus = 'CARD CANCELLED';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '10') {
      this.prePayStatus = '';
      this.payStatus = 'Declined by host or by card';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '11') {
      this.prePayStatus = '';
      this.payStatus = 'Communication Error';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '12') {
      this.prePayStatus = '';
      this.payStatus = 'USER ABORTED';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '13') {
      this.prePayStatus = '';
      this.payStatus = 'TIME OUT';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '14') {
      this.prePayStatus = '';
      this.payStatus = 'Transaction/Function Not Completed';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '16') {
      this.prePayStatus = '';
      this.payStatus = 'Declined by Merchant';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '405') {
      this.prePayStatus = '';
      this.payStatus = 'Card Verification Decline';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '18') {
      this.prePayStatus = '';
      this.payStatus = 'Transaction Already Voided';
      this.paymentSuccessFul = false;
    } else if (res.ResponseCode == '95') {
      this.toastr.warning('Device is not ready to Accept any Payment. Please ensure Device is Idle and ready to Accept New Payment Request.', 'Alert', this.toasterConfig);
      this.prePayStatus = 'Payment';
      this.payStatus = 'Failed';
      this.paymentSuccessFul = false;
    } else if (res.Reason == "EMV Device Not Connected!") {
      this.prePayStatus = 'Payment';
      this.payStatus = 'Failed';
      this.paymentFailReason = 'EMV Device Not Connected';
      this.paymentSuccessFul = false;
    } else {
      if (res.Reason == 'Device is Busy, Please try after sometime.') { // Triggering multiple transactions
        this.toastr.warning('Device is not ready to Accept Payment, Please try after sometime.', 'Alert', this.toasterConfig);
      }
      this.paymentFailReason = 'Declined!';
      this.prePayStatus = 'Payment';
      this.payStatus = 'Failed';
      this.paymentSuccessFul = false;
    }
    if (res.ResponseCode != '000') {
      const CCModel = {
        Amount: amount,
        Autopay: false,
        PaymentModeId: EPaymentModes.CreditCard,
        AutoCcProcessingDay: 0,
        CreditCardNumber: !res && res.CreditCardNumber == undefined ? 0 : res.CreditCardNumber,
        CreditCardType: res && res.CreditCardType ? res.CreditCardType : ECreditCards.Visa,
        NameonCard: res.NameonCard ? res.NameonCard : " ",
        CreditCardExpiryMonth: res && res.CreditCardExpiryMonth == 264 && res.CreditCardExpiryYear != 0 ? this.getExpiryMonthValue(parseInt(res.CreditCardExpiryMonth, 10)) : 275,
        CreditCardExpiryYear: (res == null || !parseInt(res.CreditCardExpiryYear, 10)) ? 2099 : parseInt(res.CreditCardExpiryYear, 10),
        CreditCardBillingAddress: '',
        CreditCardBillingZip: '',
        SwipeTransaction: false,
        SecurityCodeSent: false,
        AuthorizationCode: res && res.AuthorizationCode ? res.AuthorizationCode : " ",
        ResponseCode: res && res.ResponseCode ? res.ResponseCode : "",
        Reason: res && res.Reason ? res.Reason : "DECLINED!",
        Key: '',
        PaymentAccountid: '',
        CcInfoPurged: false,
        DebitCardPayment: res && res.DebitCardPayment ? true : false,
        OfflinePayment: 0,
        PaymentTransactionTypeId: paymentTrnsId,
        TransactionDateTime: new Date(),
        TransactionTypeId: EPaymentTransactionType.Declined,
        OrderId: cctId,
        CCBatchNumber: res && res.CCBatchNumber ? res.CCBatchNumber : null,
        FacilityId: this.processRefund.facId,
        EmvReceiptText: null,
        TerminalDeviceId: this.selectedDeviceId ? this.selectedDeviceId : null,
        TenantId: this.processRefund.TenantId ? this.processRefund.TenantId : null,
        LeaseNo: this.processRefund.LeaseNo ? this.processRefund.LeaseNo : null
      };
      this.paymentService.saveCCTransaction(Object.assign(CCModel)).subscribe((res: any) => { });
    }
    this.loaderIcon = Promise.resolve(false);
    if (transactionType == "REFUND") {
      this.gotoPaymentSuccess(this.aftePay, 0);
    } else {
      this.isCancel.emit(true);
    }
  }

  callOpenEdgeTerminal(amount, payId, orderId, paymentTrnsId, uniqueTransId) {
    if (!this.credentials.RCMURL) {
      this.toastr.warning('Please ask Administrator to configure RCM URL', 'URL required', this.toasterConfig);
      this.loaderIcon = Promise.resolve(false);
    } else {
      if (this.subOpenEdgeEMV != null) {
        this.subOpenEdgeEMV.unsubscribe();
        this.subOpenEdgeEMV = null;
      }
      let disablePinpad=this.credentials?.DISABLEPINPAD ?? false;
      this.initiatedVoidCC = true;
      this.refundInProgress = true;
      const requestParam = "<REQUEST>" +
        "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
        "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
        "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" + "<DISABLEDEVICEMANUALENTRY>"+disablePinpad+"</DISABLEDEVICEMANUALENTRY>"+
        "<TRANSACTIONTYPE>CREDITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + uniqueTransId + "</ORDERID><OTK>" + uniqueTransId + "</OTK><ALLOWDUPLICATES/><CLERK></CLERK> <RECEIPTCOPYLABEL>MERCHANT_COPY</RECEIPTCOPYLABEL><TITLE>SSM 6.0</TITLE><CREATEALIAS>FALSE</CREATEALIAS></REQUEST>"
      this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
        if (res) {
          const resultFromRCM = res;
          const responseData = JSON.parse(resultFromRCM.RcmResponse);
          if (responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Success) {
            this.payStatus = 'Success';
            this.paymentSuccessFul = true;
            this.refundTable.find(o => o.payId == payId)['processedCC'] = responseData.RESPONSE;
            this.refundTable.find(o => o.payId === payId).payComplete = true;
            this.gotoPaymentSuccess(this.aftePay, amount);
            this.loaderIcon = Promise.resolve(false);
            this.initiatedVoidCC = false;
          } else {
            this.isOpenEdgeEMVCompleted = false;
            this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = false;
            this.RCMStatusResponse.SessionId = '';
            this.RCMStatusResponse.SessionState = -1;
            this.amountToPay = amount;
            this.isTDEmv.isTransactionWaitTime = true;
            this.loaderIcon = Promise.resolve(true);
            const requestParam = "<REQUEST> " + "<XWEBID>" + this.credentials.XWEBID + "</XWEBID>" +
              "<XWEBTERMINALID>" + this.credentials.XWEBTERMINALID + "</XWEBTERMINALID>" +
              "<XWEBAUTHKEY>" + this.credentials.XWEBAUTHKEY + "</XWEBAUTHKEY>" +
              "<TRANSACTIONTYPE>DEBITRETURN</TRANSACTIONTYPE><AMOUNT>" + amount + "</AMOUNT><ORDERID>" + uniqueTransId + "</ORDERID><OTK>" + uniqueTransId + "</OTK></REQUEST>";
            const rcmRefundRequest = this.paymentService.getRCMService(this.credentials.RCMURL, requestParam).subscribe((res: any) => {
              const responseData = JSON.parse(res.RcmResponse);
              if (responseData.RESPONSE && responseData.RESPONSE.RESULT == EEdgeExpressResultCode.Fail) {
                this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
                this.refundTable.find(o => o.payId == payId).payFailed = true;
                this.isOpenEdgeEMVCompleted = true;
                let reposnseMessage = responseData.RESPONSE && responseData.RESPONSE.RESULTMSG ? responseData.RESPONSE.RESULTMSG : 'No Response';
                this.saveCCTransactionFailureCase(null, reposnseMessage, paymentTrnsId);
              }
            });
            setTimeout(() => {
              rcmRefundRequest.unsubscribe();
              this.CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId);
            }, 5000);
            setTimeout(() => {
              if (!this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted && this.refundTable.find(o => o.payId == payId).orderId == orderId) {
                this.isTDEmv.isTransactionWaitTime = false;
                this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
                this.paymentService.GetCreditCardTransactionById(uniqueTransId).subscribe((cctResponse: any) => {
                  let res = JSON.parse(cctResponse);
                  if (res.Reason == "Attempting to Process") {
                    this.paymentService.getCNPResponse(this.credentials, orderId).subscribe((res: any) => {
                      const jsonResp = JSON.parse(res);
                      if (jsonResp.RESULT) {
                        this.loaderIcon = Promise.resolve(false);
                        this.gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId);
                      }
                    }, err => {
                      this.saveCCTransactionFailureCase(null, "NO Response", paymentTrnsId);
                      this.loaderIcon = Promise.resolve(false);
                    });
                  } else {
                    this.paymentFailReason = "Please Contact Administrator to check in Gateway Portal if Refund is Approved. If Yes, key in the Refund as Manual Authorization";
                    this.loaderIcon = Promise.resolve(false);
                  }
                  this.cancelRCMPaymetRequest(orderId);
                }, err => {
                  this.loaderIcon = Promise.resolve(false);
                  this.saveCCTransactionFailureCase(null, "NO Response", paymentTrnsId);
                });
              }
            }, 10000 * 6 * this.paymentMaxWaitTime);
          }
        }
      }, err => {
        this.saveCCTransactionFailureCase(null, "NO Response", paymentTrnsId);
      });
    }
  }

  CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId) {
    if (!this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted) {
      const startTime = Date.now();
      this.paymentService.getCNPResponse(this.credentials, uniqueTransId).subscribe((res: any) => {
        const jsonResp = JSON.parse(res);
        const elapsedTime = Date.now() - startTime;
        const waitTime = Math.max(1000 - elapsedTime, 0);
        if (jsonResp?.RESULT && (jsonResp.RESULT?.STATE != 'IN_PROGRESS' && jsonResp.RESULT?.TRANSACTIONTYPE != 'CREDITRETURN' && (jsonResp.RESULT?.RESPONSECODE == EOpenEdgeResponseCode.Approval || jsonResp.RESULT?.RESPONSECODE != EOpenEdgeResponseCode.TransactionDoesNotExist))) {
          this.cctStatusOrderId = jsonResp.RESULT.ORDERID ? jsonResp.RESULT.ORDERID : uniqueTransId;
          this.isOpenEdgeEMVCompleted = true;
          this.loaderIcon = Promise.resolve(false);
          this.refundTable.find(o => o.payId == payId).isOpenEdgePaymentCompleted = true;
          this.gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId);
        } else {
          setTimeout(() => {
            this.CNPResponse(orderId, payId, paymentTrnsId, uniqueTransId);
          }, waitTime);
        }
      }, err => {
        this.cancelRCMPaymetRequest(uniqueTransId);
        this.isOpenEdgeEMVCompleted = true;
        this.loaderIcon = Promise.resolve(false);
        if (this.subOpenEdgeEMV != null) {
          this.subOpenEdgeEMV.unsubscribe();
          this.subOpenEdgeEMV = null;
        }
        this.refundTable.find(o => o.payId == payId).payFailed = true;
        this.saveCCTransactionFailureCase(null, "Gateway Rejected - No response received!", paymentTrnsId);
      });
    }
  }

  gotoCNPResponse(jsonResp, orderId, payId, paymentTrnsId) {
    if ((jsonResp?.RESULT?.RESPONSECODE == EOpenEdgeResponseCode.Approval && jsonResp?.RESULT?.STATE != 'IN_PROGRESS') || (jsonResp?.RESULT?.RESPONSECODE == "-1" && jsonResp?.RESULT?.STATE == "CAPTURED" && jsonResp?.RESULT?.APPROVALCODE)) {
      this.isTDEmv.isTransactionWaitTime = false;
      this.payStatus = 'Success';
      this.paymentSuccessFul = true;
      this.refundTable.find(o => o.payId == payId).payFailed = false;
      jsonResp.RESULT['OrderId'] = orderId;
      if (jsonResp.RESULT?.CARDHOLDERNAME == undefined) {
        jsonResp.RESULT['CARDHOLDERNAME'] = jsonResp.RESULT.CARDBRAND != 'Unknown' ? jsonResp.RESULT.CARDBRAND : '';
      }
      jsonResp.RESULT['ACCOUNT'] = jsonResp.RESULT.MASKEDCARDNUMBER;
      jsonResp.RESULT['HOSTRESPONSECODE'] = jsonResp.RESULT.RESPONSECODE;
      jsonResp.RESULT['HOSTRESPONSEDESCRIPTION'] = jsonResp.RESULT?.ORIGINALRESPONSEDESCRIPTION ?? jsonResp?.RESULT?.STATE;
      this.refundTable.find(o => o.payId == payId)['processedCC'] = jsonResp.RESULT;
      this.loaderIcon = Promise.resolve(false);
      this.gotoPaymentSuccess(this.aftePay, parseFloat(jsonResp.RESULT.APPROVEDAMOUNT).toFixed(2));
    } else {
      this.isTDEmv.isTransactionWaitTime = false;
      this.refundTable.find(o => o.payId == payId).payFailed = true;
      if (jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION) {
        jsonResp.RESULT.RESPONSEDESCRIPTION = this.paymentFailReason == 'RCM Not Running! - Transaction Not found' ? 'Device Not Connected! - Transaction Not found' : jsonResp.RESULT.RESPONSEDESCRIPTION;
      }
      this.saveCCTransactionFailureCase(jsonResp, jsonResp && jsonResp.RESULT && jsonResp.RESULT.RESPONSEDESCRIPTION ? jsonResp.RESULT.RESPONSEDESCRIPTION : "Transaction Cancelled", paymentTrnsId);
    }
  }

  displayApprovalPopupMerchReturn() {
    this.refundLimitref = this.modalService.show(this.RefundLimitModal,
      { class: 'modal-dialog-centered', backdrop: 'static', keyboard: false });
  }

  cancelRCMPaymetRequest(orderId) {
    this.paymentService.getRCMServiceStatus(null, orderId, false).subscribe((sessionRes: any) => {
      if (sessionRes && sessionRes.SessionState != EOpenEdgeSessionStates.Completed) {
        this.paymentService.getRCMServiceStatus(sessionRes.SessionId, 0, true).subscribe((respose: any) => { }, err => { });
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
  }

  callStripeRefund(orderId, paymentTrnsId) {
    setTimeout(() => {
      this.addJsToElement('https://js.stripe.com/v3/').onload = () => {
        this.stripeScript(orderId, paymentTrnsId);
      }
    }, 1000);
  }

  stripeScript(orderId, paymentTrnsId) {
    this.stripe = Stripe(this.stripePublishableKey, { stripeAccount: this.StripeUnifiedAccountId });
    this.modalRefStripeRefund = this.modalService.show(this.StripeRefund, { class: 'modal-medium modal-dialog-centered', backdrop: 'static', keyboard: false });

    const elements = this.stripe.elements();
    this.element = elements;
    this.cardElement = elements.create('card', {
      hidePostalCode: true
    });
    this.cardElement.mount('#card-element');
    const address = this.gatewayService.mountAddressElements(elements, this.enableAddressAutofill, this.mandatoryFieldsList);
    
    setTimeout(() => {
      this.addressElement = elements.create('address', address);
      this.addressElement.mount('#address-element');
      this.loaderIcon = Promise.resolve(false);
    }, 500);

    const form = document.querySelector("#payment-form");
    form.addEventListener('submit', (event) => this.createPayment(orderId, paymentTrnsId, this.addressElement));
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    this.renderer.appendChild(document.body, script);
    return script;
  }

  onStripePay() {
    const submitButton = document.getElementById("submit") as HTMLButtonElement;
    if (submitButton) {
      submitButton.click();
    }
  }

  async createPayment(orderId, paymentTrnsId, addressElement) {
    this.loaderIcon = Promise.resolve(true);
    try {
      const addressResult = await addressElement?.getValue() ?? '';
      const { paymentMethod, error } = await this.stripe.createPaymentMethod(
        {
          type: 'card',
          card: this.cardElement,
          billing_details: {
            name: addressResult?.value?.name ?? '',
            phone:  addressResult?.value?.phone ?? '',
            address: {
                line1: addressResult?.value?.address?.line1 ?? '',
                line2: addressResult?.value?.address?.line2 ?? '',
                city: addressResult?.value?.address?.city ?? '',
                state: addressResult?.value?.address?.state?? '',
                postal_code: addressResult?.value?.address?.postal_code ?? '',
                country: addressResult?.value?.address?.country ?? '',
            }
        }
        });
      if (paymentMethod && paymentMethod.id) {
        this.modalRefStripeRefund.hide();
        const obj = {
          FacilityId: this.processRefund.facId,
          Amount: this.amountToPay * 100,
          OrderId: orderId,
          TenantId: this.processRefund.TenantId,
          PaymentMethodId: paymentMethod.id,
          Name: this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName,
          Email: this.customerInfo.Email,
          Phone: this.customerInfo.CellPhoneNumber
        }
        this.paymentService.callProcessRefund(obj).subscribe((stripeRes: any) => {
          if (stripeRes?.Success) {
            const obj = {
              PaymentTrnsId : paymentTrnsId,
              TransactionTypeId : EPaymentTransactionType.Reversal_Refund,
              ProcessRefund : this.processRefund,
              OrderId : orderId,
              RequestGatewayDetails : this.requestGatewayDetails,
              PaymentMode : EPaymentModes.HostedPage
            }
            stripeRes['CreditHolderName'] = stripeRes?.BillingDetails?.Name ?? '' ;
            let gatewayResponse = this.gatewayService.mapStripeGatewayResponse(stripeRes, obj);
            this.paymentSuccessFul = true;
            this.payStatus = 'Success';
            this.refundTable.find(o => o.payId == this.currentPayId)['processedStripeCC'] = gatewayResponse;
            this.gotoPaymentSuccess(this.aftePay, gatewayResponse.Amount);
            this.loaderIcon = Promise.resolve(false);
          } else {
            this.paymentSuccessFul = false;
            this.payStatus = 'Failed';
            this.retryTransactionStatusLoader = false;
            this.isAnyRefundProcessed();
            this.paymentFailReason = stripeRes.Reason ? stripeRes.Reason : "Declined!";
            this.loaderIcon = Promise.resolve(false);
            const cctModel = this.saveCCTFailModelStripe(stripeRes, this.processRefund);
            this.gotoPaymentSuccess(this.aftePay, 0);
            this.paymentService.saveCCTransaction(Object.assign(cctModel)).subscribe((res: any) => { });
          }
        }, err => {
          this.loaderIcon = Promise.resolve(false);
          const stripeRes = {
            Reason: err?.error?.message ?? err.statusText,
            OrderId: orderId,
            Amount: this.amountToPay,
            PaymentTrnsId: paymentTrnsId
          }
          this.paymentSuccessFul = false;
          this.payStatus = 'Failed';
          this.retryTransactionStatusLoader = false;
          this.isAnyRefundProcessed();
          const cctModel = this.saveCCTFailModelStripe(stripeRes, this.processRefund);
          this.gotoPaymentSuccess(this.aftePay, 0);
          this.paymentService.saveCCTransaction(Object.assign(cctModel)).subscribe((res: any) => { });
        });
      } else {
        if (error) {
          if (error.code === 'incomplete_number') {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.warning('Card number is required or incomplete.', 'Card Number Required', this.toasterConfig);
          } else if (error.code === 'incomplete_cvc') {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.warning('CVV is required or incomplete.', 'CVV Required', this.toasterConfig);
          } else if (error.code === 'incomplete_expiry') {
            this.loaderIcon = Promise.resolve(false);
            this.toastr.warning('Expiry date is incomplete.', 'Expiry date Required', this.toasterConfig);
          } else {
            this.modalRefStripeRefund.hide();
            const stripeRes = {
              Reason: error.message,
              OrderId: orderId,
              Amount: this.amountToPay,
              PaymentTrnsId: paymentTrnsId
            }
            this.paymentSuccessFul = false;
            this.payStatus = 'Failed';
            this.retryTransactionStatusLoader = false;
            this.isAnyRefundProcessed();
            const cctModel = this.saveCCTFailModelStripe(stripeRes, this.processRefund);
            this.gotoPaymentSuccess(this.aftePay, 0);
            this.loaderIcon = Promise.resolve(false);
            this.paymentService.saveCCTransaction(Object.assign(cctModel)).subscribe((res: any) => { });
          }
        }
      }
    }
    catch (error) {
      console.log('error', error ? error : "Exeception");
      return null;
    }
  }

  onClickStripeAutoPopulateBillingInfo(checked) {
    let addressElement = this.element.getElement('address');
    if (checked) {
      if (this.customerInfo) {
        console.log('customer info', this.customerInfo);
        if (addressElement) {
          addressElement.unmount();
          addressElement.destroy(); // Destroy the previous element
        }

        setTimeout(() => {
          const addressElementOptions = this.gatewayService.getAddressElementOptions(false, this.customerInfo);
          this.addressElement = this.element.create('address', addressElementOptions);
          this.addressElement.mount('#address-element');
        }, 500);
      }
    } else {
      if (addressElement) {
        addressElement.clear();
        addressElement.unmount();
        addressElement.destroy(); // Destroy the previous element

        const addressContainer = document.querySelector('#address-element');
        if (addressContainer) {
          addressContainer.remove();
        }
        // Create a new container for the Address Element
        const newContainer = document.createElement('div');
        newContainer.id = 'address-element';
        document.getElementById('payment-form').appendChild(newContainer);
        setTimeout(() => {
          const addressElementOptions = this.gatewayService.getAddressElementOptions(true, this.customerInfo);
          this.addressElement = this.element.create('address', addressElementOptions);
          this.addressElement.mount('#address-element');
          this.clearFields();
        }, 500);
      }
    }
  }

  clearFields() {
    const formElement = document.querySelector('#address-element');
    if (formElement) {
      const inputs = formElement.querySelectorAll('input');
      inputs.forEach(input => input.value = '');
    }
  }

  closeStripeForm() {
    this.modalRefStripeRefund.hide();
  }

  callStripeCofRefund(cctId, orderId, paymentTrnsId, amount) {
    const obj = {
      FacilityId: this.processRefund.facId,
      TenantId: this.processRefund.TenantId,
      OrderId: orderId,
      PaymentMethodId: this.autoPayInfo.PaymentAccountId,
      Name: this.customerInfo.FirstName + this.customerInfo.MiddleName + this.customerInfo.LastName,
      Email: this.customerInfo.Email,
      Phone: this.customerInfo.CellPhoneNumber,
      Amount: amount * 100,
    }

    this.paymentService.callProcessRefund(obj).subscribe((stripeRes: any) => {
      if (stripeRes?.Success) {
      const obj = {
        PaymentTrnsId : paymentTrnsId,
        TransactionTypeId : EPaymentTransactionType.Reversal_Refund,
        ProcessRefund : this.processRefund,
        OrderId : cctId,
        RequestGatewayDetails : this.requestGatewayDetails,
        PaymentMode : EPaymentModes.CardOnfile
      }
        stripeRes['CreditHolderName'] = stripeRes?.BillingDetails?.Name ?? '';
        let gatewayResponse = this.gatewayService.mapStripeGatewayResponse(stripeRes, obj);
        this.paymentSuccessFul = true;
        this.payStatus = 'Success';
        this.refundTable.find(o => o.payId == this.currentPayId)['processedStripeCC'] = gatewayResponse;
        this.gotoPaymentSuccess(this.aftePay, gatewayResponse.Amount);
        this.loaderIcon = Promise.resolve(false);
      } else {
        this.paymentSuccessFul = false;
        this.payStatus = 'Failed';
        this.retryTransactionStatusLoader = false;
        this.isAnyRefundProcessed();
        this.paymentFailReason = stripeRes.Reason ? stripeRes.Reason : "Declined!";
        this.loaderIcon = Promise.resolve(false);
        stripeRes.OrderId = cctId;
        const cctModel = this.saveCCTFailModelStripe(stripeRes, this.processRefund);
        this.gotoPaymentSuccess(this.aftePay, 0);
        this.paymentService.saveCCTransaction(Object.assign(cctModel)).subscribe((res: any) => { });
      }
    }, err => {
      const stripeRes = {
        Reason: err?.error?.message ?? 'Declined!',
        OrderId: orderId,
        Amount: this.amountToPay,
        PaymentTrnsId: paymentTrnsId
      }
      this.paymentSuccessFul = false;
      this.payStatus = 'Failed';
      this.retryTransactionStatusLoader = false;
      this.isAnyRefundProcessed();
      const cctModel = this.saveCCTFailModelStripe(stripeRes, this.processRefund);
      this.gotoPaymentSuccess(this.aftePay, 0);
      this.loaderIcon = Promise.resolve(false);
      this.paymentService.saveCCTransaction(Object.assign(cctModel)).subscribe((res: any) => { });
    });
  }

  setMandatoryFieldforCheckpayment(formId: number) {
    this.generalService.GetMandatoryFieldsById(this.userSessionService.userSessionData.LastAccessedStoreId, formId)
      .subscribe((response: IGetPermissionMandatoryField) => {
        this.mandateFieldsforCheckpayment = response;
        this.amountFieldforcheck = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'Amount').Required;
        this.checknumberField = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkNo').Required;
        this.checkdatefield = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkDate').Required;
        this.checkbankname = this.mandateFieldsforCheckpayment.Form.ListOfProperties.find(o => o.Name == 'checkBank').Required;
      });
  }
}
